var _rect, _g, _rect2, _text, _rect3, _g2, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _polygon, _path7, _polygon2, _polygon3, _path8, _path9, _polygon4, _path10, _polygon5, _path11, _polygon6, _g3, _ellipse2, _ellipse3, _path12, _path13, _path14, _path15, _path16, _polygon7, _polygon8, _polygon9, _path17, _path18, _path19, _path20, _path21, _polyline, _path22, _line, _path23, _path24, _path25, _path26, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon10, _path37, _path38, _path39, _g12, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _ellipse4, _polygon11, _path58, _polygon12, _polygon13, _path59, _path60, _polygon14, _path61, _polygon15, _path62, _polygon16, _g13, _ellipse5, _ellipse6, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _polygon17, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g14, _path104, _path105, _path106, _path107, _path108, _g15, _path109, _path110, _path111, _path112, _path113, _ellipse7, _path114, _path115, _path116, _path117, _path118, _g16, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g17, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _polygon18, _path155, _path156, _path157, _path158, _path159, _path160, _g18, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _polygon19, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _polygon20, _polygon21, _path179, _path180, _path181, _path182, _path183, _path184, _g19, _g20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 720",
    enableBackground: "new 0 0 2048 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "story-header-bg"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    width: 2048,
    height: 720
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 779.51,
    y: 160,
    fill: "#659896",
    width: 270,
    height: 560
  }), /*#__PURE__*/React.createElement("g", {
    id: "scribble_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M452.4,406.59l-1.71,0.15l-0.86,0.08l-0.44,0.05c-0.08,0.01-2.66,0.15-2.76,0.16l0.17,0.6l0.03,0.95 c0.08-0.02,2.6-0.51,2.76-0.53l0.41-0.08l0.84-0.16l1.68-0.3l3.37-0.58l6.75-1.13l-6.83,0.52L452.4,406.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M319.61,379.43c-0.17,0.62-0.39,1.28-0.63,1.82l-0.05,0.11l-0.02,0.08c-0.59,2.19-1.38,4.42-2.19,6.61 c-0.83,2.18-1.72,4.35-2.73,6.43c-0.51,1.04-1.04,2.03-1.68,2.96c-0.64,0.94-1.33,1.79-2.15,2.43c-1.62,1.3-3.91,1.61-6.21,1.68 l-14.25,0.15l-3.57,0.03l-0.45,0c-0.12-0.01-0.2-0.02-0.3-0.03c-0.1-0.02-0.2-0.07-0.3-0.09c-0.1-0.04-0.2-0.11-0.31-0.16 c-0.41-0.25-0.81-0.61-1.18-1.02c-1.45-1.69-2.51-3.82-3.57-5.91l-0.18-0.36l-0.39,0.02c-1.09,0.07-2.14,0.19-3.21,0.41 c-0.27,0.05-0.53,0.12-0.8,0.2c-0.06,0.01-0.15,0.05-0.25,0.08c-0.1,0.03-0.17,0.08-0.25,0.13c-0.15,0.1-0.28,0.2-0.4,0.31 c-0.45,0.43-0.75,0.87-1.06,1.3c-0.6,0.86-1.17,1.7-1.85,2.42c-0.67,0.72-1.46,1.32-2.35,1.66c-0.45,0.17-0.92,0.27-1.4,0.31 l-0.36,0.02l-0.39,0l-0.78,0.01c-1.05,0.01-2.09,0.01-3.13-0.02c-2.08-0.05-4.16-0.17-6.2-0.52c-1.02-0.17-2.03-0.4-2.99-0.73 c-0.96-0.33-1.92-0.74-2.73-1.32c-0.81-0.58-1.48-1.36-1.97-2.24c-0.49-0.88-0.82-1.85-1.06-2.85c-0.24-1-0.39-2.02-0.52-3.05 l-0.42-3.09c-0.24-2.05-0.38-4.13-0.45-6.2l-0.01-0.21l-0.18,0.11c-0.89,0.56-1.8,1.1-2.72,1.61c-0.93,0.5-1.86,1.01-2.86,1.32 c-0.49,0.16-1.03,0.09-1.56,0.09c-0.53-0.01-1.06-0.05-1.58-0.11c-1.05-0.12-2-0.26-3.08-0.7c0.98,0.4,2.03,0.62,3.07,0.76 c0.53,0.06,1.05,0.12,1.58,0.14c0.26,0.02,0.53,0.02,0.8,0.03c0.26,0.02,0.55-0.02,0.8-0.09c1.03-0.3,1.97-0.79,2.92-1.28 c0.88-0.46,1.73-0.95,2.58-1.46c0.03,2.01,0.13,4.02,0.33,6.03l0.36,3.1c0.11,1.03,0.24,2.07,0.47,3.1 c0.23,1.03,0.55,2.05,1.06,3c0.5,0.95,1.21,1.81,2.08,2.46c0.88,0.65,1.87,1.09,2.87,1.46c1.01,0.36,2.04,0.62,3.08,0.82 c2.09,0.4,4.2,0.56,6.3,0.65c1.05,0.04,2.1,0.07,3.15,0.08l0.79,0.01l0.39,0l0.42-0.01c0.56-0.03,1.13-0.14,1.67-0.33 c1.08-0.38,2.01-1.07,2.77-1.86c0.76-0.79,1.38-1.67,1.99-2.5c0.3-0.41,0.61-0.82,0.93-1.11c0.08-0.07,0.16-0.13,0.23-0.17 c0.03-0.01,0.07-0.04,0.1-0.05c0.02-0.01,0.05-0.02,0.12-0.04c0.24-0.06,0.48-0.12,0.73-0.16c0.86-0.16,1.75-0.26,2.63-0.31 c0.97,2.02,1.95,4.06,3.46,5.9c0.42,0.48,0.88,0.94,1.48,1.32c0.16,0.09,0.31,0.18,0.48,0.25c0.18,0.06,0.36,0.13,0.55,0.18 c0.19,0.03,0.41,0.06,0.59,0.07l0.45,0l3.57,0.03l14.29,0.13c1.22-0.02,2.47-0.09,3.72-0.35c1.25-0.25,2.54-0.78,3.6-1.58 c1.07-0.81,1.9-1.81,2.6-2.81c0.73-1.01,1.33-2.1,1.88-3.17c1.1-2.15,2.04-4.34,2.93-6.56c0.86-2.19,1.69-4.37,2.37-6.69 c0.32-0.71,0.54-1.36,0.76-2.06c0.21-0.72,0.39-1.46,0.49-2.23c0.1-0.77,0.15-1.56,0.06-2.38c-0.01-0.09-0.03-0.18-0.04-0.26 l0.58-0.11l1.32-0.25l5.3-1c3.53-0.66,7.07-1.3,10.61-1.92c7.07-1.27,14.16-2.47,21.26-3.57l5.33-0.8 c1.63-0.26,3.26-0.46,4.95-0.79l-0.01,0.08c4.36,0.31,8.74,0.66,13.06,1.16c0.54,0.06,1.08,0.13,1.61,0.2l0.8,0.12l0.4,0.06 l0.35,0.07c0.93,0.2,1.83,0.59,2.66,1.13c0.83,0.54,1.58,1.22,2.26,1.99c0.49,0.55,0.95,1.17,1.34,1.79 c-4.69,3.16-9.54,6.17-14.53,8.84c-1.31,0.7-2.65,1.37-3.98,1.99c-1.33,0.6-2.72,1.08-4.14,1.48c-2.84,0.8-5.79,1.29-8.75,1.63 c-2.96,0.33-5.95,0.49-8.94,0.51c-2.99,0.01-5.98-0.09-8.94-0.47c-2.95-0.35-5.77-1.39-8.47-2.65c-1.35-0.64-2.67-1.33-3.97-2.08 c-0.65-0.37-1.29-0.76-1.93-1.15l-0.96-0.59c-0.3-0.17-0.56-0.36-0.89-0.52l2.88-5.51l-3.11,5.51l-0.05,0.09l0.11,0.06 c0.62,0.33,1.25,0.79,1.88,1.18c0.63,0.41,1.27,0.81,1.91,1.19c1.28,0.78,2.6,1.51,3.94,2.18c2.69,1.33,5.55,2.46,8.57,2.89 c2.99,0.45,6.01,0.62,9.02,0.68c3.02,0.05,6.04-0.05,9.05-0.31c3.01-0.27,6.02-0.7,8.97-1.46c1.48-0.38,2.94-0.85,4.36-1.45 c1.4-0.61,2.76-1.26,4.11-1.93c5.39-2.73,10.56-5.79,15.63-9.07l0.68-0.44l-0.36-0.73c-0.28-0.57-0.57-1.04-0.9-1.53 c-0.32-0.48-0.67-0.95-1.05-1.39c-0.75-0.89-1.61-1.71-2.6-2.4c-0.99-0.68-2.12-1.22-3.33-1.5l-0.45-0.1l-0.41-0.07l-0.83-0.14 c-0.55-0.09-1.1-0.17-1.65-0.25c-2.44-0.34-4.88-0.62-7.32-0.89l4.81-1.7c3.4-1.19,6.76-2.46,10.15-3.53 c3.4-1.07,6.86-2.01,10.34-2.87c6.95-1.74,14.01-3.1,21.06-4.54c3.53-0.72,7.06-1.42,10.56-2.32c1.75-0.45,3.49-0.93,5.19-1.53 c0.85-0.31,1.7-0.62,2.51-1c0.41-0.19,0.81-0.39,1.21-0.61c0.38-0.23,0.78-0.46,1.08-0.8c-0.31,0.32-0.72,0.53-1.11,0.74 c-0.4,0.2-0.81,0.38-1.23,0.54c-0.83,0.33-1.69,0.59-2.55,0.85c-1.72,0.49-3.47,0.91-5.23,1.27c-3.51,0.72-7.07,1.28-10.61,1.87 c-7.1,1.15-14.21,2.34-21.27,3.88c-3.52,0.79-7.04,1.66-10.51,2.68c-3.49,1.02-6.89,2.2-10.29,3.36l-5.1,1.73 c-1.59,0.52-3.17,1.04-4.74,1.39c-0.03,0-0.06-0.01-0.09-0.01l0,0.03c-0.07,0.02-0.14,0.04-0.21,0.05 c-1.67,0.33-3.48,0.52-5.26,0.78c-1.79,0.23-3.57,0.51-5.35,0.77c-7.13,1.07-14.24,2.25-21.33,3.49 c-3.54,0.64-7.09,1.29-10.62,1.97l-5.3,1.02l-1.33,0.26l-0.66,0.13l-0.24,0.05l-0.18-0.29c-0.27-0.41-0.57-0.81-0.89-1.19 c-0.65-0.76-1.41-1.47-2.35-2.01c-0.47-0.27-0.99-0.48-1.54-0.63c-0.54-0.14-1.18-0.17-1.58-0.19c-1.81-0.07-3.61-0.12-5.41-0.16 c-3.61-0.08-7.21-0.12-10.83-0.1c-1.81,0.02-3.61,0.04-5.43,0.11c-1.81,0.08-3.61,0.14-5.48,0.39c-1.85,0.25-3.69,0.7-5.44,1.43 c-0.87,0.37-1.72,0.8-2.53,1.33c-0.4,0.27-0.79,0.55-1.17,0.87c-0.09,0.08-0.19,0.16-0.28,0.25l-0.18,0.18 c-0.03,0.03-0.08,0.05-0.13,0.05l-2.22-0.08l-0.06,0l-0.02,0c-0.12,0.01-0.24-0.05-0.29-0.15c-0.01,0.02-0.09-0.29-0.16-0.5 c-0.08-0.22-0.16-0.45-0.26-0.67c-0.39-0.87-1-1.76-1.98-2.28c-0.47-0.26-1.05-0.38-1.47-0.43c-0.45-0.06-0.89-0.1-1.32-0.14 c-0.87-0.07-1.74-0.12-2.6-0.16c-3.46-0.16-6.91-0.18-10.36-0.14c-0.86,0.02-1.73,0.03-2.6,0.07c-0.86,0.02-1.8,0.13-2.65,0.41 c-0.86,0.27-1.67,0.68-2.39,1.2c-0.36,0.26-0.71,0.54-1.03,0.84c-0.16,0.15-0.32,0.31-0.47,0.47c-0.17,0.18-0.26,0.3-0.4,0.37 c-0.3,0.15-0.65,0.13-0.96-0.1c-0.37-0.23-0.73-0.47-1.11-0.68c-0.74-0.44-1.52-0.83-2.31-1.18c-1.46-0.65-2.98-1.17-4.54-1.48 c0.22-0.29,0.45-0.58,0.7-0.85c1.65-1.72,3.68-3.1,5.79-4.26c2.12-1.16,4.36-2.12,6.64-2.98c4.55-1.73,9.26-3.06,14-4.24 c4.74-1.2,9.53-2.2,14.34-3.12c9.62-1.84,19.31-3.32,29.02-4.64c2.43-0.34,4.86-0.65,7.29-0.97l3.65-0.46l1.83-0.23 c0.65-0.09,1.3-0.2,1.95-0.37c1.29-0.32,2.54-0.8,3.71-1.41c1.16-0.62,2.24-1.35,3.25-2.13c1.01-0.78,1.94-1.6,2.86-2.42 l2.75-2.43c3.66-3.24,7.35-6.42,11.15-9.44c3.82-3.01,7.73-5.89,11.82-8.5c4.08-2.62,8.34-4.97,12.76-6.94 c2.2-0.99,4.48-1.84,6.77-2.61c2.3-0.78,4.64-1.46,6.99-2.08c4.71-1.24,9.51-2.21,14.33-3.04c4.82-0.82,9.68-1.45,14.55-2.01 c4.87-0.55,9.76-0.97,14.65-1.31c4.9-0.32,9.8-0.59,14.71-0.8c-9.82-0.05-19.66,0.27-29.47,1.04c-4.91,0.37-9.8,0.93-14.68,1.63 c-0.7,0.1-1.39,0.21-2.08,0.32c-1.18,0.14-2.37,0.29-3.55,0.46c-1.67,0.24-3.34,0.49-5,0.78c-1,0.16-1.99,0.33-2.98,0.52 c0.31-0.15,0.62-0.3,0.93-0.45l15.63-7.48l7.83-3.73c2.6-1.27,5.24-2.47,7.82-3.81c-5.57,1.67-11.05,3.61-16.43,5.79 c-5.4,2.13-10.7,4.52-15.93,7.03c-2.95,1.43-5.88,2.92-8.77,4.46c-2.63,0.59-5.26,1.19-7.88,1.84c-3.27,0.81-6.52,1.7-9.76,2.6 c-1.62,0.45-3.23,0.94-4.84,1.42c-1.61,0.48-3.22,0.97-4.83,1.48c-3.21,1.03-6.39,2.11-9.57,3.2c-3.16,1.16-6.32,2.31-9.44,3.57 c3.29-0.74,6.55-1.58,9.8-2.42l4.88-1.24l4.87-1.28c3.26-0.79,6.49-1.71,9.75-2.5c2.83-0.72,5.65-1.46,8.49-2.15 c-3.71,1.72-7.29,3.7-10.75,5.85c-4.2,2.62-8.23,5.48-12.1,8.53c-3.87,3.05-7.61,6.25-11.29,9.48 c-3.75,3.17-7.09,6.84-11.53,7.86c-0.55,0.14-1.11,0.24-1.67,0.32l-1.82,0.24l-3.66,0.47c-2.44,0.33-4.87,0.65-7.31,1 c-4.87,0.68-9.73,1.47-14.58,2.29c-4.85,0.83-9.69,1.71-14.51,2.74c-9.62,2.06-19.24,4.39-28.41,8.14 c-2.28,0.95-4.52,2.03-6.65,3.3c-2.13,1.28-4.15,2.77-5.81,4.65c-1.64,1.92-3.04,4.79-3.6,7.17c-0.54,2.4-1.03,7.08-0.04,7.55 c-0.04-2.43,0.19-5.64,0.84-7.97c0.54-1.95,1.37-3.85,2.59-5.44c1.54,0.39,3.02,0.99,4.43,1.71c0.76,0.39,1.5,0.82,2.21,1.28 c0.36,0.22,0.71,0.47,1.06,0.71c0.36,0.31,0.99,0.43,1.47,0.19c0.12-0.06,0.23-0.13,0.33-0.22l0.24-0.24 c0.15-0.15,0.3-0.29,0.46-0.42c0.32-0.27,0.65-0.52,1-0.74c0.69-0.45,1.46-0.79,2.25-1c0.8-0.22,1.59-0.29,2.45-0.28 c0.85-0.01,1.71,0,2.57,0.02c3.43,0.08,6.87,0.25,10.28,0.49c0.85,0.07,1.71,0.13,2.55,0.23c0.42,0.04,0.84,0.1,1.24,0.16 c0.43,0.07,0.7,0.14,0.98,0.3c0.55,0.31,0.97,0.9,1.25,1.59c0.07,0.17,0.13,0.35,0.19,0.53c0.07,0.19,0.05,0.31,0.22,0.72 c0.31,0.68,1.06,1.12,1.8,1.09l-0.08,0l2.28,0.15l0.03,0l0.05,0c0.39-0.01,0.78-0.14,1.11-0.39l0.54-0.47 c0.31-0.26,0.65-0.49,1-0.72c0.71-0.44,1.47-0.81,2.26-1.13c0.79-0.31,1.62-0.55,2.45-0.76c0.84-0.18,1.69-0.35,2.55-0.44 c1.7-0.19,3.51-0.22,5.29-0.26c1.79-0.03,3.58-0.03,5.37-0.02c3.58,0.03,7.17,0.11,10.76,0.24c1.79,0.07,3.59,0.14,5.37,0.23 c0.5,0.03,0.76,0.04,1.09,0.13c0.32,0.09,0.64,0.22,0.95,0.4c0.62,0.36,1.2,0.88,1.71,1.49c0.25,0.3,0.49,0.63,0.71,0.96 l0.15,0.24l-0.04,0.02c0.24,0.44,0.4,0.96,0.48,1.53c0.08,0.57,0.05,1.19-0.02,1.82C319.92,378.16,319.78,378.8,319.61,379.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M401.04,432.79c-0.22,8.04,1.38,15.66,4.51,21.46c3.24,6.02,7.74,9.4,12.68,9.54c0.1,0,0.2,0,0.3,0 c4.83,0,9.39-3.13,12.88-8.84c3.43-5.63,5.45-13.15,5.66-21.19c0.22-8.04-1.38-15.66-4.51-21.46c-3.24-6.02-7.74-9.4-12.68-9.54 c-4.94-0.13-9.62,3-13.18,8.84C403.27,417.23,401.25,424.75,401.04,432.79z M405.32,418.97l1.1,7.65l-2.08,0.11l1.88,1.3 l-3.29,5.68c0-0.29,0-0.58,0.01-0.87C403.08,427.89,403.91,423.15,405.32,418.97z M407.3,453.73c-0.06-0.11-0.12-0.23-0.18-0.35 l2.91,0.62l-0.65,2.22l1.49-1.16l1.62,5.05C410.57,458.67,408.8,456.52,407.3,453.73z M425.58,459.37l1.75-6.37l1.77,1.07 l-0.99-2.29l3.81-1.84C430.27,453.95,428.09,457.21,425.58,459.37z M432.84,424.93l0.57-5.63c0.96,3.29,1.54,6.89,1.71,10.66 l-2.06-3.74l1.51-1.08L432.84,424.93z M419.84,404.29c1.75,0.05,3.45,0.61,5.04,1.65l-4.29,3.61l-0.77-3.68l-0.79,3.82 l-4.93-3.65c1.76-1.14,3.61-1.74,5.49-1.74C419.68,404.28,419.76,404.29,419.84,404.29z M412.09,407.61l7.79,5.76l6.98-5.87 c1.44,1.37,2.78,3.15,3.95,5.32c0.23,0.42,0.44,0.85,0.65,1.29l-1.23,12.07l4.88,8.87c-0.22,4.23-0.95,8.22-2.06,11.76 l-0.07-0.14l-7.46,3.61l-3.06,11.11c-1.27,0.57-2.59,0.87-3.94,0.87c-0.08,0-0.16,0-0.25,0c-0.89-0.02-1.77-0.19-2.63-0.48 l-3.14-9.78l-6.65-1.43c-1.45-3.63-2.39-7.79-2.74-12.21l6.02-10.4l-1.94-13.48c0.39-0.79,0.81-1.55,1.25-2.27 C409.55,410.37,410.79,408.84,412.09,407.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M487.12,477.94l-8.66-0.89l-17.31-1.78c-11.11-1.1-22.22-2.18-33.33-3.23c4.54-0.81,9.07-1.6,13.6-2.46 c10.32-1.91,20.62-3.91,30.88-6.14c-10.43,1.22-20.82,2.69-31.2,4.24c-4.44,0.64-8.87,1.35-13.3,2.04 c2.43-1.91,4.68-4.52,6.66-7.78c4.42-7.24,7.04-16.88,7.43-27.2l2-0.73l-1.96-0.63c0.19-10.35-1.91-20.14-5.94-27.62 c-4.23-7.86-10.09-12.28-16.51-12.46c-0.39-0.01-0.78-0.01-1.17,0.02l0-0.08l-15.96,0.25c1.89-2.31,4.44-3.95,7.23-5.11 c2.89-1.2,6.03-1.89,9.19-2.4c1.59-0.2,3.18-0.45,4.79-0.55c0.8-0.07,1.61-0.14,2.41-0.2l1.17-0.04c0.39,0,0.77,0.03,1.16,0.04 c1.54,0.1,3.07,0.4,4.5,0.95c1.43,0.54,2.78,1.33,3.97,2.3c2.41,1.95,4.2,4.64,5.53,7.51c1.33,2.89,2.22,5.99,2.86,9.14 c0.32,1.58,0.6,3.17,0.79,4.77c0.19,1.6,0.33,3.21,0.42,4.82c0.19,3.22,0.18,6.47-0.04,9.69c-0.44,6.45-1.73,12.87-4.15,18.89 l-0.17,0.43l0.44-0.08l16.34-3.08l-15.99,2.52c2.48-5.9,3.89-12.22,4.49-18.6c0.3-3.26,0.39-6.55,0.28-9.82 c-0.04-1.64-0.18-3.28-0.34-4.91c-0.17-1.64-0.43-3.27-0.73-4.88c-0.61-3.23-1.48-6.45-2.83-9.5c-1.35-3.04-3.21-5.95-5.84-8.16 c-1.31-1.1-2.8-2-4.4-2.64c-1.6-0.64-3.3-1-5-1.14c-0.43-0.02-0.85-0.06-1.28-0.06l-1.27,0.02c-0.83,0.05-1.64,0.11-2.46,0.17 c-1.64,0.08-3.28,0.31-4.92,0.49c-3.27,0.48-6.55,1.14-9.7,2.39l-1.17,0.48c-0.39,0.17-0.76,0.39-1.14,0.58 c-0.37,0.2-0.76,0.39-1.13,0.61l-1.07,0.72l-0.54,0.36c-0.17,0.13-0.33,0.27-0.5,0.41l-0.99,0.83c-0.31,0.29-0.6,0.61-0.91,0.92 l-0.45,0.47c-0.15,0.16-0.27,0.33-0.41,0.5l-0.8,1.01c-0.25,0.35-0.48,0.71-0.71,1.06l-0.35,0.53c-0.11,0.18-0.21,0.36-0.32,0.55 l-0.63,1.1c-0.78,1.48-1.49,2.98-2.15,4.47l-0.5,1.12l-0.47,1.15c-0.33,0.77-0.61,1.54-0.89,2.31c-0.59,1.54-1.09,3.1-1.63,4.65 c-2.05,6.21-3.89,12.47-5.68,18.74c-1.7,5.99-3.35,11.98-4.94,18c-3.81,0.25-7.64,0.45-11.46,0.61 c-4.11,0.18-8.23,0.31-12.33,0.34c-2.05,0.02-4.1,0.01-6.14-0.06c-2.03-0.07-4.09-0.2-6.14-0.33c-4.1-0.28-8.21-0.62-12.32-0.96 c-16.44-1.38-32.87-2.97-49.31-4.44l-12.34-1.08c-4.12-0.36-8.22-0.68-12.31-1.14c-4.08-0.46-8.15-1.04-12.17-1.86 c-2-0.41-3.99-0.9-5.93-1.5c-1.94-0.6-3.85-1.32-5.58-2.3c-0.86-0.49-1.68-1.06-2.37-1.73c-0.69-0.67-1.26-1.44-1.54-2.32 c-0.15-0.44-0.24-0.89-0.25-1.36c-0.02-0.48-0.02-1.02-0.03-1.53l-0.04-3.1l-0.15-12.38l-0.15-12.38 c-0.05-2.06,0.04-4.11,0.42-6.14c0.38-2.02,0.96-4.02,1.93-5.84c-1.03,1.79-1.68,3.78-2.13,5.8c-0.45,2.02-0.61,4.11-0.62,6.18 l-0.15,12.38l-0.15,12.38l-0.04,3.1c0,0.52-0.02,1.01-0.01,1.56c0,0.56,0.1,1.13,0.27,1.68c0.33,1.1,1,2.05,1.77,2.83 c0.77,0.79,1.66,1.42,2.58,1.96c1.85,1.08,3.82,1.85,5.8,2.5c1.07,0.35,2.16,0.66,3.25,0.95c2.42,10,5.93,15.83,11.5,18.63 c-0.73-0.05-1.47-0.11-2.2-0.16l-6.24-0.37l-8.78-0.54l-9.44-0.32l8.65,0.93l8.66,0.89l7.04,0.61c7.33,0.73,14.67,1.44,22,2.15 c-2.5,0.26-5,0.51-7.49,0.82c-3.39,0.38-6.78,0.81-10.17,1.26c-3.39,0.48-6.78,0.92-10.15,1.55c6.84-0.17,13.67-0.47,20.49-0.9 c3.41-0.18,6.81-0.46,10.22-0.69l10.06-0.81c11.44,1.1,22.9,2.12,34.35,3.17l34.67,3.06l32.61,2.76c0.38,0.07,0.76,0.14,1.16,0.2 l18.45,1.68l-14.68,2.53c-5.16,0.93-10.33,1.83-15.48,2.81c-5.16,0.95-10.31,1.96-15.46,2.97c-5.14,1.05-10.29,2.07-15.4,3.27 c10.42-1.33,20.81-2.77,31.18-4.35c5.19-0.76,10.37-1.6,15.55-2.41l15.53-2.54l9.8-1.68c2.04,0.16,4.07,0.32,6.11,0.48 c11.57,0.92,23.14,1.78,34.71,2.64l17.36,1.22l8.68,0.61l8.69,0.56L487.12,477.94z M419.43,395.33 c11.75,0.32,20.85,17.65,20.28,38.64c-0.28,10.29-2.83,19.88-7.18,27c-4.21,6.9-9.58,10.64-15.14,10.48l-1.42-0.13 c-11.06-1.6-19.42-18.37-18.88-38.51c0.28-10.29,2.83-19.88,7.18-27c4.14-6.78,9.39-10.49,14.84-10.49 C419.21,395.33,419.32,395.33,419.43,395.33z M383.32,449.36l0.22-0.85c3.32-12.57,6.76-25.14,10.68-37.5 c1.02-3.08,2.04-6.12,3.34-9.05c0.64-1.49,1.32-2.93,2.05-4.34l0.58-1.03c0.1-0.17,0.19-0.34,0.29-0.51l0.06-0.09l10.21-0.16 c-3.1,1.95-5.97,4.99-8.43,9.02c-4.52,7.41-7.17,17.32-7.45,27.91s1.82,20.63,5.93,28.27c2.13,3.96,4.68,7.05,7.5,9.16 l-17.25-1.57c-8.01-1.16-12.24-6.32-15.22-18.8c2.2-0.12,4.41-0.26,6.61-0.41L383.32,449.36z M283.51,444.16 c6.87,0.72,13.75,1.4,20.63,2.09c-4.23,8.33-10.27,13.17-16.42,13l-1.56-0.15c-6.22-0.98-11.77-6.89-15.2-16.23 c0.08,0.01,0.16,0.02,0.24,0.02L283.51,444.16z M246.51,439.49c0.03,0.01,0.05,0.01,0.08,0.02c4.06,0.89,8.16,1.54,12.27,2.07 c3.13,0.4,6.26,0.72,9.38,1.03c2.43,7.14,6.06,12.58,10.35,15.79l-17.02-1.59C253.75,455.68,249.45,450.78,246.51,439.49z  M357.18,465.66l-34.68-2.93c-7.78-0.63-15.56-1.27-23.34-1.9c3.11-0.33,6.23-0.62,9.34-1c6.79-0.77,13.57-1.62,20.33-2.72 c-6.85,0.07-13.68,0.39-20.5,0.8c-3.41,0.18-6.82,0.45-10.22,0.68l-1.02,0.08c3.73-2.59,7.08-6.74,9.69-12.16 c0.46,0.05,0.92,0.09,1.38,0.14c8.22,0.81,16.43,1.63,24.66,2.34c4.12,0.35,8.23,0.71,12.36,1c2.07,0.14,4.13,0.28,6.22,0.35 c2.08,0.07,4.16,0.09,6.24,0.08c5.24-0.03,10.47-0.2,15.69-0.46c1.86,8.04,4.43,14.33,9.32,17.95L357.18,465.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M245.43,429.29c-0.47,0.32-1.04,0.56-1.62,0.78c-1.16,0.43-2.37,0.76-3.57,1.11 c-1.16,0.38-2.42,0.35-3.62,0.03c-1.2-0.32-2.34-0.87-3.36-1.59c0.98,0.78,2.1,1.4,3.3,1.79c1.19,0.4,2.54,0.51,3.79,0.17 c1.22-0.3,2.44-0.57,3.65-0.96c0.61-0.2,1.21-0.41,1.8-0.77c0.28-0.19,0.6-0.41,0.77-0.85c0.08-0.22,0.08-0.48,0.01-0.69 c-0.07-0.22-0.19-0.38-0.3-0.53l-0.02-0.03l-0.05-0.04l-9.03-6.7l0,0l-0.03-0.02c-0.25-0.16-0.41-0.45-0.42-0.73l-0.01-1.42 l-0.02-1.47c0-0.27,0.17-0.55,0.38-0.7c0.11-0.07,0.23-0.11,0.34-0.12c0.06-0.01,0.12,0,0.18,0.01l0.36,0.07 c0.48,0.1,0.97,0.19,1.45,0.27c0.97,0.17,1.95,0.33,2.92,0.47c3.9,0.56,7.8,0.94,11.71,1.3c3.9,0.35,7.81,0.67,11.72,0.95 c3.91,0.28,7.81,0.53,11.72,0.78c3.91,0.24,7.82,0.48,11.73,0.69l11.73,0.59l11.73,0.55l11.73,0.48l11.73,0.45l2.93,0.1 l0.37,0.01c0.08,0,0.07,0,0.11,0.01c0.06,0.01,0.11,0.04,0.16,0.08c0.03,0.03,0.03,0.02,0.07,0.09l0.21,0.3l0.42,0.6l0.85,1.2 l0.21,0.3l0.11,0.15c0.05,0.06,0.05,0.07,0.06,0.09c0.04,0.06,0.05,0.1,0.05,0.14c0.01,0.07-0.04,0.23-0.21,0.36 c-0.04,0.03-0.08,0.06-0.14,0.09c-0.02,0.02-0.05,0.03-0.08,0.04l-0.04,0.02l-0.08,0.03l-0.68,0.24 c-3.66,1.27-7.41,2.41-11.13,3.62c-1.86,0.6-3.73,1.2-5.6,1.85c-0.47,0.16-0.93,0.33-1.42,0.52l-0.37,0.15 c-0.14,0.07-0.29,0.14-0.46,0.24c-0.08,0.05-0.18,0.13-0.26,0.19c-0.1,0.1-0.19,0.17-0.29,0.34c-0.09,0.13-0.18,0.36-0.2,0.58 c-0.02,0.24,0.03,0.45,0.09,0.62c0.15,0.34,0.31,0.47,0.46,0.62c0.14,0.13,0.28,0.22,0.41,0.31c0.26,0.17,0.5,0.29,0.75,0.41 c0.48,0.23,0.95,0.41,1.42,0.59l1.37,0.52l0.66,0.26c0.24,0.09,0.51,0.2,0.77,0.28c1.06,0.33,2.14,0.38,3.16,0.37 c1.02-0.02,2-0.1,2.96-0.15c0.95-0.03,1.93-0.07,2.91-0.12l11.74-0.57c7.82-0.39,15.65-0.81,23.46-1.3 c-7.83,0.02-15.65,0.1-23.47,0.21l-11.73,0.19c-0.98,0.02-1.95,0.03-2.96,0.04c-0.99,0.02-1.97,0.07-2.91,0.06 c-0.93-0.02-1.83-0.1-2.64-0.37c-0.21-0.06-0.39-0.14-0.61-0.23l-0.7-0.29l-1.36-0.55c-0.44-0.18-0.88-0.37-1.28-0.56 c-0.06-0.03-0.12-0.06-0.17-0.09c0.41-0.15,0.85-0.3,1.28-0.44c1.84-0.59,3.72-1.15,5.59-1.71c3.75-1.12,7.49-2.24,11.25-3.48 l0.71-0.24l0.09-0.03l0.13-0.05c0.09-0.03,0.17-0.07,0.26-0.12c0.17-0.08,0.33-0.19,0.48-0.31c0.6-0.46,1.1-1.24,1.08-2.16 c-0.01-0.45-0.15-0.89-0.36-1.25c-0.13-0.21-0.17-0.26-0.25-0.37l-0.21-0.3l-0.83-1.21l-0.42-0.6l-0.21-0.3 c-0.09-0.13-0.25-0.33-0.4-0.47c-0.32-0.29-0.7-0.5-1.12-0.62c-0.2-0.06-0.45-0.09-0.61-0.09l-0.37-0.02l-2.93-0.14l-11.73-0.5 l-5.58-0.25l3.3-11.84c5.61-2.63,11.32-5.16,17.11-7.3c1.5-0.55,3-1.06,4.51-1.51c0.75-0.23,1.51-0.43,2.26-0.6 c0.76-0.18,1.48-0.3,2.28-0.41c3.13-0.46,6.29-0.69,9.46-0.71c1.58-0.01,3.17,0.03,4.76,0.12c0.79,0.04,1.59,0.1,2.39,0.16 c0.4,0.03,0.69,0.05,0.83,0.09c0.01,0.02,0.01,0.04,0.02,0.07c0.04,0.16,0.1,0.43,0.23,0.74c0.13,0.31,0.34,0.63,0.59,0.88 c0.51,0.5,1.05,0.71,1.52,0.87c0.96,0.3,1.82,0.38,2.67,0.44c0.85,0.06,1.69,0.06,2.51,0.05l2.41-0.05 c1.6-0.02,3.22-0.02,4.88-0.11c1.65-0.09,3.39-0.29,5.07-0.91c1.68-0.6,3.19-1.64,4.43-2.82c1.25-1.19,2.28-2.51,3.24-3.86 c0.48-0.67,0.93-1.37,1.37-2.05c0.43-0.66,0.86-1.32,1.32-1.95c0.92-1.28,1.9-2.5,2.95-3.66c2.11-2.32,4.52-4.35,7.19-6.01 c5.33-3.33,11.59-5.03,17.91-5.59c3.15-0.26,6.35-0.2,9.31,0.79c1.47,0.49,2.86,1.23,4.13,2.15c1.27,0.92,2.43,2.02,3.53,3.17 c1.08,1.15,2.15,2.43,3.5,3.41c0.66,0.5,1.41,0.91,2.21,1.17c0.8,0.26,1.64,0.35,2.46,0.34c1.64-0.02,3.23-0.29,4.83-0.45 c1.6-0.18,3.21-0.29,4.82-0.33c-1.61-0.04-3.23,0-4.84,0.1c-1.61,0.09-3.22,0.27-4.81,0.24c-0.79-0.02-1.57-0.14-2.3-0.4 c-0.73-0.27-1.4-0.66-2.01-1.15c-1.24-0.97-2.21-2.22-3.29-3.45c-1.08-1.22-2.23-2.39-3.53-3.41c-1.3-1.02-2.76-1.87-4.33-2.46 c-1.56-0.59-3.21-0.93-4.86-1.08c-1.65-0.16-3.3-0.14-4.93-0.05c-3.26,0.21-6.51,0.69-9.68,1.56c-3.17,0.88-6.24,2.16-9.09,3.85 c-2.85,1.69-5.44,3.8-7.72,6.2c-1.14,1.2-2.2,2.48-3.17,3.81c-0.49,0.66-0.96,1.35-1.41,2.03c-0.44,0.67-0.87,1.32-1.33,1.96 c-1.82,2.53-3.94,4.87-6.68,5.8c-1.36,0.48-2.86,0.65-4.42,0.72c-1.56,0.07-3.17,0.04-4.79,0.07c-1.64,0.01-3.23,0.1-4.74-0.01 c-0.75-0.05-1.5-0.15-2.08-0.34c-0.28-0.09-0.51-0.22-0.57-0.29c-0.07-0.08-0.08-0.06-0.2-0.53c-0.06-0.22-0.16-0.6-0.45-0.98 c-0.29-0.38-0.71-0.61-1.03-0.73c-0.32-0.11-0.61-0.17-0.86-0.19l-0.19-0.02l-0.15-0.01l-0.3-0.02 c-0.81-0.06-1.62-0.12-2.43-0.17c-1.63-0.1-3.27-0.14-4.9-0.14c-3.27,0.01-6.56,0.23-9.8,0.72c-0.8,0.11-1.66,0.26-2.47,0.46 c-0.81,0.2-1.62,0.41-2.4,0.65c-1.58,0.47-3.12,1.01-4.65,1.57c-3.05,1.13-6.05,2.37-9.02,3.67c-2.88,1.26-5.73,2.55-8.56,3.93 l-20.14-0.88l-20.44-0.83l-20.45-0.76l-20.33-0.62c-0.5-0.67-0.98-1.37-1.46-2.07l-1.49-2.22c-0.99-1.48-1.96-2.98-2.93-4.48 c0.88,1.55,1.77,3.1,2.68,4.63c0.46,0.77,0.91,1.54,1.39,2.29c0.48,0.76,0.94,1.51,1.46,2.26l0.07,0.1l0.15,0.01l20.4,1.34 l20.42,1.25l20.42,1.19l19.16,1.05l-0.93,11.54l-17.87-0.79l-23.44-1.1c-3.91-0.19-7.81-0.4-11.71-0.62 c-3.9-0.21-7.81-0.44-11.7-0.7c-3.89-0.28-7.79-0.57-11.65-1c-0.97-0.1-1.93-0.23-2.89-0.37c-0.48-0.07-0.96-0.14-1.44-0.23 l-0.36-0.06c-0.18-0.03-0.37-0.04-0.56-0.02c-0.37,0.04-0.73,0.18-1.02,0.39c-0.58,0.42-0.93,1.1-0.92,1.81l0.06,1.47l0.06,1.51 c0.04,0.69,0.45,1.34,1.04,1.68l-0.04-0.02l9.24,6.32c0.15,0.18,0.21,0.33,0.16,0.46C245.86,428.93,245.66,429.13,245.43,429.29z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M310.98,434.33c-0.88-0.29-1.8-0.55-2.79-0.65l-2.68-0.29c-3.57-0.39-7.14-0.68-10.71-1.02l-10.73-0.84 c-7.16-0.48-14.32-0.92-21.5-1.12c-3.59-0.1-7.17-0.19-10.81-0.05c-0.47,0.03-0.89,0.05-1.44,0.16 c-0.19,0.05-0.27,0.09-0.38,0.13l-0.32,0.12l-0.63,0.25c-0.84,0.34-1.66,0.7-2.48,1.08c-1.64,0.75-3.24,1.58-4.79,2.48 c1.66-0.68,3.35-1.3,5.04-1.88c0.85-0.28,1.69-0.56,2.55-0.82l0.64-0.19l0.32-0.09c0.1-0.03,0.24-0.07,0.27-0.07 c0.33-0.03,0.82-0.02,1.24-0.01c3.54,0.15,7.12,0.51,10.69,0.78l10.71,0.87l10.72,0.81l10.73,0.73c3.58,0.2,7.15,0.45,10.74,0.62 l2.68,0.14c0.8,0.03,1.62,0.22,2.47,0.43c1.68,0.44,3.35,1.04,5,1.7c3.32,1.29,6.58,2.78,9.85,4.28 c-2.99-1.99-6.12-3.79-9.35-5.42C314.39,435.69,312.74,434.94,310.98,434.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M363.3,400.18c-0.24,0-0.51,0.01-0.79,0.01c-1.83,0-1.83,1.63-1.83,2.42c0,0.45,0.03,2.58,0.06,5.28 c0.06,4.46,0.14,10.58,0.14,12.68c0,3.56,0.48,4.3,1.8,6.32c0.4,0.61,0.67,1.09,0.86,1.44c0.44,0.79,0.77,1.37,1.74,1.37 c0.07,0,0.13,0,0.19,0c0.05,0,0.11,0,0.17,0c0.28,0,0.62-0.04,0.9-0.31c0.41-0.4,0.46-1.03,0.46-2.29V404.6 c0-2.15-0.23-3.18-0.86-3.8C365.44,400.14,364.5,400.16,363.3,400.18z M365.49,427.09c0,0.58-0.02,0.92-0.04,1.11 c-0.08,0-0.2,0-0.25,0c-0.01,0-0.01,0-0.01,0c-0.08-0.08-0.23-0.35-0.37-0.61c-0.2-0.37-0.48-0.86-0.93-1.55 c-1.24-1.91-1.54-2.37-1.54-5.49c0-2.11-0.08-8.23-0.14-12.7c-0.03-2.69-0.06-4.82-0.06-5.26c0-0.72,0.08-0.88,0.09-0.9 c0,0,0.06-0.03,0.25-0.03c0.29,0,0.56,0,0.82-0.01c0.88-0.02,1.52-0.03,1.75,0.2c0.42,0.41,0.42,2.17,0.42,2.74V427.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clouds_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1D9C8",
    d: "M738.19,79.93c-10.2-15-32.13-32.83-57.05-21.42c-4.7,2.33-9.93,5.68-15.44,10.47 c0.43,0.1,0.87,0.22,1.3,0.36c6.87,2.16,10.08,6.81,10.08,6.81s21.37-1.71,28.06,16.43c0,0-10.75-16.99-29.33-13.67 c0,0-8.25-13.33-30.1-5.83c0,0,9.05-6.4,19.36-4.25c1.95-2.63,6.27-7.7,13.48-12.25c-11.85-15.31-25.87-19.96-35.86-21.53 c-27.02-4.26-55.97,4.87-79.59,18.81C515.81,81.8,473.2,84.41,422.65,99.7l381.68-5.1C767.59,93.91,752.54,71.2,738.19,79.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "father_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M89.39,432.2l-3.35-4.05c0,0-2.94-10.8-2.46-11.55c0.48-0.76,0.48-0.76,0.48-0.76l5.8-3.97l2.35,6.01 L89.39,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.28,726.07C120.22,726.21,120.22,726.2,120.28,726.07L120.28,726.07z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.35,725.92c-0.01,0.03-0.02,0.05-0.03,0.08c-0.01,0.02-0.02,0.05-0.03,0.07 c0.01-0.02,0.02-0.04,0.03-0.07C120.33,725.97,120.34,725.95,120.35,725.92C120.35,725.92,120.35,725.92,120.35,725.92z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M155.56,424.88c-0.07-0.47-0.17-0.93-0.28-1.38c-1.01-3.94-1.25-4.93-5.23-10.06 c1.03-0.75,1.9-2.14-1.4-8.12c-2.52-4.56-4.79-6.73-6.15-6.64c-0.46,0.03-0.82,0.32-1.05,0.87c0,0,0,0,0,0 c-0.11,0.27-1.22,1.7-2.21,0.51c0,0-1.05-2.2-4.27-4.71c-3.22-2.51-8.45-5.88-10.12-6.35c-1.67-0.47-12.37-6.09-14.28-5.6 s-0.31,5.15-4.86,6.77c-4.55,1.62-10.75,2.41-13.1,3.63c-1.17,0.61-2.57,1.88-3.76,3.17c-0.48-1.25-0.84-1.95-0.82-1.18 c-0.13-0.2,0.02,0.54,0.32,1.75c-0.96,1.11-1.72,2.16-1.96,2.75c-0.58,1.36-1.8,5.67-1.73,5.7c0.08,0.03-1.21,8.16-1.21,8.16 l0.12,2.43l2.8-1.94c0.41,3.29,1.24,6.52,2.48,9.59c-0.41-0.7-0.83-1.4-1.24-2.09c0.36,0.99,0.72,1.99,1.08,2.98 c-0.87-1.25-1.64-2.57-2.3-3.94c0.95,2.68,2,5.33,3.15,7.93c-1.61-2.44-3.04-5-4.26-7.66c1.24,3.59,2.52,7.22,4.47,10.45 c-0.03,0.02-0.06,0.05-0.1,0.07c-1.41-1.97-2.68-4.04-3.8-6.18c0,0.01,0,0.01,0.01,0.02c1.08,2.15,2.22,4.33,3.53,6.36 c-0.18,0.14-0.36,0.27-0.53,0.4c-0.09,0.07-0.18,0.14-0.27,0.21c-1.43,1.09-1.84,2.66-1.38,3.99 c0.09,0.36,0.39,0.78,0.39,0.78s-2.44,2-1.47,3.92c0.21,1,1.26,1.13,1.26,1.13s-1.73,1.29-0.71,3.11 c0.15,0.26,0.41,0.63,0.41,0.63s0.51,0.83,0.97,0.8c2.18-0.15,6.99,0.34,6.55,0.6c-0.06,0.08-0.27,0.14-0.66,0.15 c-1.02,0.01-3.09-0.28-4.46,0.09c-1.37,0.37-1.95,1.59-2.03,2.64c-0.08,1.05,1.19,1.55,2.05,2.28 c0.86,0.73,1.04,0.89,2.7,1.15c1.65,0.26,2.89,0.21,3.66,0.46c0.77,0.25,1.9,1.62,3.21,1.91c1.31,0.29,2.54,2.14,4.46,2.83 c1.92,0.69,3.63,1.13,5.72,0.83c0,0,1,1.18,3.04,3.79c0.51,0.65,1.02,1.25,1.52,1.78c2.37-1.53,10.35-12.5,11.53-16.77 c0,0,2.02-1.87,5.12-0.4c1.71,0.81,2.71,1.72,4.49,1.39c0.68-0.12,2.39,0.78,4.66,2.35c0.24-0.11,0.49-0.21,0.72-0.32 c1.53-1.53,3.03-3.52,4.43-6.9c5.09-12.22,9.66-16.43,15.1-17.6C156.91,427.29,156.13,426.28,155.56,424.88z M140.38,403.4 c-0.02-0.02-0.03-0.04-0.05-0.06l-0.03-0.16C140.33,403.25,140.35,403.32,140.38,403.4z M87.06,414.18l1.15-0.8 c0.76,3.59,1.12,5.32,2.97,9.55C89.56,420.14,88.19,417.21,87.06,414.18z M88.64,413.09l1.01-0.7 c0.55,1.83,1.11,3.66,1.7,5.48C89.87,415.26,89.42,414.75,88.64,413.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M115.33,296.21c-0.44,0.69-0.94,1.34-1.5,1.94c-0.64,0.68-1.25,1.25-1.82,1.73 c0.34,0.87,0.68,1.75,1,2.66C113.89,301.09,114.86,298.98,115.33,296.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M86.46,429.13c0.03,0.01,0.07,0.02,0.1,0.02c-0.18-0.33-0.35-0.66-0.51-1c-1.57-2.02-2.57-4.47-2.84-7.01 c0.08,1.27,0.15,2.54,0.23,3.81c-0.6-2.94-0.77-5.96-0.49-8.95c-0.1,1.09-0.3,2.16-0.62,3.2c0.3-2.68,0.26-5.4-0.1-8.08 c-0.01,1.02-0.02,2.05-0.04,3.07c0-0.33-0.14-0.72-0.2-1.04c-0.06-0.36-0.12-0.73-0.16-1.09c-0.09-0.71-0.15-1.43-0.19-2.15 c-2.54,0.12-4.83,1.32-6.88,3.18c-0.25,6.08-0.03,11.73,1.26,14.79l-0.26,0.02c0.13,0,0.27,0.01,0.4,0.02 c2.91-0.09,6.24,0.23,10.23,1.19c-0.1-0.14-0.19-0.27-0.29-0.41C86.22,428.84,86.34,428.98,86.46,429.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M65.47,428.56c0.19-0.03,0.38-0.05,0.57-0.07l-0.56,0.03C65.48,428.53,65.48,428.55,65.47,428.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M113.42,368.98c0,1.59,0.04,5.44,0.75,6.32c0.34-1.86,1.12-3.79,1.12-4.65c0-0.68-0.34-1.13-0.56-1.35 c0.01-0.07,0.02-0.13,0.04-0.2c1.35-0.27,0.93-1.19,0.48-2.67c0.06-0.33,0.11-0.67,0.17-1c-0.12,0.04-0.25,0.09-0.39,0.15 C113.84,366.09,113.42,365.7,113.42,368.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M114.36,327.42c0.04-0.03,0.15-0.05,0.3-0.06c0.77-1.56,1.56-3.21,1.91-5.61 c-0.16,0.3,0.13-3.21,0.17-3.22c-0.1-3.41-0.97-8.04-3.29-14.78c-0.07-0.21-0.15-0.42-0.22-0.63 c-0.21-0.58,0.22,0.63-0.21-0.58c-0.32-0.9-0.66-1.79-1-2.66c-8.01,6.72-9.22-5.06-13.28,13.03 c-1.05,4.69-1.29,9.37-1.2,13.77c0.33,1.85,0.64,4.14,0.93,6.98c1.9,18.92,12.38,28.27,17.65,25.65 c0.03,0.01,0.05,0.02,0.08,0.03c0.01-0.11,0.02-0.22,0.03-0.34c0.53-0.42,1.08-0.88,1.48-1.15c-0.87,0.54-1.37,0.99-1.37,0.99 c0.13-5.63-0.03-8.53-1.95-14.26c-1.92-5.73-1.52-8.01-1.59-10.53c0.56,4.78,1.86,7.35,2.69,10.3 c0.83,2.95,0.7,7.26,2.04,9.33c1.34,2.07,6.58,1.84,3.98,2.52c-1.4,0.37-2.59,0.94-3.47,1.45c0.05-0.02,0.09-0.04,0.12-0.05 c5.54-1.54,6.97-2.66,3.35-9.12c-2.88-5.14-6.7-13.5-8.37-17.23c0.27-1.19,0.72-2.19,1.21-3.2 M117.5,353.69 c-1.34-2.07-1.21-6.38-2.04-9.33c-0.83-2.95-2.12-5.53-2.69-10.3c0.07,2.52-0.33,4.8,1.59,10.53 c1.92,5.73,2.08,8.63,1.95,14.26c0,0,0.5-0.44,1.37-0.99c0.1-0.06,0.21-0.13,0.33-0.2c0.88-0.52,2.07-1.09,3.47-1.45 C124.07,355.53,118.84,355.77,117.5,353.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M83.54,397.82c-0.03,0.06-0.06,0.12-0.08,0.17c-0.12,0.29-0.24,0.58-0.36,0.87 c0,0.05-0.01,0.1-0.01,0.15c0.12-0.35,0.26-0.69,0.4-1.03C83.51,397.93,83.52,397.88,83.54,397.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M73.26,329.21c2.71,0.55,4.73,4.14,2.16,7.27c-2.57,3.13-3.49,4.48-4.06,6.89 c-0.57,2.41,1.17,4.63,1.17,4.63s0.36-1.85,0.94-4.08c0.58-2.23,3.29,0.81,5.89-1.95c2.6-2.77,0.81-10.25-0.24-11.98 c-1.05-1.73-3.08-4.47-7.12-3.4c-4.03,1.07-4.92,5.87-5.79,9.22C66.21,335.81,69.45,328.44,73.26,329.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M78.91,348.15c-1.17,1.37,2.1,6.55,3.82,8.59c1.72,2.04,3.36,0.08,1.52-3.4 c-1.84-3.48-0.62-4.31,0.25-6.2c0.87-1.89-0.07-2.36-0.07-2.36C82.6,347.65,80.08,346.77,78.91,348.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M80.15,362.77c0,0-9.22-9.95-9.95-18.61C70.19,344.16,71.24,359.52,80.15,362.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M201.72,361.4c3.9,1.39,7.28,2.73,8.72,3.21c2.3,0.77,6.12,3.97,8.84,5.64 c2.71,1.67,5.36,4.31,6.47,5.5c1.06,1.13,1.04,3.21-0.11,4c-0.33-0.26-0.71-0.55-1.13-0.86c0.2-0.57,0.22-1.29-0.01-2.23 c0.28,1.46-0.28,2.37-1.67,2.3c-1.39-0.07-1.37-2.03-1.18-3.48c0.04-0.34-0.66-0.98-1.27-1.75c-0.47-0.59-0.78-1.51-1.37-0.9 c-2.44,2.5-9.67,0.56-13.64,2.23c-3.97,1.67-10.37,2.85-15.45,5.5c-4.95,2.58-13.28,6.81-20.66,12.37 c-2.56-3.12-5.28-4.84-6.41-5.48c1.53-1.27,3.09-2.6,3.97-3.49c2.16-2.16,5.22-6.12,9.25-9.67c4.04-3.55,7.24-8.35,9.18-11.34 c1.52-2.34,2.45-4.54,5.83-4.51L201.72,361.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M218.89,380.64c0.03,0.01,0.07,0.01,0.11,0.02c0.77,0.13,1.9,0.25,2.92,0.04 c1.15-0.23,2.21-0.72,2.6-1.82c0.2-0.57,0.22-1.29-0.01-2.23c0.28,1.46-0.28,2.37-1.67,2.3c-1.39-0.07-1.37-2.03-1.18-3.48 c0.04-0.34-0.66-0.98-1.27-1.75c-0.47-0.59-0.78-1.51-1.37-0.9c-2.44,2.5-9.67,0.56-13.64,2.23 c-3.97,1.67-10.37,2.85-15.45,5.5c-4.95,2.58-13.28,6.81-20.66,12.37c2.82,3.44,5.44,8.57,5.54,15.82 c1.77-1.85,2.5-2.25,3.56-2.73c1.39-0.63,1.32-0.63,2.16-1.46c0.84-0.83,4.52-0.07,7.31-2.44c2.78-2.37,5.84-6.61,6.12-6.82 c0.28-0.21,1.67-0.56,2.09-0.83c0.42-0.28,2.78,0.21,4.45,0.9c1.67,0.7,3.27,1.04,4.38,1.46c1.11,0.42,2.64,0.77,4.11-0.28 c1.46-1.04,1.74-2.5,0.56-3.69c-1.18-1.18-2.5-2.37-3.2-3.13c-0.7-0.77-3.27-1.32-4.87-2.23c0,0,0,0,0-0.01 c-1.82,1.48,4.35-3.6,1.22-1c0.32,0.13,0.73,0.37,1.36,0.59c1.18,0.42,2.85,0.49,4.31,1.67c1.46,1.18,1.88,1.25,2.64,2.64 c0.77,1.39,2.23,3.27,4.04,2.16c1.81-1.11,1.88-2.71,1.46-4.17c-0.42-1.46-0.49-2.5-0.7-2.85c-0.21-0.35-1.32-1.32-2.02-1.81 c-0.7-0.49-2.37-2.02-2.37-2.02s2.5,1.32,3.13,2.09c0.63,0.77,1.74,2.44,2.71,2.99c0.97,0.56,2.71,0.28,3.41-1.11 c0.7-1.39,0.21-3.69-0.83-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M200.62,387.15c-3.2,2.3-7.86,5.43-15.31,8.56c0,0,7.51-2.3,11.27-4.59c1.27-0.78,3.06-2.15,4.88-3.62 c0.41-0.33,0.81-0.66,1.22-1c3.13-2.6,6.01-5.19,6.01-5.19C207.51,381.93,203.82,384.86,200.62,387.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M148.66,405.33c3.3,5.98,2.43,7.37,1.4,8.12c3.98,5.13,4.22,6.12,5.23,10.06 c0.11,0.44,0.2,0.9,0.28,1.38c0.57,1.39,1.35,2.4,4.3,2.54c1.53-0.33,3.14-0.42,4.84-0.38c0.88-0.09,1.8-0.12,2.75-0.1 c3.74-10.15,7.34-16.97,7.34-16.97c0.01-0.43,0.01-0.84,0.01-1.25c-0.1-7.25-2.72-12.38-5.54-15.82 c-2.56-3.12-5.28-4.84-6.41-5.48c-0.35-0.19-0.55-0.29-0.55-0.29c-4.48,0.41-7.81,1.59-19.8,11.54 C143.87,398.59,146.14,400.77,148.66,405.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M140.33,451.93c-0.24,0.11-0.48,0.22-0.72,0.32c0.07,0.05,0.15,0.11,0.23,0.16 C140,452.26,140.16,452.1,140.33,451.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M141.45,399.57c-0.16,0.13-0.33,0.27-0.49,0.41c0.08,0.1,0.16,0.21,0.24,0.32 C141.26,400.08,141.34,399.84,141.45,399.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M86.7,429.41c-0.05-0.09-0.09-0.17-0.14-0.26c-0.03-0.01-0.07-0.02-0.1-0.02 C86.54,429.22,86.62,429.32,86.7,429.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M25.04,432.41c19.19,0,30.93-2.59,40.6-3.85c0.01-0.01,0.01-0.03,0.02-0.04l0.56-0.03l9.71-0.58 l0.26-0.02c-1.29-3.06-1.52-8.71-1.26-14.79c2.04-1.86,4.33-3.06,6.88-3.18c0-0.02-0.02-0.04,0-0.05 c1.16-0.25,5.11-6.67,6.61-7.21c7.91-2.87,4.12-9.18,4.45-9.74c4.59-7.95,17.93-4.48,17.98-4.73 c0.09-0.7-27.55,10.62-27.55,10.57c-0.33,0.81-0.67,1.73-1,2.53c0.3-0.86,0.64-1.7,1-2.53c0.84-9.82,4.15-20.81,4.51-27.32 c0.15-2.59,0.26-4.96,0.34-7.14c0.38-0.57,0.68-1.35,0.85-2.37c0.68-3.95-0.14-6.91-0.87-12.77 c-0.15-2.67-0.38-4.93-0.66-7.03c-0.04-0.29-0.07-0.57-0.08-0.86c-1.15-7.5-4.46-19.67-13.72-16.62 c-10.31,3.39-8,16.63-11.87,41.69C57.56,393.57,30.12,405.9,5.8,392c0,0-0.13-0.68-0.36-1.85c0.06,4.3-0.4,8.09-1.17,11.4 c-1.52,4.44-4.51,9.19-7.27,12.31c-0.03,0.03-0.05,0.06-0.08,0.09c-1.81,2.07-2.69,3.97-2.71,5.72 C-4.3,422.9,2.03,432.41,25.04,432.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M87.58,437.54c-0.04-0.07-0.16-0.28-0.36-0.73C87.31,437.07,87.43,437.31,87.58,437.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M83.58,397.69c-0.04,0.1-0.08,0.2-0.12,0.3c0.03-0.06,0.06-0.12,0.08-0.17 C83.56,397.78,83.57,397.73,83.58,397.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M83.11,398.76c-0.37,0.83-0.7,1.68-1,2.53c0.33-0.81,0.66-1.62,0.99-2.43 c0.12-0.29,0.24-0.58,0.36-0.87C83.34,398.25,83.22,398.5,83.11,398.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M164.7,427.05c-1.7-0.04-3.31,0.05-4.84,0.38c-5.44,1.17-10.01,5.37-15.1,17.6 c-1.41,3.39-2.91,5.38-4.43,6.9c-0.17,0.17-0.33,0.33-0.5,0.48c-0.07-0.05-0.15-0.11-0.23-0.16 c-2.27-1.57-3.98-2.47-4.66-2.35c-1.78,0.32-2.78-0.58-4.49-1.39c-3.1-1.47-5.12,0.4-5.12,0.4 c-1.18,4.27-9.16,15.23-11.53,16.77c-0.08,0.05-0.16,0.1-0.23,0.13c-0.28,3.01,3.54,5.35,3.16,7.22 c-0.37,1.87,2.92,4.61,7.07,11.03c1.85,2.87,6.98,8.36,12.68,13.45c-0.12-0.72-0.04-0.9,0.27-0.46c0.49,0.71,0.99,1.37,1.49,2 c4.59,3.94,9.36,7.44,12.96,8.96c4.15,1.06,7.08,0.35,7.08,0.35s-0.83,2.37,2.11,7.37c10.28,17.48,22.92,45.8,28.85,59.5 l0.56-0.04c8.51-19.17,21.14-20.58,24.46-27.27c3.32-6.69,7.05-18.78,11.53-21.76c0.28-0.19,0.57-0.36,0.85-0.5 c-0.01-0.16-0.02-0.33-0.02-0.48c-0.22-1.57-0.53-4.15-0.4-5.51c0.19-2.05,1.51-3.21,2.41-4.44c0.9-1.23,0.94-3.06,1.12-5.41 c0.18-2.35,0.92-3.3,1.56-4.33c0.01-0.02,0.02-0.03,0.03-0.05c-2.52-6.08-5.62-12.03-8.41-17.98 c-5.64-12.04-15.79-24.09-21.8-32.52c-4.48-6.29-6.35-11.35-10.36-16.08c-7.08-8.35-16.19-11.71-23.31-11.89 C166.5,426.93,165.58,426.97,164.7,427.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M87.38,442.63c-0.16-0.03-0.29-0.08-0.41-0.14C87.21,442.63,87.38,442.63,87.38,442.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M251.13,523.68c0,0.04,0,0.09,0,0.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M252.69,534.3c0.33-2.2,1.3-4.31,0.64-6.34c-0.21-0.63-0.49-1.18-0.79-1.68 c-0.04-0.43-1.08-1.41-1.41-2.46c-0.03-0.12-0.05-0.25-0.04-0.38c-0.13-1.31,0.79-2.64-0.78-5.59 c-0.49-0.92-1.46-1.19-2.14-2.15c0,0-0.9-1.1-0.78-2.15c0.24-2.21-1.19-5.01-3.91-6.38c-0.83-0.42-1.95-0.84-3.12-1.22 c-0.42-4.69-3.28-6.6-5.97-5.3c-0.54,0.26-0.93,0.53-1.22,0.8c-0.55,0.49-0.67,0.8-0.67,0.8c-0.23,0.96-0.23,0.96-0.48,1.62 l-0.28,0.81l-0.38,0.76c0,0-0.74,0.06-1.4,3.07c-0.26,1.17-0.3,2.82-0.59,5.04c-0.22,1.7-2.23,3.01-2.91,4.95 c-0.99,2.85,0.21,7.15,0.21,7.15s1.56-0.8,2.85-0.83c1.28-0.03,3.17,0.12,5.53,0.83s3.36,0.94,3.36,0.94 c7.06,1.37,12.58,9.76,14.6,17.15c0.58-1.6,1.48-3.71,1.43-4.96c-0.05-1.37-1.22-3.22-1.74-4.17c0,0,0.01,0.01,0.02,0.03 C252.68,534.53,252.67,534.42,252.69,534.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M226.65,525.65c0.01-0.01,0.03-0.01,0.04-0.02c-0.02-0.14-0.04-0.3-0.07-0.46 C226.64,525.32,226.64,525.48,226.65,525.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M253.02,543.86c-0.01-0.04-0.02-0.08-0.04-0.12c-0.01,0.03-0.02,0.05-0.03,0.08 c0-0.18-0.46-1.61-0.46-1.61c0-0.01,0-0.03,0-0.04c-2.52-7.56-7.3-14.12-14.11-15.58c-0.07-0.01-0.14-0.03-0.2-0.04 c-3.11-0.62-7.3-3.03-11.49-0.92c-0.01,0.01-0.03,0.01-0.04,0.02c-0.28,0.15-0.57,0.31-0.85,0.5 c-4.48,2.99-8.21,15.08-11.53,21.76c-3.32,6.69-15.95,8.1-24.46,27.27l-0.56,0.04c-5.94-13.69-18.58-42.02-28.85-59.5 c-2.94-5-2.11-7.37-2.11-7.37s-2.92,0.71-7.08-0.35c-3.6-1.52-8.37-5.01-12.96-8.96c-0.5-0.63-1-1.29-1.49-2 c-0.31-0.45-0.39-0.26-0.27,0.46c-5.7-5.09-10.83-10.58-12.68-13.45c-4.15-6.42-7.44-9.16-7.07-11.03 c0.37-1.87-3.44-4.21-3.16-7.22c0.07-0.03,0.14-0.07,0.23-0.13c-0.49-0.53-1.01-1.13-1.52-1.78 c-2.04-2.61-3.04-3.79-3.04-3.79c-2.08,0.3-3.79-0.14-5.72-0.83c-1.92-0.69-3.15-2.54-4.46-2.83s-2.45-1.66-3.21-1.91 c-0.77-0.25-2-0.19-3.66-0.46c-1.65-0.26-1.84-0.42-2.7-1.15c-0.86-0.73-2.13-1.23-2.05-2.28c0.08-1.05,0.66-2.27,2.03-2.64 c1.37-0.37,3.45-0.08,4.46-0.09c0.39,0,0.6-0.06,0.66-0.15c-0.04,0.02-0.08,0.04-0.12,0.06c0,0,0.28-0.32-0.75-0.46 c-0.07-0.01-0.16-0.02-0.24-0.03c-1.09-0.13-2.97-0.28-3.77-0.45c-0.86-0.18-1.04,0.12-1.59,0.15 c-0.71,0.04-0.98-0.47-1.06-0.67c-0.13-0.17-0.26-0.37-0.41-0.63c-1.02-1.82,0.71-3.11,0.71-3.11s-0.17,0-0.41-0.14 c-0.65-0.32-0.84-1-0.84-1c-0.96-1.92,1.47-3.92,1.47-3.92s-0.01-0.01-0.02-0.03c-0.15-0.23-0.27-0.48-0.36-0.73 c0-0.01,0-0.01-0.01-0.02c-0.46-1.33-0.05-2.9,1.38-3.99c0.09-0.07,0.18-0.14,0.27-0.21c-0.82-1.16-1.65-2.33-2.47-3.49 c-3.99-0.96-7.32-1.28-10.23-1.19c-0.13-0.01-0.27-0.01-0.4-0.02l-9.71,0.58c-0.19,0.02-0.38,0.05-0.57,0.07 c-9.68,1.26-21.41,3.85-40.6,3.85c-23.01,0-29.34-9.51-30.83-12.74c0.02-1.76,0.9-3.65,2.71-5.72 c-7.79-0.92-16.72,0.66-26.66,7.7c-23.76,16.83-24.8,64.4-18.19,97.43c5.41,27.07,10.29,15.4,26.23,140.33 c3.67,28.75,0,58.66,0,58.66s103.83,19.8,163.16,2.67c0,0-7.16-59.16-3.66-102.08c14.41,19.16,19.86,25.82,33,28.95 c0.03,0.01,0.06,0.03,0.09,0.04c4.21,1.65,8.85,1.98,13.67,1.27c6.24-0.5,12-2.56,16.28-5.82 c18.1-9.93,34.66-29.96,36.37-46.16c0.72-6.8,16.65-31.78,17.36-39.36C254.81,553.35,254.33,548.48,253.02,543.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M252.5,542.17c0,0.01,0,0.03,0,0.04c0,0,0.46,1.42,0.46,1.61c0.01-0.03,0.02-0.05,0.03-0.08 c0.42-1.21,0.84-2.25,1.12-3.17c0.35-1.18,0.47-2.17,0.04-3.1c-0.05-0.11-0.1-0.21-0.14-0.31c-0.19-0.4-0.36-0.75-0.52-1.06 c-0.44-0.87-0.71-1.34-0.78-1.46c-0.01-0.02-0.02-0.03-0.02-0.03C252.29,536.55,252.87,539.39,252.5,542.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M-2.66,368.17c0.24,0.85,0.38,1.34,0.38,1.34C-2.39,369.08-2.52,368.63-2.66,368.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M210.57,380.36c0,0,1.33-0.84,2.55-0.67c1.14,0.17,5.25,1.12,6.2,1.75c0.11,0.07,0.19,0.11,0.23,0.13 c0.29,0.09-0.61-0.9-0.61-0.9c-0.01-0.01-0.03-0.01-0.04-0.02c-1.57-0.57-4.16-0.81-5.47-1.2 C211.94,379.02,210.57,380.36,210.57,380.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M111.15,330.29c-0.47,0.78-1.48,0.7-1.48,0.7C108.65,330.29,110.39,332.39,111.15,330.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M111.19,330.53l-1.16,1.26C111.11,331.38,111.19,330.53,111.19,330.53z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M77.97,400.1c-0.47-4.51-0.8-7.06-1.02-8.48c-0.31,2.08-0.74,5.17-1.15,8.72 c-0.26,3.41-0.58,7.1-0.91,10.12c-0.05,0.88-0.1,1.76-0.14,2.64c0.37-0.39,1.03-1,2.19-1.76c1.05-0.68,2.89-1.37,4.69-1.46 c-0.01-0.09-0.01,0.14-0.02,0.05c-0.01-0.18-0.01-0.67-0.02-0.85C78.44,407.6,78.57,405.73,77.97,400.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.33,429.81c0.23,0.53,0.2,1.13-0.12,1.28l-0.01,0.08l-0.16,0.55c0.06-0.17,0.3-0.49,0.42-0.59 c0.59-0.52,1.7-0.41,1.7-0.41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M136.37,442.84c-0.54,0.39-1.03,0.7-1.43,0.85c0,0,2.39-0.96,2.2-0.67c-0.49,0.75-0.63,1.49-0.22,1.17 c0.41-0.32,0.79-0.86,2.51-2.76c1.81-2.01,4.55-3.5,3.55-3.38s-1.4,0.9-1.34,0.34c0.05-0.56,0.13-1.38-0.13-0.94 c-0.2,0.33-0.33,0.64-0.86,1.31c-0.17,0.22-0.38,0.47-0.65,0.77C139.21,440.39,137.68,441.88,136.37,442.84z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.19,432.42c1.64-1.25,3.7-2.74,5.28-2.69c1.8,0.06,4.65,0.22,5.93,0.72c1.28,0.51,1.73,1.94,3.3,2.04 c3.8,0.24,5.39,1.77,8.09,3.79c2.7,2.02,5.34,6.77,7.91,8.22c1.07,0.61,2.34,1.66,3.4,2.63l4.08,1.03 c0.84-0.16,1.93-0.12,3.19,0.48c0.45,0.21,0.84,0.43,1.22,0.63l0.37,0.09c0,0-0.5-0.61-1.25-1.69c-0.74-1.08-1-2.16-0.54-2.58 l-0.06-0.02l-0.04-0.27l-0.08-0.01c0,0-0.5,0.96-0.06,2.24c0.1,0.3,0.27,0.59,0.47,0.85c-1.09-0.99-2.49-2.21-3.38-2.69 c-1.61-0.88-4.99-0.29-7.33-2.05c-1.68-1.26-3.13-4.29-3.81-5.92c-0.16-0.39-0.28-0.69-0.35-0.88 c-0.05-0.12-0.07-0.19-0.07-0.19c-4.98,0.92-5.44-2.69-5.44-2.69s0.45,0.26-0.04-0.21c-0.16-0.16-0.44-0.4-0.87-0.76 c-0.3-0.25-0.67-0.56-1.14-0.94c-6.96-5.6-11.36-5.47-17.52-7.09c-0.67-0.18-1.29-0.37-1.85-0.59 c-0.05-0.02-0.09-0.04-0.14-0.05c-0.14-0.05-0.28-0.11-0.42-0.17c-0.22-0.09-0.43-0.19-0.63-0.29 c-0.15-0.07-0.29-0.15-0.42-0.23c-0.61-0.34-1.13-0.71-1.58-1.13c-0.02-0.02-0.05-0.04-0.07-0.07 c-1.16-1.11-1.82-2.5-2.15-4.27c-0.21-1.11-0.33-2.19-0.44-3.14l-0.23,3.8l-0.06,1.01l0.17-1.51l0.08-0.67 c-0.02,0.13-0.03,0.28-0.03,0.44c-0.03,0.76,0.02,1.78,0.11,2.82c0.2,2.28,0.58,4.66,0.58,4.66l0.12-0.57l-0.29-2.49 c0.05,0.45,0.21,1.01,0.42,1.62c0.33,0.95,0.81,2.03,1.3,3.04c0.46,0.96,0.93,1.85,1.29,2.52c0.39,0.71,0.65,1.17,0.65,1.17 l0.74,0.64L89.19,432.42z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M234.07,525.37c-2.15-0.66-1.94-0.6-2.67-0.65c0,0-1.94-0.22-4.34,0.8c-0.13,0.06-0.26,0.12-0.39,0.19 c-0.01,0.01-0.03,0.01-0.04,0.02c-0.01-0.16-0.02-0.32-0.02-0.47c-0.22-1.57-0.53-4.15-0.4-5.51c0.19-2.05,1.51-3.21,2.41-4.44 s0.94-3.06,1.12-5.41c0.18-2.35,0.92-3.3,1.56-4.33c0.03-0.04,0.05-0.08,0.07-0.12l-1.66-3.78c0,0-0.02-0.01-0.06-0.03 c-0.27-0.11-1.39-0.41-1.81,1.79c-0.47,2.51,0.72,3.44-0.39,5.64c-1.7,3.39-0.79,4.77-1.26,6.34 c-0.47,1.57-2.55,3.44-2.24,5.95c0.09,0.71,0.33,1.53,0.55,2.43c-0.72,2.37-3.41,7.66-6.48,11.03 c-3.5,3.83-3.28,5.89-4.78,11.39c-1.04,3.82-4.11,6.49-6.9,8.71c-0.44-0.42-0.86-0.85-1.28-1.28l0.07-0.06 c0,0-8.07-11.16-9.38-13.18c-2.54-3.91-2-6.02-2.54-11.68c-0.4-4.24-1.37,2.84-0.61,6.58c0.76,3.73-0.99-0.23-2.39-6.29 c-1.41-6.07-1.62-0.16-0.1,3.52c1.52,3.68,1.72,3.04-0.85,2.18c-4.98-1.65,0.8,0.33,4.03,4.09c0.8,1.11,2.19,3.07,3.76,5.4 c2.39,3.69,4.97,7.95,6.05,9.74c0.24,0.44,0.46,0.86,0.68,1.28c-1.23,0.69-6.58,3.91-10.43,9.42 c-6.28-1.06-6.93-9.05-8.57-12.08c-3.47-6.43-7.67-8.41-6.68-13.36c0.99-4.95-7.92-15.1-10.39-21.78 c-2.47-6.68,2.35-24.24,0.54-19.08c-0.38,1.09-0.86,2.07-1.39,2.95c1.08-2.08,1.34-3.77,1.34-3.77 c-8.31,9.48-10.76-0.34-12.44-5.08c-1.69-4.78-2.81-8.16-2.81-4.5c0,3.66,2.25,11.54-1.69,5.35 c-3.94-6.19-13.79-15.47-19.69-23.63c-5.6-7.73-9.08-13.8-9.44-14.42c-0.02-0.03-0.03-0.06-0.03-0.06 c-0.2,0.35-0.4,0.7-0.61,1.05c-0.75,1.25-1.57,2.47-2.39,3.61l1.12-1.74l1.71-2.65c-1.86,1.17-3.22,1.34-6.89-1.32 c-3.38-2.45-9.91-1.12-13.22-2.55c-3.44-1.48-10.21,0.06-13.62-0.75c-0.4-0.1-0.61-0.25-0.71-0.41 c0.17-0.96,0.76-1.99,1.99-2.32c1.37-0.37,3.45-0.08,4.46-0.09c0.39,0,0.6-0.06,0.66-0.15c-0.04,0.02-0.08,0.04-0.12,0.06 c0,0,0.28-0.32-0.75-0.46c-0.07-0.01-0.16-0.02-0.24-0.03c-1.09-0.13-2.97-0.28-3.77-0.45c-0.86-0.18-1.04,0.12-1.59,0.15 c-0.71,0.04-0.98-0.47-1.06-0.67c-0.13-0.17-0.26-0.37-0.41-0.63c-1.02-1.82,0.71-3.11,0.71-3.11s-0.17,0-0.41-0.14 c-0.65-0.32-0.84-1-0.84-1c-0.96-1.92,1.47-3.92,1.47-3.92s-0.01-0.01-0.02-0.03c-0.58-0.87-0.71-1.94-0.35-2.93h0 c0,0-0.92,1.99-0.77,3.07s-1.69,2.45-1.07,3.99c0.61,1.53-0.46,2.61,0.31,4.3c0.77,1.69,1.23,3.68,0.92,5.06 c-0.05,0.24-0.03,0.58,0.07,0.96c0.03,0.21,0.1,0.41,0.21,0.61c0.72,1.73,2.71,3.95,5.86,3.95c4.3,0,5.98,1.69,7.52,2.91 c1.53,1.23,5.52,2.45,7.67,1.99c2.15-0.46,4.14,4.14,5.52,6.14c0.22,0.31,0.53,0.7,0.92,1.12l2.36,4.31c0,0,0.93,2,2.72,4.96 c0.87,1.45,1.95,3.12,3.24,4.91c3.43,5.91,7.46,12.27,11.42,17.14c9.95,12.26,19.09,15.61,26.1,15.67 c0.42,0.85,0.89,1.74,1.41,2.69c3.44,7.43,8.24,16.78,16.32,34.26c7.56,16.34,11.23,28.57,11,40.71c0,0,3.08-7.87,0.37-17.47 c0,0,0.01,0.01,0.02,0.03l2.76,6.01c1.56,4.54,2.98,11.46,1.84,20.22c-2.07,15.94,2.12,3.59,3.53-11.22 c0.96-10.03-1.33-13.75-2.9-15.1c2.46,1.57,7.58,5.72,8.91,13.67c1.76,10.57,6.5-12.92-5.84-15.39 c-12.34-2.47,0.18-7.15,10.04-2.92c0,0,2.11-4.23-7.4-3.88c-9.52,0.35,4.93-8.46,10.93-11.28c5.69-2.68-6.54-0.62-13.23,6.45 c0.68-0.8,1.4-1.59,2.15-2.35c1-1.01,2.05-1.96,3.15-2.82c-0.09,0.08-0.17,0.15-0.25,0.23c-0.1,0.1-0.19,0.18-0.26,0.26 c-2.07,2.19,7.1-3.06,9.27-6.43c0.25-0.39,0.57-0.93,0.94-1.58c0.77-1.36,1.76-3.2,2.8-5.17c2.35-4.48,4.95-9.63,5.81-11.34 c2.87-3.48,5.49-4.08,7.63-4.75c3.67-1.17,11.94-1.24,11.94-1.24c-0.52-0.19-1.35-0.49-2.39-0.81 C236.7,525.99,236.07,525.98,234.07,525.37z M113.7,466.44c-0.05,0.06-0.1,0.11-0.14,0.15c-0.01-0.12-0.02-0.24-0.02-0.37 C113.59,466.3,113.65,466.37,113.7,466.44z M155.69,508.76c0.28-0.03,0.55-0.07,0.82-0.11c1.21-0.2,2.31-0.5,3.28-0.89 c-0.93,0.47-1.53,0.68-1.53,0.68S157.43,508.86,155.69,508.76z M190.3,577.79c0.45,0.9,1.01,2.12,1.56,3.64 C191.47,580.52,190.94,579.29,190.3,577.79z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M179.55,480.35c0.73-3.19,1.4-21.36,0.43-25.23c-1,2.63-2.2,5.46-3.59,8.52 c-0.27,0.59-0.51,1.2-0.73,1.82c-0.18,0.56-0.36,1.12-0.54,1.69c-2.4,8.34-1.8,19.03-4.84,27.08 c12.09-8.38,24.76,2.21,34.47,8.72c9.93,6.66,13.49,6.75,11.42,5.96c-2.07-0.79,3.47,2.43-12.41-9.64 c-18.06-13.73-18.87-11.37-18.72-16.3c0.02-0.81,0.34-6.06,2.51-11.04C189.13,468.33,178.62,484.42,179.55,480.35z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.9,653.73c-1.35-32.43,5.05-37.57,5.05-37.57c-10.78-20.36-51.16-85.64-50.56-104.81 c0.6-19.17-4.79,11.98-4.19,27.55c0.6,15.57-7.19-9.58-9.58-23.96c-2.4-14.37,2.99,17.97,3.59,24.56 c0.6,6.59-7.79-7.79-15.57-9.58c-7.79-1.8,9.73,15.43,15.12,34.6c5.39,19.17,7.84,24.71,6.04,48.67 c-1.8,23.96,46.26,40.53,25.9,52.51c-20.36,11.98-66.12,17.27-85.89,17.27s27.45,16.94,58.6,6.76s4.53,14.31-32.6,16.1 c-34.67,1.68,30.39,14.32,6,16.48c-0.92-0.22-1.98-0.46-3.19-0.71c-30.04-6.16-68.15-16.58-56.22-36.97 c9.98-17.06,5.13-35.09-7.12-70.66c-1.11-3.21-2.29-6.58-3.54-10.07l0.27,0.27c-0.43-1-0.85-2.02-1.27-3.05 c-1.53-4.25-3.13-8.65-4.78-13.13c-6.59-20.1-11.43-43.5-15.1-64.91c-4.5-26.26-4.11-25.73-2.11,3.07 c0.55,7.88-1.72,7.94-4.19,3.72c-0.23-0.64-0.45-1.27-0.68-1.9c-2.42-10.25-4.23-17.32-4.4-16.37c-0.04,0.2,0,0.76,0.12,1.73 c0.41,3.29,1.09,6.38,1.89,9.08c0.42,1.39,0.86,2.68,1.33,3.84c1.07,3.82,2.49,8.97,4.04,14.87c0.17,0.65,0.35,1.32,0.52,1.99 c2.68,11.76,5.52,24.48,7.56,33.71c1.18,5.34,2.1,9.51,2.57,11.66c0.41,2.51,0.75,4.91,1.02,7.15 c2.86,24.06,6.67,42.95,8.98,67.86c0.26,2.78,0.49,5.63,0.71,8.57c0.11,1.44,0.21,2.89,0.3,4.37 c1.87,29.22-1.47,41.79-1.47,41.79s5.84,0.76,14.86,2.48c2.04,0.39,4.23,0.82,6.56,1.31c6.65,1.39,17.81,2.49,28.6,3.12 c3.16,0.18,6.28,0.32,9.25,0.42c4.22,0.56,9.92,1.11,15.84,1.55c7.48,0.55,15.33,0.92,21,0.92c3.29,0,6.67-0.07,10.03-0.18 c17.38-0.58,34.14-2.38,34.26-2.39C119.78,722.4,132.48,691.83,130.9,653.73z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.55,466.76c3.84,4.48,4.9,7.04,5.33,8.74c0.43,1.71,0.61-1.35-1.49-4.26 c-2.1-2.92,1.33-0.23,3.04,1.87c1.71,2.1,2.63-1.18-1.58-3.28c-2.07-1.04-5.94-4.29-9.32-7.33 C152.95,463.91,154.38,465.4,155.55,466.76z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.53,462.5c-3.23-3.2-6.42-5.98-6.42-5.98S148.06,459.4,151.53,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.6,452.68l5.51,3.85c0,0,0.3-2.88,0.69-6.95c0.39-4.06,4.16-14.66,3.87-14.13 c-0.72,1.32-2.08,3.66-3.54,6.42c-0.89,1.68-1.82,3.52-2.65,5.38c-0.5,1.11-0.98,1.99-1.42,2.7 C140.63,452.22,139.6,452.68,139.6,452.68z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M221.93,380.66c-1.02,0.2-2.16,0.09-2.92-0.04c1.48,1.18,2.47,1.97,2.77,2.23 c6.19,5.34,10.16,6.05,10.67,6.2c0.11,0.03,0.23,0.04,0.33,0.03c0.12,0.1,0.25,0.2,0.38,0.28c0.36,0.21,0.45-0.09,0.3-0.3 c-0.11-0.15-0.2-0.27-0.28-0.36c0.03-0.22-0.05-0.53-0.31-0.96c-0.71-1.16-1.89-3.18-7.21-8.03c-0.31-0.28-0.71-0.55-1.13-0.86 C224.14,379.94,223.08,380.43,221.93,380.66z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M114.7,320.06c-0.96,1.42-2.16,5.87-2.16,5.87s1.82-1.62,3.47-3.15c0.23-0.22,0.43-0.49,0.59-0.79 c0.77-1.41,0.8-3.46,0.17-3.22c-0.04,0.01-0.08,0.03-0.12,0.06C116.65,318.84,115.66,318.64,114.7,320.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M114.3,326.02c0,0-1.79,1.72-2.79,3.76c-0.06,0.08-0.12,0.17-0.17,0.26c0,0,0.01,0.01,0.04,0.03 c-0.02,0.05-0.04,0.08-0.04,0.08c0.01-0.03,0.02-0.05,0.04-0.08c0.19,0.15,1.07,0.84,1.63,0.76c0,0,0.47-1.49,0.41-2.54 c0.28-0.11,0.58-0.21,0.93-0.28c0.02,0,0.04-0.01,0.06-0.01c2.39-0.46,1.96-0.66,1.96-0.66s-1.11-0.07-1.67-0.03 c-0.15,0.01-0.26,0.03-0.3,0.06C114.18,327.5,114.3,326.02,114.3,326.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M117.5,353.71c-1.34-2.07-1.21-6.38-2.04-9.33c-0.83-2.95-2.12-5.53-2.69-10.3 c0.07,2.52-0.33,4.8,1.59,10.53c1.92,5.73,1.97,8.8,1.84,14.43c0,0,0.64-0.56,1.48-1.15c0.1-0.07,0.21-0.13,0.33-0.2 c0.88-0.52,2.07-1.09,3.47-1.45C124.07,355.55,118.84,355.78,117.5,353.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M79.76,363.01c0,0-9.22-9.95-9.95-18.61C69.81,344.4,70.85,359.77,79.76,363.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M76.15,330.62c2.71,0.55,4.73,4.14,2.16,7.27s-3.49,4.48-4.06,6.89s1.17,4.63,1.17,4.63 s0.36-1.85,0.94-4.08c0.58-2.23,3.29,0.81,5.89-1.95c2.6-2.77,0.81-10.25-0.24-11.98c-1.05-1.73-3.08-4.47-7.12-3.4 c-4.03,1.07-4.92,5.87-5.79,9.22C69.1,337.22,72.35,329.86,76.15,330.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M78.94,348.39c-1.17,1.37,2.1,6.55,3.82,8.59c1.72,2.04,3.36,0.08,1.52-3.4 c-1.84-3.48-0.62-4.31,0.25-6.2s-0.07-2.36-0.07-2.36C82.64,347.89,80.12,347.02,78.94,348.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M200.89,366.52c-2.83-1.76-3.32-0.49-2.83,1.27c0.49,1.76,2.25,3.62,1.47,3.81 c-0.78,0.2-3.91,1.37-2.44,1.17c0.13-0.02,0.28-0.04,0.44-0.06c1.37-0.46,3.02-0.88,5.03-1.04c0.53-0.04,1.01-0.08,1.45-0.12 c1.07-0.14,2.26-0.25,2.92-0.3c-1.82-1.45-3.7-2.95-5.59-4.45C201.18,366.71,201.03,366.61,200.89,366.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M206.92,371.25c0.03,0.02,0.05,0.04,0.08,0.06c1.45-0.13,2.28-0.28,3.83-0.69 c0.67-0.18,1.35-0.34,2.01-0.48c-3.54-2.72-7.38-5.66-11.08-8.51c-9.74-7.48-18.59-14.28-18.88-14.51c-0.66-0.5-0.6,0.2-0.81,0 c-0.2-0.2-2.12-1.81-3.18-0.71c-1.06,1.11,1.51,2.87,1.71,3.08c0.2,0.2-0.54,0.44-0.15,0.7c0,0,4.56,3.63,10.66,8.47 c3.14,2.5,6.68,5.31,10.22,8.13C203.22,368.31,205.1,369.8,206.92,371.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB9996",
    d: "M141.34,432.68c-0.43,1.18-0.9,1.39-2.06,2.11c-1.16,0.72-2.04,1.22-2.88,1.97 c-0.84,0.75-0.35,1.7-1.58,2.42c-1.22,0.72-1.32,1.03-1.83,2.33c-0.51,1.3-0.55,1.68-1.57,2.29c-1.02,0.61-1.41,0.71-1.63,1.58 c0.71-0.85,0.95-0.83,1.5-1.14c0.55-0.31,0.95-0.29,1.77-0.79s2.54-0.11,3.61-0.87c2.49-1.77,3.94-3.6,4.7-5 c0.74-1.36,0.46-3.31,0.48-4.14c0.02-0.83,0.76-2.62,0.76-2.62C142.07,431.14,141.78,431.5,141.34,432.68z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.15,430.72c-1.57-0.6-2.06-1.43-1.83-0.91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.06,444.81l0.09,0.23l-0.04,0.04c0,0,0.01-0.06,1.11-0.77c1.29-0.83,1.76-0.73,2.04-1.46 c0.28-0.72,0.31-0.93,1.89-2.07s1.9-1.68,2.8-3.39c0.9-1.72,2.14-1.82,3.04-2.92c0.86-1.06,0.96-2.4,1.2-3.28 c0.01-0.03,0.02-0.07,0.03-0.1c0,0-0.04,0.07-0.11,0.17c-0.15,0.25-0.43,0.71-0.62,1.05c-0.04,0.08-0.08,0.16-0.12,0.25 c-0.19,0.41-0.32,0.86-0.61,1.22c-0.15,0.19-0.55,0.41-1.08,0.78c-0.72,0.49-1.57,1.02-2.22,1.42c-0.17,0.11-0.37,0.23-0.51,0.32 c-0.63,0.42-0.93,0.81-1.06,1.21c-0.03,0.09-0.05,0.18-0.07,0.28c-0.07,0.35-0.16,0.57-0.32,0.77c-0.15,0.19-0.36,0.36-0.66,0.61 c-0.13,0.11-0.4,0.24-0.54,0.35c-0.41,0.32-0.7,0.63-0.99,1.17c-0.07,0.14-0.14,0.28-0.2,0.45c-0.02,0.04-0.03,0.09-0.05,0.13 c-0.33,0.97-0.46,1.32-0.75,1.79c-0.19,0.3-1.32,0.94-1.84,1.32C130.1,444.65,130.08,444.85,130.06,444.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M129.08,436.45c-0.92,0.2-1.78,0.52-2.39,1.45c-0.68,1.03,0.05,0.78,0.75,0.2 c0.52-0.43,1.32-1.15,1.71-1.51C129.21,436.54,129.16,436.44,129.08,436.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M131.74,431.7c-0.82,0.52-1.36,1.85-1.32,2.9c0,0.07,0.09,0.08,0.12,0.03c0.21-0.43,0.71-1.39,1.31-2.02 C132.63,431.78,132.63,431.14,131.74,431.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M124.84,439.67c-0.44-0.18-0.76-0.59-0.91-1.06c-0.07-0.21-0.11-0.53-0.22-0.81 c-0.11-0.28-0.25-0.56-0.44-0.79c-0.38-0.47-0.85-0.8-1.34-1.09c0.33,0.46,0.72,0.88,0.98,1.34c0.13,0.23,0.24,0.46,0.3,0.71 c0.08,0.25,0.1,0.49,0.19,0.82c0.19,0.6,0.66,1.15,1.31,1.3c0.32,0.08,0.65,0.04,0.93-0.06c0.28-0.12,0.52-0.3,0.71-0.51 c-0.27,0.11-0.52,0.21-0.78,0.24C125.32,439.79,125.06,439.76,124.84,439.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M131.36,429.92c0.49-0.01,0.98,0.18,1.28,0.54c0.15,0.18,0.26,0.41,0.31,0.67 c0.05,0.26,0.03,0.53,0.01,0.82c0.14-0.25,0.24-0.53,0.27-0.83c0.02-0.3-0.05-0.63-0.22-0.91c-0.34-0.57-1.02-0.85-1.64-0.85 c-0.34,0.01-0.57,0.07-0.84,0.07c-0.26,0.01-0.51-0.02-0.77-0.07c-0.51-0.11-1.03-0.35-1.57-0.52c0.43,0.37,0.88,0.73,1.45,0.94 c0.28,0.11,0.59,0.16,0.89,0.18C130.82,429.97,131.15,429.91,131.36,429.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M128.73,410.14c1.94-1.55,2.7-2.54,2.7-2.54s-1.84-0.03-5.71,3.57c-3.87,3.6-5.34,8.28-4.38,6.91 C122.71,416.15,125.65,412.6,128.73,410.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M126.58,422.01c0.03,0.09,0.06,0.18,0.1,0.27c0.05-0.17,0.1-0.35,0.15-0.52 c0.08,0.07,0.15,0.16,0.19,0.25c0.02-0.18,0.07-0.35,0.17-0.51c0.04,0.07,0.11,0.14,0.19,0.18c-0.01-0.17,0.04-0.34,0.12-0.48 c0.08,0.17,0.21,0.33,0.37,0.43c0-0.23,0.03-0.46,0.09-0.68c0.1,0.12,0.2,0.23,0.31,0.35c0-0.21,0.01-0.42,0.01-0.63 c0.1,0.13,0.2,0.25,0.3,0.38c-0.02-0.21-0.04-0.42-0.06-0.63c0.14,0.2,0.3,0.38,0.49,0.54c-0.06-0.35-0.11-0.7-0.14-1.06 c0.37,0.17,0.72,0.47,0.99,0.76c-0.26-0.34-0.47-0.72-0.64-1.13c0.01-0.01,0.02-0.02,0.03-0.02c0.34,0.26,0.68,0.52,1.02,0.78 c-0.26-0.34-0.46-0.74-0.57-1.16c0,0,0.01-0.01,0.01-0.01c0.28,0.16,0.55,0.32,0.83,0.48c-0.17-0.26-0.3-0.55-0.4-0.85 c0.03-0.03,0.06-0.06,0.1-0.09c0.23,0.11,0.47,0.19,0.72,0.22c-0.17-0.15-0.29-0.34-0.38-0.56c0.05-0.05,0.1-0.11,0.15-0.17 c0.18-0.03,0.36-0.05,0.54-0.08c-0.1-0.07-0.19-0.16-0.27-0.25c0.02-0.03,0.05-0.06,0.07-0.09c0.46,0.05,0.6,0.13,1.13-0.04 c-0.46-0.08-0.71-0.17-0.89-0.29c0,0,0,0,0,0c0.52-0.02,1.04-0.14,1.53-0.36c-0.41-0.03-0.82-0.06-1.23-0.09 c0.02-0.03,0.03-0.05,0.05-0.07c0.43-0.09,0.84-0.22,1.24-0.41c-0.32,0.04-0.65,0.03-0.97-0.04c0.08-0.14,0.16-0.29,0.25-0.45 c0.2-0.1,0.4-0.22,0.59-0.35c-0.14,0.01-0.27,0.01-0.41,0c0.04-0.09,0.09-0.19,0.13-0.28c0.29-0.12,0.58-0.27,0.85-0.45 c-0.22,0.01-0.44,0.01-0.65,0.02c0.02-0.05,0.05-0.11,0.07-0.16c0.15-0.08,0.28-0.19,0.4-0.31c-0.09,0-0.18,0-0.27,0 c0.04-0.1,0.09-0.21,0.13-0.32c0.07-0.05,0.13-0.1,0.2-0.16c-0.04-0.02-0.08-0.04-0.11-0.05c0.01-0.03,0.02-0.06,0.03-0.09 c0.03-0.01,0.05-0.03,0.08-0.04c0.15-0.06,0.31-0.12,0.46-0.17c-0.13,0.02-0.26,0.05-0.39,0.09c0.11-0.02,0.2-0.08,0.27-0.17 c-0.07,0.01-0.15,0.02-0.22,0.03c0.21-0.15,0.4-0.34,0.56-0.55c-0.16,0.07-0.31,0.14-0.47,0.21c0.17-0.12,0.32-0.26,0.46-0.4 c-0.12,0.02-0.24,0.07-0.34,0.14c0.17-0.12,0.31-0.28,0.42-0.46c-0.09,0.02-0.19,0.05-0.28,0.07c0.15-0.13,0.29-0.28,0.41-0.44 c-0.08,0-0.17,0.03-0.23,0.08c0.09-0.1,0.17-0.2,0.26-0.3c-0.04-0.03-0.1-0.03-0.14,0.01c0.06-0.08,0.13-0.16,0.19-0.24 c-0.04-0.04-0.12-0.02-0.15,0.03c0.18-0.33,0.28-0.7,0.29-1.08c0-0.07-0.02-0.16-0.08-0.17c-0.01,0-0.02,0-0.03,0 c0.02-0.11,0.02-0.18,0-0.18c-0.16-0.05-0.95,2.2-1.94,4.14c-0.99,1.95-1.92,3.28-3.69,4.96s-2.37,2.64-2.3,2.69 c0.01,0.01,0.06-0.02,0.12-0.06c0,0.15,0.07,0.32,0.08,0.45C126.5,422.29,126.53,422.15,126.58,422.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M128.39,422.11l-0.73,0.39c4.83-1.51,6.94-6.09,6.94-6.09C132.22,420.05,128.39,422.11,128.39,422.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M147.14,405.49c1.36,2.71,1.42,6.86,1.42,6.86C149.6,410.28,147.14,405.49,147.14,405.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M146.26,407.77c-0.45-0.27-0.75,0.3-1.57-0.34c0,0-0.09,0.26,0.39,0.72c0.48,0.47,0.84,0.57,1.11,1.85 c0.27,1.28,0.9,1.67,0.86,0.84S146.71,408.05,146.26,407.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M108.1,433.61c0.36,0.19,0.71,0.41,1.05,0.64c1.52-2.13,3.15-4,4.22-5.1 C114.44,428.05,110.89,429.88,108.1,433.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M117.19,434.32c-0.06-0.02-0.12-0.02-0.18,0.01c0.03-0.12,0.04-0.21,0.02-0.27c0,0-0.7,0.52-1.22,1.51 c-0.27,0.52-1,1.6-1.9,2.75c0.19,0.22,0.38,0.44,0.57,0.67c0.01-0.1,0.01-0.21,0.01-0.31c0.05,0.12,0.1,0.24,0.15,0.36 c-0.02-0.22-0.02-0.43,0.02-0.65c0.11,0.13,0.2,0.28,0.28,0.43c-0.01-0.23-0.02-0.46-0.03-0.69c0.06,0.08,0.12,0.16,0.18,0.25 c0-0.15,0-0.3-0.01-0.45c0.09,0.07,0.18,0.14,0.26,0.21c-0.02-0.19-0.04-0.38-0.06-0.57c0.11,0.08,0.21,0.16,0.32,0.25 c-0.03-0.17-0.07-0.35-0.1-0.52c0.11,0.1,0.21,0.2,0.32,0.3c-0.02-0.17-0.04-0.34-0.07-0.52c0.09,0.08,0.18,0.14,0.29,0.19 c-0.03-0.21-0.06-0.41-0.09-0.62c0.11,0.08,0.23,0.13,0.36,0.15c-0.1-0.13-0.19-0.26-0.29-0.39c0.16,0.05,0.3,0.11,0.44,0.2 c-0.07-0.12-0.14-0.24-0.21-0.36c0.09,0.05,0.19,0.11,0.28,0.16c-0.06-0.1-0.12-0.21-0.17-0.31c0.1,0.08,0.22,0.13,0.34,0.17 c-0.06-0.13-0.12-0.26-0.16-0.39c0.08,0.01,0.16,0.02,0.24,0.03c-0.08-0.11-0.18-0.2-0.29-0.27c0.14,0,0.28-0.02,0.41-0.06 c-0.07-0.04-0.15-0.07-0.23-0.08c0.09-0.11,0.23-0.16,0.37-0.14c-0.11-0.07-0.22-0.13-0.32-0.2c0.22-0.02,0.43-0.09,0.61-0.22 c-0.12-0.09-0.27-0.13-0.41-0.11c0.15-0.1,0.32-0.15,0.5-0.15c-0.16-0.04-0.33-0.06-0.5-0.06c0,0,0,0,0-0.01 c0.15-0.04,0.3-0.1,0.44-0.16c-0.11-0.01-0.22-0.02-0.34-0.04c0.18-0.01,0.36-0.01,0.54-0.02 C117.42,434.38,117.31,434.35,117.19,434.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M94.12,446.79l-4.75-0.76c-1.33,0.07-2.41-2.53-2.05-1.44c0.36,1.09,1.53,1.63,1.14,1.83 c-0.39,0.21-0.8,0.27-1.41-0.14c0,0,0.01,0.03,0.03,0.08c0.08,0.2,0.35,0.71,1.06,0.67c0.54-0.03,0.72-0.33,1.59-0.15 c0.8,0.17,2.68,0.32,3.77,0.45c0.09,0.01,0.17,0.02,0.24,0.03c1.03,0.14,0.75,0.46,0.75,0.46c0.04-0.02,0.08-0.04,0.12-0.06 C95.15,447.45,95.04,446.81,94.12,446.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M93.03,441.34c1.89,0.17,2.53,0.09,3.07,0.09l-3.72-0.62c-0.92-0.07-1.74-0.3-3.11,0.33 c-1.24,0.57-2.28,1.34-3.14,0.35c0,0,0.19,0.68,0.84,1c0.12,0.06,0.26,0.11,0.41,0.14c0.72-0.43,1.79-0.92,2.56-1.24 C90.71,441.06,91.14,441.18,93.03,441.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M94.42,435.21c1.09,0.26,3.53,1.03,4.19,1.38l-3.37-2.21c-0.95,0.06-2.81,0.1-3.57,0.55 c-0.76,0.45-2.44,1.53-3.19,1.98c-0.74,0.44-1.24-0.09-1.27-0.12c0,0.01,0,0.01,0.01,0.02c0.2,0.45,0.32,0.66,0.36,0.73 c0.01,0.02,0.02,0.03,0.02,0.03s0.9-0.51,2.45-1.4C92.45,434.81,93.59,435.01,94.42,435.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M229.76,509.81c-0.3,2.43-0.21,4.18-1.12,5.41c-0.9,1.23-2.11,2.08-2.46,4.11 c-0.42,2.41,0.15,4.4,0.37,5.97c0.02,0.17,0.09,0.21,0.11,0.35c4.19-2.11,8.42,0.28,11.53,0.9c0.07,0.01,0.14,0.03,0.2,0.04 c-1.23-2.09-2.73-4.32-3.38-6.29c-2.34-7.05-2.63-13.12-2.79-13.82c-0.24-1.06,0.07-1.99,2.16-2.81c2.09-0.83,4.15,0,4.15,0 c-4.87-2.5-6.13,1.25-5.81-0.08c0.31-1.28-0.05-1.38,0.46-2.13c0.02-0.03,0.03-0.05,0.05-0.08c0,0-0.62,0.39-0.87,1.24 c-0.25,0.84-0.4,1.81-1.01,2.82c-0.01,0.02-0.02,0.03-0.03,0.05C230.68,506.51,230.11,506.92,229.76,509.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M247.32,518.78c0.24,2.18,1.71-0.76,2.11-1.93c0,0-0.68-0.36-1.26-1.15c-0.38-0.52-0.72-1.23-0.78-2.15 C247.2,515.04,247.08,516.6,247.32,518.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M251.24,528.15c0.13,2.16,1.07-1.08,1.28-1.72c0.02-0.05,0.02-0.1,0.01-0.16 c-0.03-0.36-0.47-0.83-0.86-1.37c-0.24-0.34-0.46-0.7-0.55-1.09C251.14,524.91,251.17,526.89,251.24,528.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M61.61,366.33c3.88-25.06,1.57-38.29,11.87-41.69c9.26-3.05,12.57,9.12,13.72,16.62 c0.01,0.28,0.04,0.57,0.08,0.86c0.29,2.09,0.52,4.36,0.66,7.03c0.72,5.86,1.55,8.81,0.87,12.77c-0.18,1.03-0.47,1.8-0.85,2.37 c-0.08,2.19-0.19,4.55-0.34,7.14c-0.37,6.51-3.67,17.5-4.51,27.32c0.04-0.09,12.66-3.2,15.52-4.67c3.11-1.6,8.31-3.79,10.77-5.02 c3.08-1.55,4.16-6.02,4.39-6.04c0.03-0.97,0.02-1.63-0.1-2.08c0.3-0.59,0.56-1.43,0.73-2.54c0.05-0.33,0.17-0.86,0.33-1.53 c0.13-0.54-0.07-1.1-0.5-1.46c-0.03-0.03-0.06-0.06-0.09-0.1c-0.71-0.89-0.75-4.74-0.75-6.32c0-3.28,0.41-2.89,1.58-3.39 c0.14-0.06,0.27-0.11,0.39-0.15c0.92-0.3,1.42-0.2,1.87-1.53c0.03-0.08,0.05-0.13,0.07-0.15c0.14-2.27-0.13-4-1.17-4.42 c-0.03-0.01-0.05-0.02-0.08-0.03c-5.27,2.62-15.75-6.74-17.65-25.65c-0.29-2.84-0.6-5.13-0.93-6.98 c-0.09-4.41,0.15-9.08,1.2-13.77c4.07-18.09,5.28-6.31,13.28-13.03c0.57-0.48,1.17-1.05,1.82-1.73c0.56-0.6,1.06-1.25,1.5-1.94 c-0.46,2.77-1.43,4.88-2.32,6.33c-0.95,1.56-1.8,2.35-1.8,2.35s0.72-0.37,2.01-1.76c0.97-1.06,2.27-2.7,3.82-5.23 c2.87-4.67,3.01-9.9,1.48-14.1c1.4,2.04,2.16,3.57,2.16,3.57c-0.87-6.11-3.4-10.31-5.92-13.05c-0.38-0.71-0.79-1.4-1.23-2.07 c3.33,1.8,4.33,3.37,4.33,3.37c-2.84-5.53-7.49-9.13-13.23-10.84c-1.49-0.57-3.09-0.91-4.79-0.99c-0.23-0.01-0.44-0.03-0.66-0.04 c-0.11-0.01-0.23-0.01-0.34-0.02c-3.49-0.28-6.07-1.19-8.41-2.55c6.39,0.99,11.91,0.94,7.02-0.09 c-7.08-1.49-12.78-4.72-12.78-4.72l13.59,2.35c0,0-5.35-1.39-12.73-6.39c-7.36-4.98-19.17-7.69-24.57-7.3 c-10.38-0.6-20.65,4.9-37.21,5.46c-9.82,0.33-18.66,4.61-25.18,11.22c-4.99,4.43-10.58,10.83-13.33,20.09 c-3.63,12.21-4.95,18.48-4.95,18.48s3.79-9.73,6.16-15.16s-0.85,4.24-3.05,13.57c-2.21,9.33,0.85,27.99,0.85,27.99 s-1.86-14.49,3.65-28.99c-1.45,7.71-4.21,19.63-2.48,35.53c0.47,4.29,1.34,8.2,2.42,11.77c0.31,1.03,0.64,2.03,0.98,3 c2.99,8.54,6.9,15,8.52,20.16c-1.18-4.16-4.83-17.14-7.19-25.79c-0.32-1.17-0.5-2.46-0.59-3.83c2.31,9.08,5.35,17.26,8.09,24.06 c3.75,9.3,6.64,22.68,7.63,27.53C5.5,391.32,5.63,392,5.63,392C29.95,405.9,57.39,393.57,61.61,366.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M112.05,382.23c-1.76,0.08-3.51,0.45-5.16,1.1c0.39-0.74,0.77-1.48,1.16-2.22 c-1.13,0.88-2.26,1.77-3.39,2.65c0.36-0.68,0.72-1.36,1.08-2.04c-1.22,0.74-2.45,1.46-3.69,2.17c0.24-0.37,0.4-0.78,0.37-1.21 c-0.4,0.57-0.92,1.05-1.53,1.4c0.42-0.62,0.7-1.34,0.82-2.08c-0.5,1.34-1.53,2.47-2.82,3.09c0.6-0.87,1.21-1.75,1.81-2.62 c-1.31,1.42-2.63,2.85-4.05,4.16c0.59-0.84,0.99-1.81,1.17-2.82c-0.32,0.92-0.8,1.78-1.39,2.56c-0.01-0.05-0.01-0.11-0.02-0.16 c-0.04,0.04-0.08,0.08-0.12,0.12c0.02-0.1,0.03-0.2,0.05-0.3c-0.09,0.17-0.18,0.35-0.27,0.52c-0.08,0.08-0.17,0.17-0.25,0.25 c0.12-0.44,0.23-0.88,0.34-1.32c-0.32,0.43-0.69,0.82-1.1,1.15c-0.01-0.05-0.02-0.09-0.04-0.14c0.04-0.21,0.08-0.41,0.12-0.62 c-0.04,0.18-0.09,0.37-0.13,0.55c-0.05-0.24-0.06-0.5-0.01-0.74c-0.26,0.48-0.56,0.95-0.87,1.41c0.09-0.81,0.13-1.62,0.1-2.43 c-0.16,1.1-0.41,2.19-0.71,3.27c-0.03,0.04-0.06,0.08-0.09,0.12c0.15-0.67,0.19-1.37,0.13-2.06c-0.27,0.53-0.54,1.05-0.81,1.58 c-0.05-0.28-0.11-0.56-0.17-0.84c0.07-0.43,0.13-0.86,0.2-1.29c-0.12,0.22-0.23,0.44-0.34,0.66c-0.12-0.56-0.25-1.11-0.38-1.66 c-0.02,1.02-0.1,2.05-0.22,3.07c-0.12,0.34-0.23,0.67-0.32,1.02c-0.01-0.06-0.01-0.13-0.02-0.19c0.09-0.49,0.18-0.98,0.27-1.47 c-0.11,0.26-0.23,0.52-0.34,0.78c-0.05-0.54-0.11-1.08-0.16-1.62c0.05-0.26,0.1-0.52,0.14-0.77c-0.05,0.22-0.1,0.43-0.16,0.65 c-0.1-0.96-0.2-1.93-0.29-2.89c-0.01,0.3-0.03,0.6-0.04,0.89c-0.05-0.39-0.11-0.79-0.17-1.18c-0.1,0.88-0.23,1.76-0.39,2.64 c0.02-0.5,0.03-1,0.01-1.49c-0.16,1.05-0.38,2.1-0.65,3.12c-0.03-2-0.05-4-0.08-6c-0.31,2.49-0.74,4.97-1.25,7.42 c-0.05-0.19-0.1-0.38-0.15-0.56c0.02,0.34,0.04,0.67,0.06,1.01c-0.07,0.32-0.13,0.64-0.21,0.96c-0.09-0.34-0.18-0.68-0.27-1.02 c-0.01,0.79-0.28,1.57-0.76,2.2c-0.17-0.69-0.19-1.41-0.07-2.11c-0.36,0.87-0.57,1.81-0.61,2.75c0.17-1.81,0.06-3.65-0.31-5.43 c-0.05,3.4-0.83,6.5-1.62,9.85c-0.02,0.04-0.05,0.08-0.07,0.12l0.03-0.09c-0.21,0.38-0.4,0.77-0.59,1.16 c-0.1,0.19-0.19,0.39-0.28,0.58c-0.02,0.06-0.04,0.12-0.05,0.17c-0.14,0.34-0.28,0.68-0.4,1.03c-0.5,1.39-0.83,2.84-1.01,4.31 c-0.05,0.25-0.07,0.51-0.11,0.73c-0.11,0.63-0.19,1.27-0.25,1.91c-0.12,1.29-0.15,2.6-0.09,3.9c0,0.02,0,0.03,0,0.05 c0.04,0.72,0.1,1.44,0.19,2.15c0.05,0.36,0.1,0.73,0.16,1.09c0.06,0.33,0.2,0.72,0.2,1.04c0.01-1.02,0.02-2.05,0.04-3.07 c0.36,2.67,0.4,5.39,0.1,8.08c0.32-1.04,0.52-2.12,0.62-3.2c-0.27,2.99-0.11,6.01,0.49,8.95c-0.08-1.27-0.15-2.54-0.23-3.81 c0.27,2.54,1.27,4.99,2.84,7.01c0.16,0.34,0.34,0.67,0.51,1c0.05,0.09,0.09,0.18,0.14,0.26c-0.08-0.1-0.16-0.19-0.24-0.29 c-0.12-0.14-0.24-0.28-0.36-0.43c0.1,0.14,0.19,0.27,0.29,0.41c0.82,1.16,1.65,2.33,2.47,3.49c0.17-0.13,0.35-0.26,0.53-0.4 c-1.31-2.03-2.45-4.21-3.53-6.36c0-0.01,0-0.01-0.01-0.02c1.12,2.14,2.39,4.21,3.8,6.18c0.03-0.02,0.06-0.05,0.1-0.07 c-1.96-3.23-3.23-6.87-4.47-10.45c1.22,2.66,2.65,5.22,4.26,7.66c-1.15-2.61-2.2-5.25-3.15-7.93c0.66,1.37,1.43,2.69,2.3,3.94 c-0.36-0.99-0.72-1.99-1.08-2.98c0.41,0.7,0.83,1.4,1.24,2.09c-1.64-4.07-2.57-8.42-2.74-12.8c1.26,4,2.96,7.86,5.06,11.49 c-2.22-5.09-2.3-6.56-3.49-11.98c1.56,3.68,1.69,3.44,3.66,6.91c-1.3-4-2.49-8.04-3.57-12.11c0.93,2.49,3.12,8.71,4.53,10.95 c-1.68-4.28-1.84-6.52-2.39-8.04c0.48,1,1.06,1.94,1.75,2.81c-0.22-1.02-0.44-2.04-0.66-3.06c0.53,0.8,1.07,1.59,1.6,2.39 c-0.07-2.46-0.74-4.89-1.94-7.04c1.13,2.12,2.27,4.24,3.4,6.36c-0.78-2.83-1.56-5.65-2.33-8.48c0.68,1.59,1.45,3.14,2.32,4.63 c0-1.04-0.15-2.07-0.43-3.07c0.23,0.42,0.52,0.81,0.86,1.15c-0.03-0.95-0.16-1.91-0.4-2.83c0.17,0.48,0.44,0.93,0.78,1.31 c0.02-1.03,0.75-3.85,0.77-4.88c0.3-0.85-0.12,0.09,0.17-0.76c0.12,0.91-0.27,4.29,0.61,4.02c-0.21-0.88,1-4.47,0.79-5.36 c0.81,0.58,1.3,2.64,1.86,4.33c-0.13-0.49,0.53-4.69,0.11-4.96c0.98,0.57,2.17,1.16,2.53,3.11c0.15-0.55,0.59-4.04,0.08-4.28 c1.82,0.62,6.66-0.41,8.38-1.29c-0.98-0.38-4.55-0.32-4.9-1.32c2.86,0.57,6.49,0.01,10.24,1.73c-0.14-0.4-1.62-1.82-2.36-2.25 c1.35,0.54,1.74,0.54,3.3,0.97c2.49,0.69,5.15,1.4,5.15,1.4s-1.98-1.29-3.64-2.34c1.41,0.6,3.07,1.07,3.93,1.19 c2.17,0.29,3.56,0.06,4.87,0.04l-0.49,1.08c2.96,1.5,5.54,3.72,7.47,6.41c-0.43-1.12-1.03-2.17-1.77-3.1 c1.17,1.15,2.34,2.31,3.51,3.46c-0.63-0.66-1.12-1.46-1.42-2.32c1.1,1.07,2.21,2.15,3.31,3.22c-0.54-0.71-0.94-1.52-1.16-2.39 c1.43,1.56,2.82,3.16,4.15,4.8c-0.38-1.11-0.76-2.21-1.13-3.32c0.99,1.2,1.97,2.39,2.96,3.59c-0.15-0.53-0.3-1.05-0.44-1.58 c0.4,0.59,0.8,1.13,1.24,1.63c0.35,1,1.09,2.55,1.82,2.95c0.94,0.52,0.9-0.74,1.39-0.13c0.49,0.6,0.87,1.12,0.87,1.12 s-0.07-0.88-0.59-1.55c-0.52-0.66-0.92-0.96-1.92-1.59c-0.19-0.12-0.34-0.26-0.48-0.41c-0.06-0.07-0.11-0.15-0.17-0.22 c-0.44-0.66-0.5-1.47-0.22-1.83c0.55-0.7,2.4,1.13,2.4,1.13c-0.73-0.91-1.72-2.25-2.63-2.08c-0.61,0.12-0.76,0.65-0.76,1.18 c-0.45-0.6-0.9-1.2-1.35-1.78c-0.05-0.07-0.11-0.14-0.16-0.21c-0.08-0.11-0.16-0.21-0.24-0.32c-1.27-1.65-2.49-3.03-4.07-4.46 c-0.91-0.82-1.89-1.55-2.92-2.21c-2.41-3.17-5.09-6.18-8.7-7.77c0.51,0.39,1.02,0.77,1.52,1.16c-2.09-1.16-2.3-1.36-3.09-1.61 c0.5,0.16-2.7-1.3-2.34-0.92c1.92,1.38-1.31-0.19-3.84,0.34c0.65-0.17,2.09-0.88,2.62-0.96c-1.68,0.13-3.37,0.25-5.05,0.38 c0.29-0.44,0.65-0.83,1.07-1.16c-0.79,0.08-1.58,0.17-2.37,0.25c-0.89,0.09-1.78,0.19-2.67,0.28 C111.43,382.94,111.74,382.59,112.05,382.23z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cloud-left",
    fill: "#E1D9C8",
    d: "M410.36,157.7c-26.87-2.99-30.39-23.19-57.19-17.2c-21.24,4.76-31.03-10.69-49.39,0.11 c-3.1,1.82-5.46,4.01-6.67,5.25c4.08,1.37,6.34,3.94,7.44,5.61c4.87-0.81,9.13,0.73,9.13,0.73c4.29-4.52,10.39-4.07,10.39-4.07 c-8.36,1.36-10.17,6.55-10.17,6.55c-11.29-5.2-19.88,4.29-19.88,4.29c2.56-4.51,6.13-6.52,9.52-7.31 c-6.76-4.75-14.81-7.14-26.17-4.11c-4.75,1.61-10.84,4.34-18.9,8.82c-13.39,7.44-51.68,11.52-79.85,12.29l271.57-3.91 C450.18,164.76,451.76,162.31,410.36,157.7z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "line",
    x: 439.58,
    y: 212.66,
    width: 1112.42,
    height: 13
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1131.8091 284.0464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "\u2026 und mit "), /*#__PURE__*/React.createElement("tspan", {
    x: 106.24,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "27px"
  }, "MINUS 53% "), /*#__PURE__*/React.createElement("tspan", {
    x: 247.08,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "sogar \xFCbertroffen!"))), /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1898,
    fill: "#1EBEE4",
    width: 150,
    height: 540.54
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "windpower_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1971.89,379.97C1971.89,379.97,1971.89,379.97,1971.89,379.97 C1971.89,379.97,1971.89,379.97,1971.89,379.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M2078.74,393.76c-0.18-0.01-0.37-0.02-0.57-0.04C2079,393.89,2079.24,393.86,2078.74,393.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M2025.05,369.48c0,0.01,0,0.03,0,0.04c0,0-0.64,0.3-1.7,0.3s-1.2-0.31-1.2-0.31 c-17.12,0.56-33.3,15.71-33.3,15.71s-7.75-5-16.96-5.24c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.01,0 c-0.07,0.05-0.6,0.77-3.17,0.77c-1.38,0-2.49-0.35-2.68-0.41c-13.1,1.95-21.63,11.11-29.84,13.68c0,0,7.64-2.4,21.25-3.37 c13.19-0.94,25.8,0.95,23.45-0.15c-2.36-1.1-7.21-3.94,3.66-2.34c10.99,1.61,17.91,6.26,26.5,7.17 c32.26,3.45,29.85-6.44,23.25-11.28c-13.71-10.05,4.84-7.91,19.12,0c9.85,5.46,19.37,9.2,24.74,9.68 c-2.39-0.48-9.78-2.61-19.19-9.48C2047.1,375.56,2039.26,369.73,2025.05,369.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1971.89,379.97C1971.89,379.97,1971.89,379.97,1971.89,379.97 C1971.89,379.97,1971.89,379.97,1971.89,379.97C1971.89,379.97,1971.89,379.97,1971.89,379.97c-0.2-3.63-1.47-49.1-1.78-60.19 c2.97,3.41,9.27,10.61,13.78,15.78l3.06-2.67c-3.01-4.82-6.66-10.67-7.75-12.53c-1.76-3.02-2.11-2.01-3.96-2.33 c-1.48-0.25-2.75-0.79-3.74-1.6c-0.22,1.4-1.43,2.47-2.9,2.47c-0.63,0-1.21-0.2-1.69-0.54l-0.92,61.95c0,0,0.01,0,0.03,0.01 c0.19,0.06,1.3,0.41,2.68,0.41C1971.29,380.74,1971.82,380.02,1971.89,379.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1970.9,314.14c1.13-3.33,4.72-13.9,7.2-21.21l-3.85-1.31c-2.66,5.02-5.88,11.11-6.95,12.99 c-1.73,3.04-0.68,2.83-0.02,4.59c0.51,1.37,0.69,2.71,0.51,3.95c0.26-0.08,0.54-0.12,0.82-0.12 C1969.53,313.04,1970.36,313.47,1970.9,314.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1980.51,285.83c0.79-2.32-1.37-3.36-2.62-1.05c-0.56,1.04-1.99,3.73-3.63,6.84l3.85,1.31 C1979.28,289.43,1980.22,286.68,1980.51,285.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1988.81,341.21c1.61,1.85,3.6,0.51,2.22-1.74c-0.61-1.01-2.23-3.59-4.1-6.58l-3.06,2.67 C1986.31,338.35,1988.22,340.53,1988.81,341.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1965.67,315.97c0-0.4,0.08-0.79,0.23-1.14c-3.66,0.75-14.33,2.92-21.75,4.44l0.81,3.98 c5.68-0.24,12.56-0.52,14.72-0.55c3.49-0.04,2.79-0.84,3.98-2.29c0.86-1.05,1.84-1.85,2.91-2.32 C1966.02,317.55,1965.67,316.8,1965.67,315.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1936.8,320.77c-2.4,0.49-2.22,2.88,0.42,2.79c1.18-0.04,4.23-0.17,7.74-0.31l-0.81-3.98 C1940.53,320.01,1937.68,320.59,1936.8,320.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1971.5,316.44c0.02-0.15,0.04-0.31,0.04-0.46c0-0.69-0.24-1.33-0.64-1.83 c-0.54-0.67-1.36-1.11-2.29-1.11c-0.29,0-0.56,0.04-0.82,0.12c-0.85,0.25-1.54,0.87-1.88,1.68c-0.15,0.35-0.23,0.73-0.23,1.14 c0,0.83,0.35,1.58,0.9,2.11c0.11,0.1,0.22,0.2,0.35,0.29c0.48,0.34,1.06,0.54,1.69,0.54 C1970.07,318.91,1971.28,317.84,1971.5,316.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M2023.35,369.81c1.06,0,1.7-0.3,1.7-0.3c0-0.01,0-0.02,0-0.04c-0.1-1.91-0.84-31.27-0.98-36.82 c-0.59,0.36-1.36,0.35-1.92-0.11c-0.2-0.16-0.35-0.37-0.45-0.59c-0.27,0.65-0.79,1.21-1.5,1.64c-0.77,0.47-1.11,0.09-1.35,1.75 c-0.15,1.03-0.73,4.29-1.2,6.99l1.85,0.64c0.87-2.52,2.03-5.84,2.82-8.11l-0.15,34.63 C2022.15,369.5,2022.29,369.81,2023.35,369.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M2017,346.01c-0.21,1.25,0.92,1.49,1.31,0.38c0.14-0.41,0.6-1.73,1.18-3.41l-1.85-0.64 C2017.35,344,2017.09,345.45,2017,346.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M2024.59,332.15c0.41,0.07,0.83,0.22,1.24,0.45c0.79,0.43,0.63,0.91,2.19,0.29 c0.96-0.39,4.08-1.53,6.65-2.47l-0.37-1.92c-3.13,0.61-7.47,1.45-9.68,1.88C2024.94,330.91,2024.94,331.6,2024.59,332.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M2038.16,329.13c1.19-0.45,0.83-1.54-0.33-1.32c-0.43,0.08-1.8,0.35-3.54,0.69l0.37,1.92 C2036.25,329.84,2037.63,329.33,2038.16,329.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M2021.9,330.2c0.15-0.18,0.32-0.32,0.51-0.42c-0.15-0.46-0.2-0.99-0.16-1.54 c0.07-0.9,0.58-0.95-0.63-2.12c-0.75-0.72-3.06-3.1-4.97-5.06l-1.6,1.12c2.22,3.16,5.63,8.06,6.5,9.31 C2021.49,331.05,2021.59,330.58,2021.9,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M2014.05,318.39c-0.89-0.9-1.75-0.13-1.07,0.84c0.25,0.36,1.05,1.5,2.07,2.95l1.6-1.12 C2015.47,319.85,2014.45,318.79,2014.05,318.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M2022.15,332.55c0.57,0.46,1.34,0.48,1.92,0.11c0.15-0.1,0.3-0.21,0.42-0.36 c0.04-0.05,0.06-0.1,0.09-0.14c0.36-0.55,0.35-1.24,0.02-1.78c-0.1-0.16-0.21-0.3-0.37-0.42c-0.54-0.43-1.26-0.48-1.83-0.17 c-0.19,0.1-0.37,0.24-0.51,0.42c-0.3,0.38-0.41,0.84-0.35,1.29c0.02,0.16,0.07,0.32,0.14,0.47 C2021.8,332.18,2021.95,332.38,2022.15,332.55z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2018.92,383.6c-4-7.63,5.26-8.54,10.77-9.67c4.17-0.85,5.26-2.52,2.1-3.38 c-2.26-0.61-4.52-0.94-6.75-1.03c-0.02,0.01-0.06,0.02-0.12,0.04c0.08-0.03,0.14-0.05,0.14-0.05l0-0.04l-0.97-36.83 c-0.33,0.21-0.71,0.29-1.09,0.25c-0.03,0.08-0.05,0.16-0.08,0.24c0.22,0.5,0.4,1.2,0.44,2.16c0.1,2.55,0.8,33.89,0.82,34.45 c-0.23,0.04-0.5,0.06-0.81,0.06c-0.84,0-1.1-0.2-1.18-0.28c-5.67,0.27-11.1,1.94-15.86,4.1c-10.26,4.66-17.46,11.57-17.46,11.57 c10.47,8.59,22.2,10.11,22.2,10.11C2019.58,395.18,2021.23,388.01,2018.92,383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1967.99,384.92c1.69-4.04,8-4.27,9.38-4.27c0.17,0,0.27,0,0.27,0c-1.05-0.21-2.06-0.36-3.05-0.47 c-0.1-0.01-0.2-0.02-0.3-0.04c-0.05-0.01-0.11-0.01-0.16-0.02c-0.76-0.08-1.51-0.12-2.25-0.14c0,0,0.01-0.01,0.01-0.01l0,0v0 l-0.94-30.13l-0.98-31.28c-0.41,0.22-0.88,0.34-1.37,0.34c-0.41,0-0.8-0.08-1.15-0.23c0.61,0.56,1.58,1.85,1.68,4.5 c0.15,3.89,1.03,57.13,1.03,57.44c0.13,0,0.24-0.02,0.35-0.03c-0.45,0.09-1.03,0.16-1.8,0.16c-1.31,0-2.37-0.31-2.65-0.4 c-1.64,0.25-3.2,0.62-4.71,1.06c-2.97,0.87-5.73,2.06-8.42,3.47c-1.84,0.96-3.66,2.03-5.49,3.16c-6.81,4.24-10,5.54-10.94,5.87 c-0.09,0.03-0.16,0.05-0.21,0.07c-0.07,0.02-0.11,0.03-0.11,0.03l9.14-1.98l1.71-0.37 C1958.02,389.9,1965.91,389.88,1967.99,384.92z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ix3"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1940.06,436.17c-12.52-12.86-26.01-28.04-62.49-30.73c-1.93-0.14-3.83-0.27-5.7-0.39l20.67,49.32 c0.16,0.01,0.31,0.03,0.44,0.04c6.74,0.61,53.78,6.02,59.2,6.39c5.42,0.37,6.31-3.59,6.31-3.59S1952.59,449.02,1940.06,436.17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1671.01,572.61c0,0-18.07,1-30.96,1.82c-13.59,0.87-54.62,4-25.89,10.83c4.21,1,30.73,7.29,60.29,12.15 c38.15,6.27,56.8,3.29,63.12,2.56c35.6-4.14,66.96-7.74,98.8-11.94c43.58-5.76,156.5-18.1,169.44-20.3 c12.95-2.2-8.09-6.2-43.33-9.19c-25.77-2.18-69.72-6.21-85.91-3.49C1844.94,560.36,1671.01,572.61,1671.01,572.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1978.29,549.41c1.82-0.76,45.4-13.85,45.4-13.85s8.17-48.02-14.53-46.48 C1986.46,490.61,1978.29,549.41,1978.29,549.41z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1791.22,561.72c0,0,62.96-0.62,73.25-2.15c10.29-1.54,11.81-65.87-26.64-66.49 C1799.39,492.46,1791.22,561.72,1791.22,561.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1839.29,507.13c8.73,0,24.56,9.84,22.84,42.35c-1.6,30.08-18.81,38.71-26.42,38.71 c-6.43,0-37.38-0.64-49.1-25.14c0,0,9.74-0.69,11.8-9.56C1800.68,543.73,1809.37,507.13,1839.29,507.13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1812.69,551.4c-0.59-7.4-3.21-15.3-4.73-20.64c0,0,10.15-25.79,31.96-22.18 c25.14,4.16,22.61,44.48,21.14,50.73c-1.86,7.91-6.76,27.17-24.69,28.72C1818.44,589.57,1813.36,559.82,1812.69,551.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0288 -0.9996 0.9996 0.0288 1237.7252 2368.449)",
    fill: "#FFFFFF",
    cx: 1837.7,
    cy: 547.27,
    rx: 33.37,
    ry: 20.72
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#191C1C",
    points: "1842.9,516.23 1844.87,528.78 1854.86,530.82 1857.01,544.31 1849.34,552.28 1851.99,567.54 1847.6,568.95 1844.62,575.94 1838.24,567.27 1829.39,576.29 1826.98,568.87 1822.45,567.78 1826.4,552.28 1818.27,544.56 1821.76,538.04 1821.38,530.09 1830.87,529.37 1834.17,515.98 1838.08,517.75  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1837.1694,
    y1: 577.0038,
    x2: 1838.0618,
    y2: 514.881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7515,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_)",
    strokeMiterlimit: 10,
    d: "M1834.17,515.98l-3.83,10.94l-8.97,3.16 c0,0-2.75,8.88-3.11,14.47l5.74,9.73l-1.55,13.5c0,0,2.51,5.72,6.94,8.51l8.01-5.47l7.17,5.47c0,0,5.14-4.5,7.41-8.76 l-0.48-13.13l5.5-10.09c0,0,0-7.42-2.15-13.5l-8.01-2.68l-3.95-11.92C1842.9,516.23,1840.03,514.52,1834.17,515.98z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1842.9,516.23 1841.35,533.61 1843.98,536.41 1854.86,530.82 1846.85,528.14  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1834.17,515.98 1832.86,533.01 1830.35,536.17 1821.38,530.09 1830.35,526.93  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1821.38,530.09l2.15,5.35l-2.03,7.78l-3.23,1.34C1818.27,544.56,1818.87,536.53,1821.38,530.09z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1854.86,530.82l-2.63,4.74l1.2,7.3l3.59,1.46C1857.01,544.31,1857.01,537.14,1854.86,530.82z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1857.01,544.31 1846.25,549.42 1845.05,554.28 1851.99,567.54 1851.51,554.41  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1851.99,567.54l-3.59-2.31l-3.71,4.38l-0.12,6.69C1844.57,576.29,1850.43,571.43,1851.99,567.54z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1844.57,576.29 1837.76,562.07 1835.13,561.46 1829.39,576.29 1837.4,570.82  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1829.39,576.29l0.96-6.2c0,0-4.42-4.86-4.54-4.5c-0.12,0.36-3.35,2.19-3.35,2.19 S1825.68,574.11,1829.39,576.29z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1822.45,567.78 1828.19,553.56 1827.48,548.93 1818.27,544.56 1824.01,554.28  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#191C1C",
    x1: 1851.51,
    y1: 554.41,
    x2: 1856.41,
    y2: 556.96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1846.85,
    y1: 528.14,
    x2: 1850.08,
    y2: 521.58
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1837.4,
    y1: 570.82,
    x2: 1837.4,
    y2: 579.21
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1824.01,
    y1: 554.28,
    x2: 1818.99,
    y2: 556.72
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1830.35,
    y1: 526.93,
    x2: 1826.64,
    y2: 521.45
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 1834.21,
    cy: 546.92,
    rx: 1.95,
    ry: 3.35
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1EBEE4",
    cx: 1834.21,
    cy: 546.92,
    rx: 1.27,
    ry: 2.19
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1653.63,544.54c0,0-1.89,33.51,39.91,33.51c29.94,0,30.51-31.21,30.51-31.21L1653.63,544.54z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1653.8,548.38l18.04,4.81c0,0,1.14,18.5,15.75,24.62C1687.59,577.8,1657.35,577.45,1653.8,548.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1653.7985,
    y1: 563.0912,
    x2: 1687.5896,
    y2: 563.0912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4606,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6335,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M1653.8,548.38l18.04,4.81c0,0,1.14,18.5,15.75,24.62 C1687.59,577.8,1657.35,577.45,1653.8,548.38z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1795.46,562.03c0,0-16.97,2.75-52.2,1.44c-29.23-1.09-118.12-11.39-121.56-26.9l139.61,7.43 L1795.46,562.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1720.2988,
    y1: 433.0746,
    x2: 1703.7274,
    y2: 597.4263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M1795.46,562.03c0,0-16.97,2.75-52.2,1.44c-29.23-1.09-118.12-11.39-121.56-26.9l139.61,7.43 L1795.46,562.03z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1EBEE4",
    points: "1828.15,404.7 1881.27,407.1 1897.54,455.5 1834.87,449.86 1828.32,445.82  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.63,
    fill: "#A1C8D9",
    points: "1828.15,404.7 1881.27,407.1 1897.54,455.5 1834.87,449.86 1828.32,445.82 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A59B91",
    points: "1946.88,459.65 1941.97,453.41 1905.28,452.85 1907.13,456.26 1947.16,460.9  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1946.27,459.88c0,0-15.69-21.55-26.89-31.08s-36.27-18.86-93.93-15.75l-0.36-8.64 c0,0,32.35-1.09,56.6,1.19c24.25,2.28,41.97,10.98,61.94,33.77c19.97,22.79,18.54,21.55,18.54,21.55 S1950.95,464.44,1946.27,459.88z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1642.9,438.45c-1.1,1.19-4.13,3.57,1.45,3.92c5.58,0.35,36.89,0.18,36.89,0.18s28.86,0,40.52-0.58 c11.66-0.58,31.57-0.58,35.41-5.78c3.84-5.21,8.39-13.59,8.39-13.59s-0.18-0.34-0.58-0.89c-1.75-2.42-7.71-8.94-21.03-8.94 c-16.35,0-61.43,0-66.12,0c-4.57,0-12.07,0.83-21.06,10.41c-0.23,0.25-0.47,0.5-0.7,0.76 C1646.75,434.24,1644,437.26,1642.9,438.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2017.8927,
    y1: 477.7417,
    x2: 2028.6198,
    y2: 488.4687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6582,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9675,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M2026.3,490.79c0,0,1.24-10.83-6.11-14.77c0,0-3.25,0.58-0.78,4.28 C2021.87,483.99,2026.3,490.79,2026.3,490.79z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2028.05,496.81c-0.95-5.46-2.05-6.9-2.05-6.9s-2.52-4.81-5.05-8.18c-2.52-3.37-3-5.13-0.63-5.78 c0,0-7.73-10.75-51.75-20.38c0,0-1.38,1.55-5.21,2.25c0,0-0.28,0.25-0.78,0.57c-0.55,0.35-1.38,0.78-2.37,1.04 c0,0-3.16,2.73-7.89,2.57c-4.73-0.16-62.64-6.74-62.64-6.74s-29.35-2.41-37.55-3.21c-8.2-0.8-24.45-5.46-32.34-7.86 c-7.89-2.41-23.03-8.02-26.66-9.15c-3.63-1.12-5.05-3.37-4.1-8.82c0.95-5.46,4.26-14.76,5.52-17.81 c1.26-3.05,11.2-5.13,17.99-5.62c6.78-0.48,42.44-2.57,65.79,0.32c23.35,2.89,37.93,8.07,52.59,22.48 c14.66,14.42,23.36,24.39,23.36,24.39l0.33-0.9l0.8-1.87c0,0-29.48-33.42-46.23-39.64c-16.75-6.22-44.46-11.3-67.82-12.45 c-23.36-1.15-59.59,1.75-59.59,1.75l-15.43,4.56l-23.84,50.2l47.4,41.07l24.12,3.71l25.24-9.7l23,9.7l8.13,28.81l109.38,1.14 l16.27-36.79l15.71-4.56l8.97,5.7l5.33,12.55l0.84,19.39l1-2.74C2027.89,519.91,2029,502.26,2028.05,496.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1685.6396,
    y1: 397.8848,
    x2: 1740.3888,
    y2: 397.8848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2783,
    style: {
      stopColor: "#FBFBFB",
      stopOpacity: 0.9172
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3622,
    style: {
      stopColor: "#F0F0F0",
      stopOpacity: 0.8372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#DCDCDC",
      stopOpacity: 0.7584
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    style: {
      stopColor: "#C1C1C1",
      stopOpacity: 0.6803
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    style: {
      stopColor: "#9E9E9E",
      stopOpacity: 0.6026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    style: {
      stopColor: "#737372",
      stopOpacity: 0.5253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.4498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.4
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M1685.64,401.03c0,0,12.5-7.58,54.75-6.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "1740.39,394.93 1690.32,401.48 1685.64,401.03  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1754.41,491.3c0,0-0.87,5.35-1.73,12.02c-0.68,5.33-1.14,10.16-4.71,11.32 c-3.57,1.16-17.84,4.06-23.26,4.21c-4.02,0.11-47.34-1.54-73.44-2.4c-9.07-0.3-16.05-0.5-18.59-0.5 c-9.85,0-10.84-3.34-11.7-6.53c-0.69-2.56-1.37-5.96-1.62-7.21c0,3.44,0,6.7,0,7.74c0,2.36-0.3,6.7-0.3,8.83 c0,2.13,0.45,6.7,0.45,6.7s0.85,1.97,7.62,2.62c2.65,0.26,16.85,1.14,33.74,2.12c26.28,1.53,59.06,3.29,64.85,3.29 c9.5,0,34.79-1.31,34.79-1.31s2.49-15.56,2.9-22.93C1763.95,499.49,1764.88,491.95,1754.41,491.3z"
  })), /*#__PURE__*/React.createElement("g", null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 1782.58,
    y1: 539.9,
    x2: 1761.42,
    y2: 537.89
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1762.22,531.36l-1.57-0.08c-0.09,0.58-0.14,0.91-0.14,0.91s-25.29,1.31-34.79,1.31 c-5.79,0-38.56-1.76-64.85-3.29c-16.89-0.98-31.09-1.86-33.74-2.12c-6.2-0.6-7.43-2.3-7.59-2.58l2.39,12.8 c0,0,10.81,3.9,31.89,5.01s82.4,5.01,93.21,5.01c10.81,0,13.41-2.51,13.41-2.51l0.98-7.95L1762.22,531.36z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M1623.74,527.72l-1.47,3.39c-0.04,0.08-0.14,0.11-0.22,0.06l-1.7-1.45c-0.04-0.03-0.06-0.07-0.06-0.11 c0,0-0.87-4.16-0.77-4.09c0.41,0.31,1.7,1.14,4.12,2C1623.73,527.55,1623.77,527.64,1623.74,527.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1619.5323,
    y1: 536.9328,
    x2: 1760.5066,
    y2: 536.9328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M1760.51,532.2c0,0-25.29,1.31-34.79,1.31c-5.79,0-38.56-1.76-64.85-3.29 c-16.89-0.98-31.09-1.86-33.74-2.12c-6.2-0.6-7.43-2.3-7.59-2.58l2.39,12.8c0,0,10.81,3.9,31.89,5.01s82.4,5.01,93.21,5.01 c10.81,0,12.53-2.08,12.53-2.08L1760.51,532.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1627.13,528.1c2.65,0.26,16.85,1.14,33.74,2.12c26.28,1.53,59.06,3.29,64.85,3.29 c9.5,0,34.79-1.31,34.79-1.31s0.05-0.33,0.14-0.91c0.54-3.44,2.41-15.72,2.76-22.02c0.54-9.78,1.47-17.31-9-17.97 c0,0-0.87,5.35-1.73,12.02c-0.68,5.33-1.14,10.16-4.71,11.32c-3.57,1.16-17.84,4.06-23.26,4.21 c-4.02,0.11-47.34-1.54-73.44-2.4c-9.07-0.3-16.05-0.5-18.59-0.5c-9.85,0-10.84-3.34-11.7-6.53c-0.69-2.56-1.37-5.96-1.62-7.21 c0,3.44,0,6.7,0,7.74c0,2.36-0.3,6.7-0.3,8.83c0,1.48,0.22,4.14,0.35,5.62c0.04,0.42,0.07,0.75,0.09,0.93 c0.01,0.1,0.01,0.15,0.01,0.15s0.01,0.01,0.02,0.04C1619.69,525.8,1620.93,527.5,1627.13,528.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1629.78,491.69l-0.11-14.27c0,0,0,8.74,0,11.84C1629.67,489.96,1629.71,490.79,1629.78,491.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1631.79,500.73c1.41,2.63,2.12,7.05,8.93,7.53c6.6,0.46,77.5,3.05,89.39,3.22 c5.46-4.92,7.11-14.62,8.16-19.74c1.45-7.04,3.54-11.79,3.54-11.79l2.88-0.04l0.08-0.36l-2.19-18.73c0,0-26.1,1.12-35.74,1.12 s-53.7-0.76-53.7-0.76l-6.54,8.28c0,0-11.32,2.25-11.08,2.25c0.24,0-5.86,5.71-5.86,5.71l0.11,14.27 C1630.03,494.79,1630.7,498.69,1631.79,500.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1640.72,508.26c-6.82-0.48-7.52-4.9-8.93-7.53c-1.09-2.04-1.77-5.95-2.02-9.05 c-0.07-0.9-0.11-1.73-0.11-2.43c0-3.11,0-11.84,0-11.84s-2.97,8.97-2.97,10.2c0,1.23,0.11,5.43,0.43,12.8s1.29,9.67,5.15,10.16 c3.87,0.49,77.8,3.93,89.89,3.93c2.54,0,4.66-0.7,6.44-1.86c0.53-0.35,1.03-0.74,1.51-1.16 C1718.22,511.32,1647.32,508.73,1640.72,508.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1744.7,479.91l-2.88,0.04c0,0-2.09,4.75-3.54,11.79c-1.05,5.12-2.7,14.82-8.16,19.74 c-0.47,0.43-0.97,0.81-1.51,1.16c-1.78,1.17-3.9,1.86-6.44,1.86c-12.08,0-86.02-3.44-89.89-3.93 c-3.87-0.49-4.83-2.78-5.15-10.16s-0.43-11.57-0.43-12.8c0-1.23,2.97-10.2,2.97-10.2l-4.32-0.07c0,0-3.97,8.3-4.79,10.21 c-0.82,1.9-1.2,3.27-1.2,4.8c0,0.85,0,5.5,0,9.85c0.24,1.24,0.93,4.65,1.62,7.21c0.86,3.19,1.85,6.53,11.7,6.53 s86.61,3.05,92.03,2.9c5.42-0.15,19.69-3.05,23.26-4.21c3.57-1.16,4.02-5.99,4.71-11.32c0.86-6.67,1.73-12.02,1.73-12.02 s6.1-8.74,13.99-11.68L1744.7,479.91z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M1779.16,458.41c-3.34-1.93-22.3-3.03-41-0.73c-14.04,1.72-22.48,3.61-25.81,4.43 c-0.83,0.21-1.25,1.17-0.83,1.93l3.07,5.65c0.22,0.41,0.64,0.67,1.1,0.68c2.16,0.07,8.45,0.31,10.46,0.99 c2.44,0.83,9.57,5.79,13,5.79c3.43,0,24.83,0,27.09,0c2.87,0,6.72-3.61,9.48-7.29c-4.23,0.14-29.12,0.91-34.16,0.74 c-5.52-0.19-8.23-1.62-11.31-2.57c-3.09-0.95-4.21-1.24-7.01-1.14c-2.27,0.08-5.28,0.22-6.34,0.27 c-0.23,0.01-0.45-0.13-0.54-0.35l-0.85-2.02c-0.14-0.34,0.07-0.73,0.44-0.79c4.98-0.73,34.97-4.87,64.85-2.86 C1780.97,460.07,1780.55,459.21,1779.16,458.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1731.29,466.76c-0.32,0.01-0.42,0.43-0.14,0.59c1.17,0.65,3.2,1.66,4.83,1.82 c1.39,0.14,3.8,0.16,4.66,0.16c0.17,0,0.31-0.14,0.31-0.31v-2.16c0-0.18-0.14-0.32-0.32-0.31L1731.29,466.76z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M1630.17,471.97c0.17,0.01,0.35-0.04,0.48-0.15l5.24-4.04c0.11-0.08,0.24-0.13,0.38-0.15l6.33-0.53 c0.28-0.02,0.52-0.21,0.61-0.47l0.94-2.56c0.16-0.44-0.12-0.92-0.58-0.98l-16.42-2.25c0.1,0.07,0.17,0.19,0.17,0.32l-0.2,7.82 c0,0.1-0.04,0.19-0.11,0.26l-2.11,2.14c-0.06,0.07-0.1,0.15-0.11,0.25l-0.01,0.12c0.13-0.09,0.29-0.14,0.46-0.13 L1630.17,471.97z M1630.2,465.54c0-0.16,0.14-0.29,0.29-0.27l4.05,0.41c0.24,0.02,0.33,0.34,0.13,0.49l-2.09,1.57 c-0.05,0.04-0.11,0.06-0.17,0.05l-1.96-0.09c-0.14-0.01-0.25-0.13-0.25-0.27V465.54z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1779.16,458.41c-3.34-1.93-22.3-3.03-41-0.73c-14.04,1.72-22.48,3.61-25.81,4.43 c-0.83,0.21-1.25,1.17-0.83,1.93l3.07,5.65c0.22,0.41,0.64,0.67,1.1,0.68c2.16,0.07,8.45,0.31,10.46,0.99 c2.44,0.83,9.57,5.79,13,5.79s24.83,0,27.09,0c2.87,0,6.72-3.61,9.48-7.29c-4.23,0.14-29.12,0.91-34.16,0.74 c-5.52-0.19-8.23-1.62-11.31-2.57c-3.09-0.95-4.21-1.24-7.01-1.14c-2.27,0.08-5.28,0.22-6.34,0.27 c-0.23,0.01-0.45-0.13-0.54-0.35l-0.85-2.02c-0.14-0.34,0.07-0.73,0.44-0.79c4.98-0.73,34.97-4.87,64.85-2.86 C1780.97,460.07,1780.55,459.21,1779.16,458.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1731.29,466.76c-0.32,0.01-0.42,0.43-0.14,0.59c1.17,0.65,3.2,1.66,4.83,1.82 c1.39,0.14,3.8,0.16,4.66,0.16c0.17,0,0.31-0.14,0.31-0.31v-2.16c0-0.18-0.14-0.32-0.32-0.31L1731.29,466.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1632.14,449.45c-0.84,0.54-1.15,1.09-1.15,1.61c0,0.73,0,1.37,0,1.93c0.02,0.04,0.03,0.09,0.03,0.15 v1.81c0,0.17,0.11,0.31,0.26,0.36l17.57,5.68c0.03,0.01,0.07,0.02,0.1,0.02l5.75,0.19c0.1,0,0.19,0.05,0.25,0.11 c0.12,0.13,0.15,0.33,0.03,0.49l-0.49,0.67l54.95-0.19c0.29-0.34,0.8-0.59,1.41-0.8c0.24-0.08,0.49-0.15,0.76-0.22 c8.12-2.11,25.89-4.46,30.34-5.07c0.63-0.09,1.21-0.4,1.64-0.89c1.41-1.62,3.54-3.51,4.8-4.59c0.1-0.09,0.2-0.17,0.3-0.25 c0.43-0.36,0.96-0.58,1.52-0.61c0.06,0,0.13-0.01,0.19-0.01c0,0-0.06-0.01-0.17-0.02c-2.5-0.35-32.24-4.36-71.38-4.36 C1646.46,445.45,1635.36,447.39,1632.14,449.45z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M1785.77,456.77c-6.46-4.23-17.8-6.84-35.35-6.93c-0.62,0-1.23,0.22-1.71,0.62 c-1.2,1.01-3.58,3.08-5.1,4.84c-0.42,0.49-1,0.81-1.64,0.89c-4.45,0.61-22.22,2.96-30.34,5.07c-0.26,0.07-0.52,0.14-0.76,0.22 c-0.61,0.21-1.12,0.46-1.41,0.8c-0.35,0.4-0.4,0.92,0.02,1.62l5.09,8.13c0.49,0.81,1.37,1.3,2.31,1.29 c0.61-0.01,1.36-0.01,2.14,0.03c0.41,0.02,0.83,0.05,1.24,0.09c0.53,0.02,0.9,0.07,1.16,0.15c0.7,0.12,1.33,0.28,1.83,0.51 c2.35,1.08,8.46,5.74,13.63,5.74c5.17,0,32.2,0,35.72,0s7.76-3.35,10.93-8.48C1786.71,466.21,1792.35,461.07,1785.77,456.77z  M1780.8,461.13c-29.88-2.01-59.88,2.13-64.85,2.86c-0.36,0.05-0.58,0.44-0.44,0.79l0.85,2.02c0.09,0.22,0.31,0.36,0.54,0.35 c1.06-0.05,4.07-0.19,6.34-0.27c2.8-0.1,3.93,0.19,7.01,1.14c3.09,0.95,5.8,2.38,11.31,2.57c5.04,0.17,29.93-0.61,34.16-0.74 c-2.76,3.68-6.61,7.29-9.48,7.29c-2.26,0-23.66,0-27.09,0s-10.57-4.96-13-5.79c-2.01-0.68-8.29-0.92-10.46-0.99 c-0.46-0.01-0.88-0.27-1.1-0.68l-3.07-5.65c-0.42-0.76,0-1.72,0.83-1.93c3.33-0.83,11.76-2.71,25.81-4.43 c18.69-2.3,37.66-1.19,41,0.73C1780.55,459.21,1780.97,460.07,1780.8,461.13z M1740.94,469.01c0,0.17-0.14,0.31-0.31,0.31 c-0.85,0-3.27-0.02-4.66-0.16c-1.63-0.16-3.66-1.17-4.83-1.82c-0.28-0.15-0.17-0.58,0.14-0.59l9.34-0.21 c0.17,0,0.32,0.14,0.32,0.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1731.3,466.79c-0.32,0.01-0.42,0.43-0.14,0.59c1.17,0.65,3.21,1.65,4.84,1.82 c1.39,0.14,3.82,0.16,4.67,0.16c0.17,0,0.31-0.14,0.31-0.31v-2.16c0-0.18-0.14-0.32-0.32-0.31L1731.3,466.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M1654.96,461.31c-0.06-0.07-0.15-0.11-0.25-0.11l-5.75-0.19c-0.03,0-0.07-0.01-0.1-0.02l-17.57-5.68 c-0.16-0.05-0.26-0.2-0.26-0.36v-1.81c0-0.06-0.01-0.1-0.03-0.15c-0.11-0.26-0.49-0.33-0.66-0.05l-1.69,2.76 c-0.03,0.05-0.07,0.09-0.11,0.12l-1.7,1.15c0,0,0,0-0.01,0.01c0.02,0,0.05,0,0.07,0.01l19.42,4.61 c0.42,0.1,0.66,0.56,0.51,0.97l-2.22,6.02c-0.11,0.29-0.37,0.48-0.67,0.48h-6.54c-0.18,0-0.34,0.06-0.48,0.18l-5.75,5.14 c-0.13,0.12-0.3,0.18-0.48,0.18h-5.41c-0.27,0-0.51-0.15-0.63-0.38l-0.05,0.77c0,0.05,0,0.1,0.02,0.14l0.64,2 c0.05,0.16,0.19,0.26,0.36,0.26h7.72c0.06,0,0.13-0.02,0.18-0.05l8.05-4.59c0.05-0.03,0.1-0.04,0.16-0.05l4.83-0.36l0.6-0.04 c0.11-0.01,0.21-0.06,0.27-0.15l7.08-9.63l0.49-0.67C1655.12,461.64,1655.08,461.44,1654.96,461.31z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M1625.29,474.56h5.41c0.18,0,0.34-0.06,0.48-0.18l5.75-5.14c0.13-0.12,0.3-0.18,0.48-0.18h6.54 c0.3,0,0.57-0.19,0.67-0.48l2.22-6.02c0.15-0.41-0.09-0.87-0.51-0.97l-19.42-4.61c-0.02-0.01-0.05-0.01-0.07-0.01 c-0.08,0.05-0.13,0.13-0.15,0.23l-0.63,2.85c-0.04,0.18,0.06,0.37,0.23,0.44l0.82,0.32c0.03,0.01,0.05,0.02,0.07,0.04 l16.42,2.25c0.46,0.06,0.74,0.54,0.58,0.98l-0.94,2.56c-0.1,0.27-0.34,0.45-0.61,0.47l-6.33,0.53 c-0.14,0.01-0.27,0.06-0.38,0.15l-5.24,4.04c-0.14,0.11-0.31,0.16-0.48,0.15l-4.91-0.35c-0.17-0.01-0.33,0.04-0.46,0.13 l-0.14,2.43C1624.78,474.41,1625.02,474.56,1625.29,474.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1CAB7",
    d: "M1630.46,467.71l1.96,0.09c0.06,0,0.12-0.02,0.17-0.05l2.09-1.57c0.2-0.15,0.11-0.46-0.13-0.49 l-4.05-0.41c-0.16-0.02-0.29,0.11-0.29,0.27v1.9C1630.2,467.58,1630.31,467.7,1630.46,467.71z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0398 0.0398 0.9992 -16.7665 67.1694)",
    fill: "#1EBEE4",
    cx: 1676.66,
    cy: 454.2,
    rx: 4.14,
    ry: 5.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0401 0.0401 0.9992 -16.8867 67.6649)",
    fill: "#141616",
    cx: 1676.31,
    cy: 454.29,
    rx: 3.39,
    ry: 4.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0401 0.0401 0.9992 -16.8867 67.6649)",
    fill: "#FFFFFF",
    cx: 1676.31,
    cy: 454.29,
    rx: 2.1,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1676.19,451.28v2.96h-1.98C1674.21,454.24,1674.12,451.53,1676.19,451.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1676.19,454.24v3.06c0,0,2.18,0.23,2.22-3.06L1676.19,454.24z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1635.16,495.24l1.29-0.03c0,0-0.85,3.58-0.89,3.76c-0.04,0.18-0.13,0.33-0.52,0.3 c-0.39-0.04-0.95-0.12-0.95-0.12s0.7-3.31,0.8-3.61C1635,495.23,1635.16,495.24,1635.16,495.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1635.45,496.33c0,0,0.47,0.1,0.56-0.15c0.09-0.25,0.14-0.55,0.14-0.55l-0.54,0.02L1635.45,496.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1635.92,496.55c0,0-0.19,0-0.35,0c-0.15,0-0.22,0.13-0.25,0.28c-0.03,0.15-0.47,2.16-0.47,2.16 s0.27,0.01,0.38,0.02c0.11,0.01,0.18-0.12,0.25-0.41S1635.92,496.55,1635.92,496.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1636.84,495.69l0.46-0.01c0.02,0,0.05,0.01,0.06,0.04l0.4,0.91c0.02,0.04,0.07,0.05,0.1,0.02l1-0.95 c0.01-0.01,0.03-0.02,0.04-0.02l0.73,0c0.05,0,0.08,0.07,0.04,0.11l-1.53,1.56c-0.02,0.02-0.02,0.05-0.01,0.07l0.82,1.66 c0.02,0.04-0.01,0.09-0.06,0.09l-0.64-0.04c-0.02,0-0.04-0.01-0.05-0.03l-0.57-1.13c-0.02-0.04-0.07-0.05-0.1-0.02 c-0.2,0.21-0.86,0.9-0.93,0.96c-0.09,0.08-0.11,0.07-0.27,0.06c-0.09-0.01-0.23-0.02-0.32-0.03c-0.05-0.01-0.07-0.07-0.04-0.1 l1.34-1.54c0.02-0.02,0.02-0.04,0.01-0.06l-0.54-1.44C1636.77,495.74,1636.8,495.7,1636.84,495.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1640.33,496.27l2.22,0.02c0.03,0,0.06,0.03,0.05,0.06l-0.23,0.81c-0.01,0.02-0.03,0.04-0.05,0.04 c-0.2,0-1.12-0.02-1.3-0.02c-0.18-0.01-0.26,0.23-0.31,0.46c-0.01,0.03,0.02,0.06,0.05,0.06l1.35,0.06 c0.03,0,0.05,0.03,0.05,0.06c-0.04,0.17-0.14,0.66-0.18,0.76c-0.05,0.12-0.1,0.09-0.26,0.08c-0.16-0.01-1.48-0.06-1.75-0.06 c-0.26,0-0.4,0.26-0.47,0.55c-0.01,0.03,0.01,0.06,0.04,0.06c0.36,0.03,2.4,0.17,2.68,0.19c0.3,0.02,0.53-0.13,0.64-0.61 c0.11-0.48,0.85-2.77,0.91-3.03c0.07-0.26-0.25-0.19-0.37-0.2c-0.13-0.01-2.36,0.03-2.61,0.04c-0.24,0.01-0.44,0.26-0.5,0.61 C1640.28,496.24,1640.3,496.27,1640.33,496.27z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1764.99,421.7c0.4,0.55,0.58,0.89,0.58,0.89s-4.55,8.39-8.39,13.59c-3.84,5.21-23.75,5.21-35.41,5.78 c-11.66,0.58-40.52,0.58-40.52,0.58s-31.3,0.17-36.89-0.18c-5.58-0.35-2.55-2.73-1.45-3.92c1.1-1.19,3.86-4.2,13.16-14.51 c0.23-0.26,0.47-0.51,0.7-0.76l-0.92,0.01c0,0-8.73,9.63-16.71,18.32c-3.9,4.24-5.93,6.62-6.98,7.94c3.22-2.06,14.32-4,46.72-4 c39.14,0,68.88,4.02,71.38,4.36c1.4-2.11,4.81-7.31,6.98-11.13c2.79-4.91,9.66-16.99,9.66-16.99L1764.99,421.7z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F1",
    d: "M1799.99,393.07c0.57,0,0.89-0.01,0.95-0.01C1800.63,393.07,1800.31,393.07,1799.99,393.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F1",
    d: "M1800.95,393.07c0,0,0.01,0,0.01,0C1800.96,393.07,1800.95,393.07,1800.95,393.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1771.11,412.09c-1.85-1.07-10.52-5.91-18.32-7.24c-8.79-1.49-19.29-1.49-19.78-1.61 c-0.45-0.11-3.92,0.94-4.45,1.1c-0.04,0.01-0.09,0.02-0.14,0.02c-1.71-0.05-34.51-0.93-52,1.24c-0.04,0.01-0.09,0-0.13,0 l-3.41-0.6c-0.04-0.01-0.08-0.01-0.13,0c-0.79,0.1-8.61,1.07-10.92,2.72c-0.53,0.38-0.99,0.85-1.38,1.38 c-1.4,1.87-1.97,4.38-2.16,5.45c-0.21,1.15,0.02,2.74,0.1,3.21c0.02,0.09,0,0.19-0.04,0.27l-2.18,4.51 c-0.15,0.3,0.07,0.65,0.4,0.65c0.12,0,0.23-0.05,0.31-0.14c8.93-9.45,16.37-10.27,20.92-10.27c4.69,0,49.77,0,66.12,0 c13,0,18.99,6.21,20.9,8.76c0.09,0.11,0.22,0.18,0.36,0.18l1.43-0.02c0.17,0,0.32-0.1,0.39-0.25l4.27-8.75 C1771.39,412.47,1771.31,412.21,1771.11,412.09z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464648",
    d: "M1704.31,435.91c0,0,0.13,0.56,1.58,0.71c1.09,0.11,8.49,0.12,12.02,0.19 c1.58-0.27,2.51-0.91,1.78-1.28c-1-0.51-12.26,0-13.88-0.89s-17.51-1.4-21.01-1.27c-3.5,0.13-6.06,0.55-5.35,3.02 c0.02,0.08,0.18-0.12,0.21-0.04c1.27-0.53,3.31-1.03,8.34-1.03C1695.4,435.31,1704.31,435.91,1704.31,435.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1686.13,439.15c0.22-0.13,0.36-0.36,0.39-0.61c0.04-0.37,0.31-0.94,1.52-1.06 c3.75-0.38,14.13-0.38,17.51-0.38c1.65,0,8.01-0.38,10.63-0.25c0.71,0.03,1.39-0.02,1.97-0.12 c-3.53-0.07-10.66-0.22-11.75-0.33c-0.84-0.09-1.19-0.37-1.34-0.59c-0.13-0.2-0.35-0.31-0.58-0.33 c-1.98-0.15-9.85-0.72-16.26-0.72c-4.09,0-6.71,0.19-8.22,0.55c-0.47,0.11-0.73,0.63-0.55,1.09c0.42,1.04,0.87,2.09,1.08,2.58 c0.08,0.19,0.24,0.35,0.43,0.42C1683.47,440.39,1685.34,439.61,1686.13,439.15z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M1685.58,406.74c-0.25,0-0.47-0.2-0.48-0.46c-0.02-0.27,0.18-0.51,0.45-0.53 c0.12-0.01,12.59-0.89,27.69-0.49c0.27,0.01,0.48,0.23,0.47,0.51c-0.01,0.27-0.22,0.49-0.5,0.48 c-15.05-0.4-27.47,0.47-27.6,0.48C1685.6,406.74,1685.59,406.74,1685.58,406.74z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1770.04,399.62l3.99,1.35c0,0,74.67-15.15,137.53,7.65c0,0-2.04-5.71-18.15-9.77 c-13.42-3.38-44.95-11.23-96.33-5.9C1787.86,393.91,1778.82,395.99,1770.04,399.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1770.0356,
    y1: 399.8852,
    x2: 1911.5511,
    y2: 399.8852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    style: {
      stopColor: "#1C1C1A",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M1770.04,399.62l3.99,1.35c0,0,74.67-15.15,137.53,7.65c0,0-2.04-5.71-18.15-9.77 c-13.42-3.38-44.95-11.23-96.33-5.9C1787.86,393.91,1778.82,395.99,1770.04,399.62z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1767.87,479.8c-7.63,3.14-13.44,11.47-13.44,11.47c10.47,0.66,9.54,8.19,9,17.97 c-0.07,1.31-0.21,2.88-0.39,4.57l0.27-2c0,0,22.47,2.8,23.84,2.8s7.17,1.96,10.89-3.64c1.95-2.94,6.94-11.67,15.11-18.7 c-4.79-1.28-15.64-4.22-23.21-6.61c-6.3-1.98-10.04-5.61-11.94-8.01c-1.82,1.37-3.68,2.15-5.37,2.15 C1771.9,479.8,1770.18,479.8,1767.87,479.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C9C6",
    d: "M1954.78,449.21l-0.33,0.76c0,0-8.7-9.83-23.36-24.24c-14.66-14.42-29.24-19.59-52.59-22.48 c-23.35-2.89-59.01-0.8-65.79-0.32s-16.72,2.57-17.99,5.62c-1.26,3.05-4.58,12.35-5.52,17.81s0.47,7.7,4.1,8.82 c3.63,1.12,18.77,6.74,26.66,9.15c7.89,2.41,24.14,7.06,32.34,7.86s37.55,3.21,37.55,3.21s57.9,6.58,62.64,6.74 s7.89-2.57,7.89-2.57c1-0.25,1.7-0.85,2.25-1.21L1954.78,449.21z M1952.19,460.8c-5.42-0.37-52.46-5.78-59.2-6.39 c-6.74-0.61-38.29-3.67-42.98-4.41c-4.7-0.73-22.27-4.65-28.78-6.86c-6.5-2.2-20.95-7.35-24.32-8.57 c-3.37-1.22-3.01-5.63-2.41-8.33c0.6-2.69,2.89-11.51,2.89-11.51c0.96-2.82,2.53-6.37,10.84-7.96 c8.31-1.59,32.87-4.04,69.35-1.35s49.97,17.88,62.49,30.73c12.52,12.86,18.43,21.58,18.43,21.58S1957.61,461.17,1952.19,460.8z"
  })), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1808.23,406.78c-8.31,1.59-9.87,5.14-10.84,7.96c0,0-2.29,8.82-2.89,11.51 c-0.6,2.69-0.96,7.1,2.41,8.33c3.37,1.22,17.82,6.37,24.32,8.57c2.7,0.92,7.32,2.13,12.13,3.28 c-0.46-8.38-1.86-28.51-5.21-41.73C1818.63,405.22,1811.87,406.08,1808.23,406.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1798.3071,
    y1: 438.8428,
    x2: 1835.4707,
    y2: 417.3864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M1808.23,406.78c-8.31,1.59-9.87,5.14-10.84,7.96c0,0-2.29,8.82-2.89,11.51 c-0.6,2.69-0.96,7.1,2.41,8.33c3.37,1.22,17.82,6.37,24.32,8.57c2.7,0.92,7.32,2.13,12.13,3.28 c-0.46-8.38-1.86-28.51-5.21-41.73C1818.63,405.22,1811.87,406.08,1808.23,406.78z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    fill: "#A1C8D9",
    d: "M1940.06,436.17c-12.52-12.86-26.01-28.04-62.49-30.73c-1.93-0.14-3.83-0.27-5.7-0.39 l20.67,49.32c0.16,0.01,0.31,0.03,0.44,0.04c6.74,0.61,53.78,6.02,59.2,6.39c5.42,0.37,6.31-3.59,6.31-3.59 S1952.59,449.02,1940.06,436.17z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1828.15,404.7c0,0,4.16,25.79,4.33,41.44l0.88,0.29c0,0,1.05-14.47-4.13-41.79L1828.15,404.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1871.88,405.05l20.67,49.32l14.82,1.61l-24.18-49.87C1883.18,406.11,1878.71,405.37,1871.88,405.05z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "1874.88,405.25 1897.21,454.81 1907.36,455.98 1883.18,406.11  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1943.38,439.64l8.81,21.16c0,0,3.22,0.48,5.36-1.58S1952.67,449.58,1943.38,439.64z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M1731.37,533.41l7.03,4.07c0.34,0.2,0.73,0.29,1.13,0.27c2.67-0.15,13.46-0.74,16.96-0.74 c4.01,0,4.01-4.8,4.01-4.8S1743.4,533.21,1731.37,533.41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1731.3715,
    y1: 534.9727,
    x2: 1760.5066,
    y2: 534.9727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M1731.37,533.41l7.03,4.07c0.34,0.2,0.73,0.29,1.13,0.27c2.67-0.15,13.46-0.74,16.96-0.74 c4.01,0,4.01-4.8,4.01-4.8S1743.4,533.21,1731.37,533.41"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2011.34,487.36c-21.94-4.33-29.33,46.22-29.33,46.22c-32.08,0.91-113.16,4.07-113.96,4.77 c0,0.02-0.01,0.02-0.01,0.01c0,0,0-0.01,0.01-0.01c0.22-0.95,5.65-43.34-26.43-47.8c-32.69-4.55-45.84,45.91-45.84,45.91 l-35.28-4.26c0,0-0.96,6.84-1.57,11.19c-0.27,1.89,0.55,4.72,2.48,5.52c8.73,3.65,34.05,13.11,34.05,13.11 s3.84-22.52,8.89-36.48c5.05-13.96,14.71-27.68,27.75-28.93c11.91-1.14,34.57,0.55,32.83,35.51 c-0.31,6.25-0.95,20.06-1.42,22.78c-0.47,2.73-2.52,4.81-2.52,4.81s95.45-10.59,119.12-11.07c0,0,0.79-0.16,1.74-1.93 c0.95-1.76,3.47-19.25,6.31-29.84c2.84-10.59,8.99-27.76,23.67-24.71c14.67,3.05,13.88,24.07,12.31,37.22l-1.1,4.65l-0.16,4.65 c0,0,4.31-2.1,4.6-8.99l-2.24,0.23C2025.22,529.94,2033.28,491.69,2011.34,487.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2011.11,482.35c-21.1-3.47-26.83,30.83-31.4,37.86c-1.57,2.42-1.73,3.19-6.09,2.98 c-4.07-0.2-10.77-0.12-10.77-0.12c-2.69,0-85.12-2.66-88.34-3.1c-3.22-0.44-2.74-0.84-3.29-4.48 c-0.55-3.64-1.24-28.31-27.98-32.52c-26.74-4.2-41.49,22.43-45.21,28.03c-3.72,5.61-9.51,3.64-10.89,3.64s-23.84-2.8-23.84-2.8 l-2.78,20.36l35.28,4.26c0,0,13.15-50.46,45.84-45.91c32.07,4.47,26.64,46.85,26.43,47.8c0.8-0.7,81.87-3.86,113.96-4.77 c0,0,7.39-50.55,29.33-46.22s13.88,42.58,13.88,42.58l2.24-0.23C2027.46,529.71,2033.5,486.03,2011.11,482.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1868.04,538.36c0,0.01,0,0.01,0.01-0.01C1868.04,538.36,1868.04,538.36,1868.04,538.36z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1893.07,548.23l3.98,0.08c0.34,0.01,0.55,0.38,0.38,0.68l-0.24,0.42c-0.18,0.31,0.06,0.7,0.41,0.68 l6.88-0.42c0.07,0,0.13-0.02,0.19-0.06l3.29-1.9c0.07-0.04,0.15-0.06,0.23-0.06l3.3,0.07c0.35,0.01,0.56,0.41,0.36,0.71 l-0.01,0.02c-0.2,0.31,0.02,0.71,0.38,0.71l7.12-0.17c0.08,0,0.16-0.03,0.23-0.07l3.55-2.26c0.07-0.05,0.16-0.07,0.25-0.07 l3.62,0.07c0.38,0.01,0.58,0.46,0.33,0.75l0,0c-0.26,0.3-0.04,0.77,0.36,0.75l5.46-0.24c0.06,0,0.12-0.02,0.17-0.04l3.7-1.74 c0.05-0.02,0.11-0.04,0.16-0.04l3.79-0.22c0.39-0.02,0.62,0.44,0.37,0.74l-0.03,0.04c-0.25,0.3-0.02,0.76,0.36,0.74l5.1-0.24 c0.07,0,0.14-0.02,0.2-0.06l3.57-2.09c0.07-0.04,0.14-0.06,0.21-0.06l3.78-0.08c0.35-0.01,0.57,0.38,0.39,0.69l-0.17,0.28 c-0.19,0.31,0.04,0.71,0.4,0.69l4.88-0.24c0.07,0,0.15-0.03,0.21-0.07l3.66-2.27c0.07-0.04,0.15-0.07,0.23-0.07h3.05 c0.36,0,0.57,0.41,0.37,0.71c-0.41,0.59-0.89,1.32-0.72,1.2c0.24-0.16,2.61-0.19,3.3-0.19c0.12,0,0.23-0.05,0.32-0.14l3.12-3.25 c0.28-0.3,0.06-0.79-0.34-0.77c-9.56,0.46-76.45,3.71-79.07,4.06c-2.82,0.38-7.15-1.82-11.11-1.24 c-3.95,0.57-2.26,2.68-1.51,3.35c0.75,0.67,3.48,2.58,4.24,3.06c0.75,0.48,2.92,0.29,4.52-0.96c1.36-1.06,2.38-1.42,2.66-1.51 C1892.98,548.23,1893.02,548.23,1893.07,548.23z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1893.24,547.62c-2.4,1.04-2.46,2.34-5.06,1.09c-2.61-1.25-1.72-0.76-2.61-1.25 c-0.89-0.49-1.64-1.89,1.58-1.95c3.22-0.07,70.05-3.05,84.87-4.03l-2.47,1.78c0,0-21.58,1.39-45.1,2.48 C1900.92,546.83,1894.68,547,1893.24,547.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1884.798,
    y1: 545.3553,
    x2: 1972.0129,
    y2: 545.3553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5959,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.2289
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.4494
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.6
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M1893.24,547.62c-2.4,1.04-2.46,2.34-5.06,1.09c-2.61-1.25-1.72-0.76-2.61-1.25 c-0.89-0.49-1.64-1.89,1.58-1.95c3.22-0.07,70.05-3.05,84.87-4.03l-2.47,1.78c0,0-21.58,1.39-45.1,2.48 C1900.92,546.83,1894.68,547,1893.24,547.62z"
  })), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1713.44,550.91c0.46,0.07,0,2.06,0,2.06l-12.34-2.22l-2.03-13.18 C1699.07,537.57,1700.17,548.84,1713.44,550.91z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1699.07,537.57l19.67,1.11c0,0,14.05,8.42,15.77,9.84c1.72,1.43,1.56,4.92,1.56,4.92l-22.64-0.48 v-2.06c0,0-3.28-0.64-6.87-2.06C1702.98,547.41,1699.39,541.38,1699.07,537.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1717.5792,
    y1: 537.5672,
    x2: 1717.5792,
    y2: 553.4461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M1699.07,537.57l19.67,1.11c0,0,14.05,8.42,15.77,9.84c1.72,1.43,1.56,4.92,1.56,4.92 l-22.64-0.48v-2.06c0,0-3.44-0.45-6.85-2.26C1702.55,546.5,1699.39,541.38,1699.07,537.57z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1745.92,554.4l-9.84-0.95c0,0,0.54-3.45-2.04-5.02c-2.58-1.57-15.3-9.75-15.3-9.75l1.18-1.78 c0,0,12.67,8.7,15.04,10.37c2.37,1.68,2.78,5.03,2.78,5.03l8.14,1.47L1745.92,554.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1698.92,536.48l0.16,1.08l2.03,13.18l-1.57-0.01C1699.53,550.73,1697.37,536.8,1698.92,536.48z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1698.92,536.48c0,0,16.38,0.1,21.02,0.42l-1.18,1.78l-19.67-1.11L1698.92,536.48z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1719.93,536.9l25.96,16.87l-8.65-1.26c0,0-0.31-2.93-1.75-4.3s-16.07-10.37-16.07-10.37L1719.93,536.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1719.4156,
    y1: 545.337,
    x2: 1745.8909,
    y2: 545.337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M1719.93,536.9l25.96,16.87l-8.65-1.26c0,0-0.31-2.93-1.75-4.3s-16.07-10.37-16.07-10.37 L1719.93,536.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1623.05,545.06l-0.85-3.62c0,0,3.01-7.06,3.77-8.53c0.24-0.46,0.22-0.88,0.22-0.88 s-1.24,0.98-2.29,2.93c-1.53,2.85-2.29,4.75-2.38,5.87c-0.08,1.12,0.68,4.06,0.68,4.06L1623.05,545.06z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1626.19,532.03c0,0,11.71,0.43,13.57,0.95c1.87,0.52,2.12,1.21,2.71,4.49 c0.59,3.28,1.36,5.95,1.36,5.95l3.56,3.97l-5.68-0.52l-0.25-0.95l-5.26-0.26l-0.17,1.12l-12.98-1.73l-0.85-3.62L1626.19,532.03 z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1626.19,532.03c0,0-1.78,3.8-2.29,5.78c-0.51,1.98,0.76,1.81,2.29,2.07s3.9,4.23,10.01,5.78l5.26,0.26 c0,0-1.61-8.89-1.78-10.27c-0.17-1.38-0.51-2.59,0.08-2.67C1639.76,532.98,1630.01,532.11,1626.19,532.03z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1641.71,546.87h1.1c0,0-1.95-11.22-2.29-12.42s-1.27-1.04-1.02,0.26S1641.71,546.87,1641.71,546.87z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1834.17,515.98c0.54,0.78,2.38,3.46,2.38,3.46l4.35-0.08l2-3.14 C1842.9,516.23,1840.14,514.5,1834.17,515.98z"
  })), /*#__PURE__*/React.createElement("g", null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M2007.69,496.45c5.86,0,16.48,8.67,15.33,37.3c-1.07,26.5-12.62,34.09-17.73,34.09 c-4.32,0-26.86,5.01-32.25-19.15c0,0,8.99,2.23,10.78-9.34C1985.15,530.74,1987.6,496.45,2007.69,496.45z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1989.83,535.44c-0.4-6.52-1.2-12.31-2.22-17.01c0,0,5.85-23.89,20.49-20.71 c16.87,3.67,15.17,39.18,14.19,44.68c-1.25,6.97-4.54,23.93-16.57,25.29C1993.69,569.06,1990.28,542.86,1989.83,535.44z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0174 -0.9998 0.9998 0.0174 1440.0201 2528.8806)",
    fill: "#FFFFFF",
    cx: 2006.62,
    cy: 531.81,
    rx: 29.39,
    ry: 13.9
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#191C1C",
    points: "2010.11,504.46 2011.43,515.52 2018.13,517.31 2019.58,529.2 2014.43,536.21 2016.21,549.66 2013.26,550.9 2011.26,557.06 2006.98,549.42 2001.04,557.37 1999.42,550.83 1996.39,549.87 1999.03,536.21 1993.58,529.42 1995.92,523.68 1995.66,516.67 2002.04,516.04 2004.25,504.25 2006.87,505.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 2006.1622,
    y1: 558.102,
    x2: 2006.9506,
    y2: 503.2209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7515,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_)",
    strokeMiterlimit: 10,
    d: "M2004.25,504.25l-2.57,9.64l-6.02,2.78 c0,0-1.85,7.82-2.09,12.74l3.85,8.57l-1.04,11.89c0,0,1.69,5.03,4.65,7.5l5.38-4.82l4.81,4.82c0,0,3.45-3.96,4.98-7.71 l-0.32-11.57l3.69-8.89c0,0,0-6.53-1.44-11.89l-5.38-2.36l-2.65-10.5C2010.11,504.46,2008.18,502.96,2004.25,504.25z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "2010.11,504.46 2009.06,519.78 2010.83,522.24 2018.13,517.31 2012.76,514.96  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "2004.25,504.25 2003.37,519.24 2001.68,522.03 1995.66,516.67 2001.68,513.89  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1995.66,516.67l1.44,4.71l-1.36,6.85l-2.17,1.18C1993.58,529.42,1993.98,522.35,1995.66,516.67z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2018.13,517.31l-1.77,4.18l0.8,6.43l2.41,1.29C2019.58,529.2,2019.58,522.88,2018.13,517.31z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "2019.58,529.2 2012.35,533.7 2011.55,537.98 2016.21,549.66 2015.89,538.09  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2016.21,549.66l-2.41-2.03l-2.49,3.86l-0.08,5.89C2011.23,557.37,2015.16,553.08,2016.21,549.66z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "2011.23,557.37 2006.66,544.84 2004.89,544.3 2001.04,557.37 2006.42,552.55  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2001.04,557.37l0.64-5.46c0,0-2.97-4.28-3.05-3.96c-0.08,0.32-2.25,1.93-2.25,1.93 S1998.55,555.44,2001.04,557.37z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1996.39,549.87 2000.24,537.34 1999.76,533.27 1993.58,529.42 1997.43,537.98  "
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 2012.76,
    y1: 514.96,
    x2: 2014.92,
    y2: 509.17
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 2015.89,
    y1: 538.09,
    x2: 2019.18,
    y2: 540.34
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 2006.42,
    y1: 552.55,
    x2: 2006.42,
    y2: 559.94
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1997.43,
    y1: 537.98,
    x2: 1994.06,
    y2: 540.13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 2001.68,
    y1: 513.89,
    x2: 1999.19,
    y2: 509.07
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 2004.27,
    cy: 531.5,
    rx: 1.31,
    ry: 2.95
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1EBEE4",
    cx: 2004.27,
    cy: 531.5,
    rx: 0.85,
    ry: 1.92
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1619.062,
    y1: 512.404,
    x2: 1763.7013,
    y2: 512.404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M1754.41,491.3c0,0-0.87,5.35-1.73,12.02c-0.68,5.33-1.14,10.16-4.71,11.32 c-3.57,1.16-17.84,4.06-23.26,4.21c-4.02,0.11-47.34-1.54-73.44-2.4c-9.07-0.3-16.05-0.5-18.59-0.5 c-9.85,0-10.84-3.34-11.7-6.53c-0.69-2.56-1.37-5.96-1.62-7.21c0,3.44,0,6.7,0,7.74c0,2.36-0.3,6.7-0.3,8.83 c0,2.13,0.47,6.74,0.47,6.74s0.83,1.93,7.59,2.58c2.65,0.26,16.85,1.14,33.74,2.12c26.28,1.53,59.06,3.29,64.85,3.29 c9.5,0,34.79-1.31,34.79-1.31s2.49-15.56,2.9-22.93C1763.95,499.49,1764.88,491.95,1754.41,491.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.2256,
    y1: 460.816,
    x2: 1687.2256,
    y2: 511.4808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M1631.79,500.73c1.41,2.63,2.12,7.05,8.93,7.53c6.6,0.46,77.5,3.05,89.39,3.22 c5.46-4.92,7.11-14.62,8.16-19.74c1.45-7.04,3.55-11.9,3.55-11.9l2.84-0.01l0.12-0.28l-2.19-18.73c0,0-26.1,1.12-35.74,1.12 s-53.7-0.76-53.7-0.76l-6.54,8.28c0,0-11.32,2.25-11.08,2.25c0.24,0-5.86,5.71-5.86,5.71l0.11,14.27 C1630.03,494.79,1630.7,498.69,1631.79,500.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1619.3616,
    y1: 498.1008,
    x2: 1768.3998,
    y2: 498.1008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M1744.67,479.83l-2.87,0.01c0,0-2.07,4.86-3.52,11.9c-1.05,5.12-2.7,14.82-8.16,19.74 c-0.47,0.43-0.97,0.81-1.51,1.16c-1.78,1.17-3.9,1.86-6.44,1.86c-12.08,0-86.02-3.44-89.89-3.93 c-3.87-0.49-4.83-2.78-5.15-10.16s-0.43-11.57-0.43-12.8c0-1.23,2.97-10.2,2.97-10.2l-4.32-0.07c0,0-3.97,8.3-4.79,10.21 c-0.82,1.9-1.2,3.27-1.2,4.8c0,0.85,0,5.5,0,9.85c0.24,1.24,0.93,4.65,1.62,7.21c0.86,3.19,1.85,6.53,11.7,6.53 s86.61,3.05,92.03,2.9c5.42-0.15,19.69-3.05,23.26-4.21c3.57-1.16,4.02-5.99,4.71-11.32c0.86-6.67,1.73-12.02,1.73-12.02 s6.1-8.74,13.99-11.68L1744.67,479.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1624.8036,
    y1: 466.4085,
    x2: 1644.2145,
    y2: 466.4085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M1625.26,471.62l4.91,0.35c0.17,0.01,0.35-0.04,0.48-0.15l5.24-4.04 c0.11-0.08,0.24-0.13,0.38-0.15l6.33-0.53c0.28-0.02,0.52-0.21,0.61-0.47l0.94-2.56c0.16-0.44-0.12-0.92-0.58-0.98l-16.42-2.25 c0.1,0.07,0.17,0.19,0.17,0.32l-0.2,7.82c0,0.1-0.04,0.19-0.11,0.26l-2.11,2.14c-0.06,0.07-0.1,0.15-0.11,0.25l-0.01,0.12 C1624.93,471.66,1625.09,471.61,1625.26,471.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1624.6123,
    y1: 465.0542,
    x2: 1655.0719,
    y2: 465.0542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M1654.71,461.2l-5.75-0.19c-0.03,0-0.07-0.01-0.1-0.02l-17.57-5.68 c-0.16-0.05-0.26-0.2-0.26-0.36v-1.81c0-0.38-0.49-0.52-0.69-0.2l-1.69,2.76c-0.03,0.05-0.07,0.09-0.11,0.12l-1.7,1.15 c0,0,0,0-0.01,0.01c0.02,0,0.05,0,0.07,0.01l19.42,4.61c0.42,0.1,0.66,0.56,0.51,0.97l-2.22,6.02 c-0.11,0.29-0.37,0.48-0.67,0.48h-6.54c-0.18,0-0.34,0.06-0.48,0.18l-5.75,5.14c-0.13,0.12-0.3,0.18-0.48,0.18h-5.41 c-0.27,0-0.51-0.15-0.63-0.38l-0.05,0.77c0,0.05,0,0.1,0.02,0.14l0.64,2c0.05,0.16,0.19,0.26,0.36,0.26h7.72 c0.06,0,0.13-0.02,0.18-0.05l8.05-4.59c0.05-0.03,0.1-0.04,0.16-0.05l5.43-0.41c0.11-0.01,0.21-0.06,0.27-0.15l7.57-10.29 C1655.18,461.56,1655.01,461.21,1654.71,461.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1624.6588,
    y1: 465.7639,
    x2: 1646.873,
    y2: 465.7639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M1625.29,474.56h5.41c0.18,0,0.34-0.06,0.48-0.18l5.75-5.14c0.13-0.12,0.3-0.18,0.48-0.18h6.54 c0.3,0,0.57-0.19,0.67-0.48l2.22-6.02c0.15-0.41-0.09-0.87-0.51-0.97l-19.42-4.61c-0.02-0.01-0.05-0.01-0.07-0.01 c-0.08,0.05-0.13,0.13-0.15,0.23l-0.63,2.85c-0.04,0.18,0.06,0.37,0.23,0.44l0.82,0.32c0.03,0.01,0.05,0.02,0.07,0.04 l16.42,2.25c0.46,0.06,0.74,0.54,0.58,0.98l-0.94,2.56c-0.1,0.27-0.34,0.45-0.61,0.47l-6.33,0.53 c-0.14,0.01-0.27,0.06-0.38,0.15l-5.24,4.04c-0.14,0.11-0.31,0.16-0.48,0.15l-4.91-0.35c-0.17-0.01-0.33,0.04-0.46,0.13 l-0.14,2.43C1624.78,474.41,1625.02,474.56,1625.29,474.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 1626.696,
    y1: 495.962,
    x2: 1730.1124,
    y2: 495.962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M1640.72,508.26c-6.82-0.48-7.52-4.9-8.93-7.53c-1.09-2.04-1.77-5.95-2.02-9.05 c-0.07-0.9-0.11-1.73-0.11-2.43c0-3.11,0-11.84,0-11.84s-2.97,8.97-2.97,10.2c0,1.23,0.11,5.43,0.43,12.8s1.29,9.67,5.15,10.16 c3.87,0.49,77.8,3.93,89.89,3.93c2.54,0,4.66-0.7,6.44-1.86c0.53-0.35,1.03-0.74,1.51-1.16 C1718.22,511.32,1647.32,508.73,1640.72,508.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1709.1832,
    y1: 464.8306,
    x2: 1788.8186,
    y2: 464.8306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2965,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M1785.77,456.76c-6.46-4.23-17.8-6.84-35.35-6.93c-0.62,0-1.23,0.22-1.71,0.62 c-1.2,1.01-3.58,3.08-5.1,4.84c-0.42,0.49-1,0.81-1.64,0.89c-4.45,0.61-22.22,2.96-30.34,5.07c-0.26,0.07-0.52,0.14-0.76,0.22 c-1.32,0.45-2.17,1.12-1.39,2.42l5.09,8.13c0.49,0.81,1.37,1.3,2.31,1.29c0.61-0.01,1.36-0.01,2.14,0.03 c0.41,0.02,0.83,0.05,1.24,0.09c0.53,0.02,0.9,0.07,1.16,0.15c0.7,0.12,1.33,0.28,1.83,0.51c2.35,1.08,8.46,5.74,13.63,5.74 c5.17,0,32.2,0,35.72,0s7.76-3.35,10.93-8.48C1786.71,466.2,1792.35,461.07,1785.77,456.76z M1780.8,461.12 c-29.88-2.01-59.88,2.13-64.85,2.86c-0.36,0.05-0.58,0.44-0.44,0.79l0.85,2.02c0.09,0.22,0.31,0.36,0.54,0.35 c1.06-0.05,4.07-0.19,6.34-0.27c2.8-0.1,3.93,0.19,7.01,1.14c3.09,0.95,5.8,2.38,11.31,2.57c5.04,0.17,29.93-0.61,34.16-0.74 c-2.76,3.68-6.61,7.29-9.48,7.29c-2.26,0-23.66,0-27.09,0c-3.43,0-10.57-4.96-13-5.79c-2.01-0.68-8.29-0.92-10.46-0.99 c-0.46-0.01-0.88-0.27-1.1-0.68l-3.07-5.65c-0.42-0.76,0-1.72,0.83-1.93c3.33-0.83,11.76-2.71,25.81-4.43 c18.69-2.3,37.66-1.19,41,0.73C1780.55,459.2,1780.97,460.07,1780.8,461.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1711.3601,
    y1: 466.7608,
    x2: 1780.8348,
    y2: 466.7608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2963,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M1779.16,458.41c-3.34-1.93-22.3-3.03-41-0.73c-14.04,1.72-22.48,3.61-25.81,4.43 c-0.83,0.21-1.25,1.17-0.83,1.93l3.07,5.65c0.22,0.41,0.64,0.67,1.1,0.68c2.16,0.07,8.45,0.31,10.46,0.99 c2.44,0.83,9.57,5.79,13,5.79c3.43,0,24.83,0,27.09,0c2.87,0,6.72-3.61,9.48-7.29c-4.23,0.14-29.12,0.91-34.16,0.74 c-5.52-0.19-8.23-1.62-11.31-2.57c-3.09-0.95-4.21-1.24-7.01-1.14c-2.27,0.08-5.28,0.22-6.34,0.27 c-0.23,0.01-0.45-0.13-0.54-0.35l-0.85-2.02c-0.14-0.34,0.07-0.73,0.44-0.79c4.98-0.73,34.97-4.87,64.85-2.86 C1780.97,460.07,1780.55,459.21,1779.16,458.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 1683.1475,
    y1: 461.06,
    x2: 1683.1475,
    y2: 488.2906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7973,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M1721.18,473.46c-0.37-0.06-0.77-0.11-1.16-0.15c-0.18-0.01-0.37-0.01-0.58-0.01 c-0.22,0-0.44-0.03-0.66-0.08c-0.78-0.04-1.53-0.04-2.14-0.03c-0.94,0.01-1.82-0.47-2.31-1.29l-5.09-8.13 c-0.78-1.3,0.07-1.97,1.39-2.42c-0.07-0.19-0.1-0.3-0.1-0.3h-55.35l-0.22,0.25c0.12,0.13,0.15,0.33,0.03,0.49l-7.57,10.29 c-0.06,0.09-0.16,0.14-0.27,0.15l-0.6,0.04l-1.51,0.19c0,0-3.57,15.75,11.33,15.75c9.87,0,40.69,0.05,45.99,0.05 s12.28-5.44,14.93-9.35C1719.49,475.7,1722.8,473.97,1721.18,473.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 1630.9952,
    y1: 453.9621,
    x2: 1750.4125,
    y2: 453.9621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6631,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.2996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.4
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M1710.87,461.48c0.24-0.08,0.49-0.15,0.76-0.22c8.12-2.11,25.89-4.46,30.34-5.07 c0.63-0.09,1.21-0.4,1.64-0.89c1.52-1.76,3.9-3.82,5.1-4.84c0.48-0.4,1.09-0.62,1.71-0.62c0,0-30.64-4.39-71.55-4.39 c-40.91,0-47.87,3.1-47.87,5.61c0,0.73,0,1.37,0,1.93c0.02,0.04,0.03,0.09,0.03,0.15v1.81c0,0.17,0.11,0.31,0.26,0.36 l17.57,5.68c0.03,0.01,0.07,0.02,0.1,0.02l5.75,0.19c0.1,0,0.19,0.05,0.25,0.11c0.12,0.13,0.15,0.33,0.03,0.49l-0.49,0.67 l54.95-0.19C1709.75,461.94,1710.26,461.69,1710.87,461.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 1660.459,
    y1: 402.8769,
    x2: 1799.9949,
    y2: 402.8769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6704,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.1742
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8349,
    style: {
      stopColor: "#090908",
      stopOpacity: 0.237
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9517,
    style: {
      stopColor: "#141414",
      stopOpacity: 0.2816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M1770.83,399.45c0,0,12.33-6.15,29.16-6.37c-6.67,0.06-46.55,0.5-76.48,3.18 c-32.76,2.94-55.23,7.15-58.99,8.81c-2.98,1.31-3.83,3.26-4.06,4.02c0.39-0.52,0.85-1,1.38-1.38 c2.32-1.65,10.13-2.63,10.92-2.72c0.04-0.01,0.09,0,0.13,0l3.41,0.6c0.04,0.01,0.08,0.01,0.13,0c17.49-2.17,50.28-1.28,52-1.24 c0.05,0,0.09,0,0.14-0.02c0.53-0.16,4-1.21,4.45-1.1c0.49,0.12,10.99,0.12,19.78,1.61c7.8,1.32,16.46,6.16,18.32,7.24 c0.2,0.12,0.28,0.38,0.18,0.59C1771.29,412.68,1780.16,399.29,1770.83,399.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 1632.1615,
    y1: 435.7416,
    x2: 1766.8958,
    y2: 435.7416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.0617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.008066498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2198,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M1764.99,421.7c0.4,0.55,0.58,0.89,0.58,0.89s-4.55,8.39-8.39,13.59 c-3.84,5.21-23.75,5.21-35.41,5.78c-11.66,0.58-40.52,0.58-40.52,0.58s-31.3,0.17-36.89-0.18c-5.58-0.35-2.55-2.73-1.45-3.92 c1.1-1.19,3.86-4.2,13.16-14.51c0.23-0.26,0.47-0.51,0.7-0.76l-0.92,0.01c0,0-8.73,9.63-16.71,18.32 c-3.9,4.24-5.93,6.62-6.98,7.94c3.22-2.06,14.32-4,46.72-4c39.14,0,68.88,4.02,71.38,4.36c1.4-2.11,4.81-7.31,6.98-11.13 c2.79-4.91,9.66-16.99,9.66-16.99L1764.99,421.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1760.5066,
    y1: 510.2402,
    x2: 2028.1981,
    y2: 510.2402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2017,
    style: {
      stopColor: "#161819",
      stopOpacity: 0.0631
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#0B0C0D",
      stopOpacity: 0.0253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.0208
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8316,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.0629
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M1760.51,532.2l35.28,4.26c0,0,13.15-50.46,45.84-45.91c32.69,4.55,26.42,48.5,26.42,47.81 c0-0.68,81.72-3.87,113.96-4.78c0,0,7.39-50.55,29.33-46.22s13.88,42.58,13.88,42.58l2.24-0.23c0,0,6.04-43.68-16.34-47.36 c-21.1-3.47-26.83,30.83-31.4,37.86c-1.57,2.42-1.73,3.19-6.09,2.98c-4.07-0.2-10.77-0.12-10.77-0.12 c-2.69,0-85.12-2.66-88.34-3.1c-3.22-0.44-2.74-0.84-3.29-4.48c-0.55-3.64-1.24-28.31-27.98-32.52s-41.49,22.43-45.21,28.03 c-3.72,5.61-9.51,3.64-10.89,3.64s-23.84-2.8-23.84-2.8L1760.51,532.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1927.2614,
    y1: 485.5829,
    x2: 1927.2614,
    y2: 516.6846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001784581,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.9026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1228,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.8041
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    style: {
      stopColor: "#E4E4E4",
      stopOpacity: 0.696
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    style: {
      stopColor: "#CFCFCE",
      stopOpacity: 0.5832
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5424,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.4673
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6899,
    style: {
      stopColor: "#888888",
      stopOpacity: 0.3489
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8399,
    style: {
      stopColor: "#585858",
      stopOpacity: 0.2285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    style: {
      stopColor: "#20201F",
      stopOpacity: 0.1085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M1873.75,516.68c0,0,10.3-6.02,44.79-6.49c34.49-0.46,64.04,2.73,64.04,2.73l9.7-21.42 c0,0-91.66-4.94-107.78-5.41c-5-0.14-24.99-1.71-21.95,1.39C1876.44,501.62,1873.75,516.68,1873.75,516.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1803.7643,
    y1: 455.9543,
    x2: 1794.6718,
    y2: 471.7031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M1788.32,459.42c0,0,11.89,0.57,23.42,1.14l1.05,3.06c-2.97,0.26-6.18,0.36-8.47,0.64 c-8.93,1.12-17.16,2.65-17.79,2.74C1786.29,467.04,1790.07,462.52,1788.32,459.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1850.5854,
    y1: 466.7021,
    x2: 1863.0117,
    y2: 466.7021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M1858.85,464.79l4.16-0.25c0,0-1.3,3.41-4.54,4.05c-3.15,0.62-5.19,0.2-7.89-1.44 c0,0,0.13-0.06,0.54-0.47c0.41-0.42,0,0,0,0s0.81,0.86,3.19,0.83C1856.81,467.48,1858.85,466.87,1858.85,464.79L1858.85,464.79 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1846.2318,
    y1: 460.4279,
    x2: 1861.1171,
    y2: 460.4279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M1861.02,461.84c0,0-13.5-3.06-13.93,0l-0.83-0.08c0,0-0.51-2.51,2.95-2.73 C1852.67,458.81,1862.15,461.49,1861.02,461.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1847.0031,
    y1: 464.8223,
    x2: 1863.0117,
    y2: 464.8223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      stopColor: "#222222",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#353534",
      stopOpacity: 0.2887
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3212,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.4174
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#7C7C7B",
      stopOpacity: 0.5603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#B1B1B1",
      stopOpacity: 0.7148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    style: {
      stopColor: "#F1F1F1",
      stopOpacity: 0.8769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7903,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.881
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M1848.46,462.49c0,0,2.02,1.94,6.16,2.05c4.14,0.11,8.4,0,8.4,0s-8.06,0.34-9.96,1.02 c-1.9,0.68-2.46,1.59-2.46,1.59s-2.91-1.82-3.58-4.44L1848.46,462.49z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 1945.5922,
    y1: 502.1279,
    x2: 1909.192,
    y2: 439.0811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2536,
    style: {
      stopColor: "#818283",
      stopOpacity: 0.4996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#B7B7B6",
      stopOpacity: 0.7439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#646463",
      stopOpacity: 0.4305
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.2083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M1865.37,464.38l124.04,12.45c0,0-9.67,3.28-28.67,1.97c-19.01-1.31-62.18-5.24-71.2-6.55 C1880.52,470.93,1865.37,464.38,1865.37,464.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1919.4338,
    y1: 473.5729,
    x2: 1929.4364,
    y2: 473.5729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M1926.08,471.37l3.35-0.29c0,0-1.05,3.94-3.65,4.68c-2.54,0.72-4.18,0.23-6.35-1.66 c0,0,0.1-0.07,0.43-0.55s0,0,0,0s0.65,1,2.56,0.96C1924.44,474.47,1926.08,473.76,1926.08,471.37L1926.08,471.37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1915.9294,
    y1: 466.3279,
    x2: 1927.9113,
    y2: 466.3279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M1927.84,467.96c0,0-10.87-3.53-11.22,0l-0.67-0.09c0,0-0.41-2.9,2.38-3.15 C1921.12,464.46,1928.74,467.55,1927.84,467.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 1916.5503,
    y1: 471.4022,
    x2: 1929.4364,
    y2: 471.4022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      stopColor: "#222222",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#353534",
      stopOpacity: 0.2887
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3212,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.4174
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#7C7C7B",
      stopOpacity: 0.5603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#B1B1B1",
      stopOpacity: 0.7148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    style: {
      stopColor: "#F1F1F1",
      stopOpacity: 0.8769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7903,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.881
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M1917.72,468.71c0,0,1.62,2.23,4.96,2.37c3.33,0.13,6.76,0,6.76,0s-6.49,0.39-8.02,1.18 c-1.53,0.79-1.98,1.84-1.98,1.84s-2.34-2.1-2.88-5.13L1917.72,468.71z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1874.8794,
    y1: 430.6143,
    x2: 1907.3591,
    y2: 430.6143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_37_)",
    points: "1874.88,405.25 1897.21,454.81 1907.36,455.98 1883.18,406.11  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 1769.0546,
    y1: 517.2869,
    x2: 1790.9094,
    y2: 479.4332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2364,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2393,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.1275
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6941,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.2191
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8608,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2994
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M1767.87,479.8c-7.63,3.14-13.44,11.47-13.44,11.47c10.47,0.66,9.54,8.19,9,17.97 c-0.07,1.31-0.21,2.88-0.39,4.57l0.27-2c0,0,22.47,2.8,23.84,2.8s7.17,1.96,10.89-3.64c1.95-2.94,6.94-11.67,15.11-18.7 c-4.79-1.28-15.64-4.22-23.21-6.61c-6.3-1.98-10.04-5.61-11.94-8.01c-1.82,1.37-3.68,2.15-5.37,2.15 C1771.9,479.8,1770.18,479.8,1767.87,479.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1980.43,500.15c0,0-0.27,4.93-0.68,9.52c-0.41,4.58-1.78,11.09-1.95,12.01 c-0.16,0.92,0.33,1.25,1.48-0.17s4.67-9.83,6.15-13.42c1.48-3.58,2.46-6.5,2.95-7.83c0.49-1.33-0.32-1.48-1.89-1.5 c-1.24-0.02-2.48-0.06-4.52-0.01C1981.18,498.76,1980.43,498.84,1980.43,500.15z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4B",
    d: "M1980.43,499.6c0,0-1.77,4.2-2.2,10.21c-0.43,6.01-0.32,12.12-0.32,12.12s1.99-8.63,2.36-13.6 C1980.65,503.37,1980.43,499.6,1980.43,499.6z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1758.11,394.67c0,0-4.06-6.35-14.78-6.46l-1.98,4.34c0,0-1.46,1.27-1.46,2.86 C1739.9,395.41,1750.52,397.53,1758.11,394.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 1749.007,
    y1: 388.216,
    x2: 1749.007,
    y2: 396.1687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    style: {
      stopColor: "#151514",
      stopOpacity: 0.0837
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    style: {
      stopColor: "#050505",
      stopOpacity: 0.0372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1717
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M1758.11,394.67c0,0-4.06-6.35-14.78-6.46l-1.98,4.34c0,0-1.46,1.27-1.46,2.86 C1739.9,395.41,1750.52,397.53,1758.11,394.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 1943.3767,
    y1: 450.2472,
    x2: 1957.9385,
    y2: 450.2472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M1943.38,439.64l8.81,21.16c0,0,3.22,0.48,5.36-1.58S1952.67,449.58,1943.38,439.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 1955.4113,
    y1: 447.5756,
    x2: 1969.1729,
    y2: 447.5756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0143,
    style: {
      stopColor: "#393A3C",
      stopOpacity: 0.1258
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364,
    style: {
      stopColor: "#626364",
      stopOpacity: 0.1657
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0612,
    style: {
      stopColor: "#888989",
      stopOpacity: 0.2106
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0883,
    style: {
      stopColor: "#A8A9A9",
      stopOpacity: 0.2595
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1182,
    style: {
      stopColor: "#C4C4C4",
      stopOpacity: 0.3135
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#DADADA",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    style: {
      stopColor: "#EAEBEB",
      stopOpacity: 0.4456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2402,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.5337
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3085,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.6572
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4984,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6895,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.657
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7584,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.5334
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    style: {
      stopColor: "#EBEBEA",
      stopOpacity: 0.4453
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    style: {
      stopColor: "#DADADA",
      stopOpacity: 0.3741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#C4C4C4",
      stopOpacity: 0.3131
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9114,
    style: {
      stopColor: "#A9A9A8",
      stopOpacity: 0.259
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9386,
    style: {
      stopColor: "#888888",
      stopOpacity: 0.2101
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9637,
    style: {
      stopColor: "#636362",
      stopOpacity: 0.1651
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#3A3A39",
      stopOpacity: 0.1252
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M1955.44,442.35c-0.31-0.96,2.3-1.08,3.28-0.91c0.53,0.09,1.17,0.26,1.92,0.56 c2.04,0.82,4.14,2.03,4.98,2.54c0.25,0.15,0.45,0.39,0.56,0.67l2.96,7.82c0.36,0.91-3.53,0.78-4.49,0.73l-3.57-1.43 c-0.55-0.03-1.03-0.4-1.21-0.93L1955.44,442.35z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1951.95,454.01h2.14c0,0,0-8.24,0-9.45s0.71-4.6,5.6-2.06c4.89,2.54,5.36,7.27,5.48,10.18h3.93 c0,0,0.24,4.97-1.79,4.97s-3.57-0.24-5.12,0.97c-1.55,1.21-2.98,0.61-4.65,0.61s-2.03,1.58-5.36,1.58L1951.95,454.01z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    fill: "#A1C8D9",
    d: "M1956.74,444.32c0-0.58,0.55-1,1.1-0.82c1.89,0.61,5.94,2.73,5.94,10.09 c0,2.6-4.43,3.98-6.26,3.74c-0.42-0.06-0.73-0.42-0.73-0.85L1956.74,444.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 1956.7413,
    y1: 450.4098,
    x2: 1963.7825,
    y2: 450.4098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M1956.74,444.32c0-0.58,0.55-1,1.1-0.82c1.89,0.61,5.94,2.73,5.94,10.09 c0,2.6-4.43,3.98-6.26,3.74c-0.42-0.06-0.73-0.42-0.73-0.85L1956.74,444.32z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1954.13,446.67c0,0,0,5.95,0,6.72s-0.7,0.91-2,0.91v-0.35c0,0,1.72,0.15,1.72-1.26 c0-2.03,0.31-5.99,0-5.68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 1699.0743,
    y1: 545.2685,
    x2: 1713.4396,
    y2: 545.2685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M1713.44,550.91v2.06l-12.34-2.22l-2.03-13.18C1699.07,537.57,1700.17,548.84,1713.44,550.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 1632.6224,
    y1: 532.0283,
    x2: 1632.6224,
    y2: 545.9191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M1626.19,532.03c0,0-1.78,3.8-2.29,5.78c-0.51,1.98,0.76,1.81,2.29,2.07s3.9,4.23,10.01,5.78 l5.26,0.26c0,0-1.61-8.89-1.78-10.27c-0.17-1.38-0.51-2.59,0.08-2.67C1639.76,532.98,1630.01,532.11,1626.19,532.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 1709.1837,
    y1: 553.36,
    x2: 1709.4871,
    y2: 532.2408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7309,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M1698.92,536.48c0,0,16.38,0.1,21.02,0.42l-0.93,1.75l-19.93-1.09L1698.92,536.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 1987.608,
    y1: 532.4523,
    x2: 2023.0636,
    y2: 532.4523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M1989.81,535.31c-0.4-6.55-1.17-12.16-2.2-16.88c0,0,5.86-24.21,20.59-21.02 c16.99,3.68,15.27,39.37,14.28,44.9c-1.26,7-4.57,24.05-16.68,25.42S1990.27,542.77,1989.81,535.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 1790.2268,
    y1: 493.1379,
    x2: 1750.8204,
    y2: 498.6772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5619,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1561
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9619,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M1761.96,494.78c0,0,7.81-11.68,10.66-14.98c2.86-3.29-4.45,23.75-4.82,32.52l-4.5-0.51 C1763.31,511.81,1765.98,503.55,1761.96,494.78z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1833.37,445.6c0.1-0.03,55.72,0.36,55.72,0.36l3.45,8.41c0,0-42.46-4.37-48.47-5.61 c-6.01-1.24-10.72-2.33-10.72-2.33L1833.37,445.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 1854.0729,
    y1: 433.6458,
    x2: 1872.6637,
    y2: 465.8461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005137858,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0225,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0325,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0435,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0705,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1138,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.94
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#282827",
      stopOpacity: 0.9457
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464645",
      stopOpacity: 0.9559
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787877",
      stopOpacity: 0.9694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC",
      stopOpacity: 0.9855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M1833.37,445.6c0.1-0.03,55.78,0.15,55.78,0.15l3.39,8.62c0,0-40.01-3.07-49.01-5.47 c-5.93-1.58-10.18-2.46-10.18-2.46L1833.37,445.6z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1665.13,475.09c0.25-1.23,0.5-2.45,0.77-3.68c0.04-0.17,0.22-0.38-0.01-0.49 c-0.26-0.12-0.37,0.13-0.45,0.33c-0.15,0.34-0.27,0.69-0.42,1.04c-0.06,0.15-0.18,0.3-0.36,0.27 c-0.21-0.03-0.19-0.23-0.19-0.38c-0.01-0.27,0.01-0.53-0.01-0.8c-0.02-0.19,0.1-0.49-0.23-0.49c-0.25,0-0.31,0.24-0.35,0.47 c-0.2,1.1-0.31,2.21-0.61,3.29c-0.1,0.37-0.22,0.61-0.63,0.5c-0.41-0.11-0.21-0.41-0.16-0.65c0.35-1.8,0.7-3.61,1.06-5.41 c0.15-0.54,0.14-1.11,0.31-1.64l0,0c0.5-0.27,0.92-0.03,0.94,0.31c0.09,0.68,0.12,1.36,0.17,2.04 c0.03,0.39,0.15,0.58,0.51,0.22l-0.01,0.01c0.34-0.62,0.41-0.98,0.65-1.45c0,0,0,0.01,0,0.01c0.24-0.43,0.28-0.71,0.52-1.06 c0.12-0.18,0.34-0.28,0.57-0.2c0.26,0.09,0.29,0.23,0.24,0.44c-0.46,2.32-0.91,4.64-1.36,6.96 C1665.95,475.35,1665.52,475.15,1665.13,475.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1694.44,475.6c-0.63,0.04-0.5-0.34-0.39-0.87c0.47-2.19,1.02-4.36,1.28-6.58 c0.06-0.5,0.29-0.76,0.84-0.73c0.75,0.04,1.32,0,2.07,0.03c0.23,0.01,0.88-0.09,0.82,0.43c-0.04,0.38-0.1,0.74-0.69,0.71 c-0.51-0.02-1.02,0.06-1.52-0.03c-0.6-0.11-0.61,0.49-0.71,1.29c-0.03,0.2,0.11,0.38,0.31,0.4c0.51,0.04,1.33-0.25,1.23,0.52 c-0.13,0.72-0.49,0.57-0.91,0.57c-1.16,0-0.95,0.03-1.14,1.17c-0.29,1.76-0.58,1.79,1.25,1.78c0.5,0,1.15-0.2,0.99,0.75 c-0.08,0.45-0.32,0.57-0.72,0.56c-0.43-0.01-0.85,0-1.28,0C1695.84,475.57,1694.84,475.58,1694.44,475.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1686.64,475.44c-0.13,0-0.28,0.03-0.4-0.01c-0.63-0.02-1.09,0.11-1.25-0.44 c-0.16-0.55-0.02-1,0.36-1.48c0.18-0.23,0.49-0.6,0.73-0.77c0.77-0.95,1.42-1.48,2.09-2.27c0.25-0.21,0.4-0.64,0.44-1.01 c0.05-0.39,0.05-0.73-0.38-0.83c-0.41-0.09-0.9-0.05-1.06,0.4c-0.05,0.15-0.07,0.31-0.14,0.45c-0.1,0.19-0.29,0.22-0.48,0.2 c-0.24-0.02-0.29-0.19-0.29-0.4c0.02-0.69,0.12-1.37,0.78-1.74c0.69-0.39,1.65-0.39,2.16,0c0.5,0.3,0.49,0.92,0.48,1.37 c-0.04,1.53-0.83,2.58-1.88,3.62c-0.4,0.39-0.82,0.76-1.22,1.15c-0.11,0.11-0.27,0.35-0.21,0.53 c0.07,0.21,0.26,0.13,0.46,0.13c0.37-0.01,0.75-0.05,1.12-0.05c0.26,0,0.6-0.02,0.57,0.37c-0.03,0.33-0.05,0.75-0.52,0.78 C1687.55,475.48,1687.1,475.45,1686.64,475.44C1686.64,475.45,1686.64,475.45,1686.64,475.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1690.96,475.44c-0.13,0-0.28,0.03-0.4-0.01c-0.63-0.02-1.09,0.11-1.25-0.44 c-0.16-0.55-0.02-1,0.36-1.48c0.18-0.23,0.49-0.6,0.73-0.77c0.77-0.95,1.42-1.48,2.09-2.27c0.25-0.21,0.4-0.64,0.44-1.01 c0.05-0.39,0.05-0.73-0.38-0.83c-0.41-0.09-0.9-0.05-1.06,0.4c-0.05,0.15-0.07,0.31-0.14,0.45c-0.1,0.19-0.29,0.22-0.48,0.2 c-0.24-0.02-0.29-0.19-0.29-0.4c0.02-0.69,0.12-1.37,0.78-1.74c0.69-0.39,1.65-0.39,2.16,0c0.5,0.3,0.49,0.92,0.48,1.37 c-0.04,1.53-0.83,2.58-1.88,3.62c-0.4,0.39-0.82,0.76-1.22,1.15c-0.11,0.11-0.27,0.35-0.21,0.53 c0.07,0.21,0.26,0.13,0.46,0.13c0.37-0.01,0.75-0.05,1.12-0.05c0.26,0,0.6-0.02,0.57,0.37c-0.03,0.33-0.05,0.75-0.52,0.78 C1691.86,475.48,1691.41,475.45,1690.96,475.44C1690.96,475.45,1690.96,475.45,1690.96,475.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1678.38,467.23c0.37,0.1,0.93-0.09,1.06,0.57c0.13,0.65-0.05,1.15-0.36,1.74 c-0.09,0.17-0.34,0.13-0.52,0.09c-0.24-0.07-0.24-0.25-0.19-0.45c0.11-0.41,0.23-0.82-0.41-0.89 c-0.54-0.05-0.95,0.09-1.07,0.7c-0.27,1.33-0.56,2.66-0.82,3.99c-0.08,0.43,0.06,0.84,0.52,0.96 c0.55,0.14,1.02-0.06,1.28-0.58c0.2-0.41,0.31-1.04,0.88-0.71c0.46,0.26,0.12,0.82-0.08,1.22c-0.37,0.74-0.85,1.35-1.77,1.43 c-1.26,0.11-1.95-0.57-1.75-1.83c0.2-1.26,0.48-2.52,0.72-3.77c0.04-0.18,0.1-0.36,0.13-0.54 C1676.26,467.62,1676.74,467.22,1678.38,467.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1672.83,472.69c-0.05-0.38-0.32-0.02-0.42,0.17c-0.33,0.66-0.67,1.32-1.01,1.98 c-0.14,0.27-0.33,0.55-0.68,0.37c-0.39-0.21-0.12-0.49,0-0.74c0.47-1,1.01-1.87,1.47-2.98c0.25-0.48,0.27-0.72,0.23-1.1 c-0.09-0.82-0.21-1.64-0.32-2.46c-0.05-0.35-0.02-0.67,0.4-0.73c0.43-0.06,0.55,0.26,0.58,0.6c0.04,0.45,0.05,0.91,0.07,1.36 c0.01,0.16,0.01,0.34,0.21,0.37c0.18,0.03,0.3-0.09,0.37-0.24c0.25-0.53,0.48-1.07,0.75-1.59c0.14-0.29,0.36-0.63,0.73-0.44 c0.4,0.21,0.15,0.52-0.01,0.81c-0.4,0.72-0.72,1.49-1.15,2.19c-0.36,0.6-0.35,1.22-0.27,1.86c0.1,0.85,0.23,1.69,0.33,2.54 c0.04,0.3,0.05,0.62-0.38,0.64c-0.39,0.02-0.57-0.16-0.6-0.57C1673.07,474.04,1673,473.56,1672.83,472.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1681.47,474.81c0.1-1.35,0.71-2.49,1.44-3.6c0.4-0.6,0.75-1.22,1.1-1.85c0.15-0.28,0.57-0.98-0.02-1 c-0.75-0.02-0.96-0.05-1.16,0.55c-0.04,0.13-0.04,0.27-0.08,0.39c-0.11,0.31-0.37,0.26-0.6,0.23 c-0.29-0.04-0.33-0.26-0.26-0.48c0.13-0.41,0.21-0.82,0.25-1.25c0.04-0.39,0.32-0.53,0.68-0.52c0.77,0,1.55,0.01,2.32,0.02 c0.46,0.01,0.57,0.22,0.52,0.68c-0.15,1.2-0.95,2.06-1.49,3.06c-0.68,1.25-1.7,2.34-1.75,3.87c-0.01,0.35-0.3,0.48-0.64,0.44 C1681.46,475.3,1681.44,475.06,1681.47,474.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1663.54,465.77c-1.07,0-1.93,0-2.54,0c-0.58,0-1.09,0.41-1.22,0.98l-2.04,9.13 c-0.17,0.78,0.41,1.52,1.21,1.52l1.75,0.01l0.45-0.12L1663.54,465.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1660.42,477.23l-0.55-0.01l38.19,0.17c0.6,0,1.13-0.27,1.25-0.65c0,0-0.53,1.17-2.46,1.17 s-34.23,0-36.25,0c-2.86,0-2.61-0.82-2.61-0.82l2.27,0.12l0.35,0.03"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0978 -0.9952 0.9952 0.0978 1033.4983 2088.0098)",
    fill: "#5E5D5B",
    cx: 1668.42,
    cy: 473.97,
    rx: 2.06,
    ry: 1.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1278 -0.9918 0.9918 0.1278 991.0299 2064.4302)",
    fill: "#D25959",
    cx: 1669.26,
    cy: 468.76,
    rx: 1.84,
    ry: 1.2
  })))))), /*#__PURE__*/React.createElement("g", null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1810.71,457.01c0,0,0.43,1.44,1.03,3.54c0.6,2.1,2.25,7.36,2.85,8.71c0.6,1.35,2.1,2.7,4.8,2.7 c2.7,0,11.24-0.3,13.21-0.3c2.38,0,2.14-3.45,0.33-7.65c-1.8-4.2-2.56-7.57-8.44-8.11c-4.96-0.46-9.68-0.65-11.48-0.65 S1810.34,455.49,1810.71,457.01z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1833.94,458.51c0.77,2.07,2.03,5.52,2.9,8.06c0.45,1.3,1.94,1.9,3.16,1.27l13.38-6.98 c0.95-0.5,1.42-1.6,1.11-2.62c0,0-0.66-4.47-2.35-8.07c-1.05-2.24-2.98-2.55-4.24-1.84l-12.96,7.46 C1833.99,456.33,1833.56,457.48,1833.94,458.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 1833.8043,
    y1: 458.0406,
    x2: 1854.5885,
    y2: 458.0406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0382
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.0749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M1833.94,458.51c0.77,2.07,2.03,5.52,2.9,8.06c0.45,1.3,1.94,1.9,3.16,1.27l13.38-6.98 c0.95-0.5,1.42-1.6,1.11-2.62c0,0-0.66-4.47-2.35-8.07c-1.05-2.24-2.98-2.55-4.24-1.84l-12.96,7.46 C1833.99,456.33,1833.56,457.48,1833.94,458.51z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C9C6",
    d: "M1831.65,461.34l4.26-1.75c0,0,0-1.2,2.18-2.18c2.18-0.98,8.96-5.13,10.49-5.79 c1.53-0.66,4.37,4.37,3.06,6.99l-12.78,7.1l-1.75-2.29l-4.26,1.75L1831.65,461.34z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1815.4,461.85c0,0-0.58-1.39-1.1-3.31c-0.52-1.91,5.51-1.22,8.64-1.04c3.13,0.17,3.71,0.99,4.18,1.86 L1815.4,461.85z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1815.4,461.85l2.36,6.12c0,0,2.55-1.47,3.95-2.49c1.4-1.02,1.34-2.11,1.59-2.93 c0.19-0.6,0.68-1.8,1.56-2.49c-2.1-0.46-5.19-0.53-6.52-0.53C1816.34,460.42,1815.4,461.85,1815.4,461.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1815.4,461.85l2.36,6.12c0,0,2.55-1.47,3.95-2.49c1.4-1.02,1.34-2.11,1.59-2.93 c0.19-0.6,0.68-1.8,1.56-2.49c-2.1-0.46-5.19-0.53-6.52-0.53C1816.34,460.42,1815.4,461.85,1815.4,461.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFB",
    d: "M1828.29,461.21c-0.26-2.49-3.19-2.62-7.14-2.36c-1.1,0.07-2.02,0.34-2.79,0.68 c1.33,0.01,4.42,0.08,6.52,0.53c0.34-0.26,0.72-0.46,1.18-0.51C1827.71,459.36,1828.29,461.21,1828.29,461.21z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1828.29,461.21l7.74,0.22c0,0-2.23,3.34,0.06,5.19l-8.72-0.56c0,0-1.79,2.72-3.83,4.2 c0,0-2.23,0.25-3.65,0.06c-1.42-0.19-1.85-1.57-2.13-2.36l5.97-7.72c0,0,1.17-1.11,2.6-0.87 C1827.74,459.64,1828.29,461.21,1828.29,461.21z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFB",
    d: "M1828.29,461.21c0,0-0.66-1.51-1.9-1.26c-1.24,0.25-2.04,2.16,1.92,2.16c3.96,0,7.3,0.12,7.3,0.12 s-0.12-0.56,0.74-0.87L1828.29,461.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 1818.3503,
    y1: 460.0325,
    x2: 1828.285,
    y2: 460.0325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.0617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.00806646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M1821.14,458.85c-1.1,0.07-2.02,0.34-2.79,0.68c1.33,0.01,4.42,0.08,6.52,0.53 c0.34-0.26,0.72-0.46,1.18-0.51c1.66-0.19,2.23,1.66,2.23,1.66"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1836.8,467.29c-1.1,0-2-1.41-2-3.15s0.9-3.15,2-3.15h1.38v6.3H1836.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 1834.7998,
    y1: 464.1444,
    x2: 1838.1815,
    y2: 464.1444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M1836.8,467.29c-1.1,0-2-1.41-2-3.15s0.9-3.15,2-3.15h1.38v6.3H1836.8z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E5D5B",
    cx: 1838.18,
    cy: 464.14,
    rx: 2,
    ry: 3.15
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1815.34,461.7l1.95,4.98c0,0-1.43-4.62-1.3-5.63"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 1622.2015,
    y1: 539.7071,
    x2: 1647.3993,
    y2: 539.7071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M1626.19,532.03c0,0,11.71,0.43,13.57,0.95c1.87,0.52,2.12,1.21,2.71,4.49 c0.59,3.28,1.36,5.95,1.36,5.95l3.56,3.97l-5.68-0.52l-0.25-0.95l-5.26-0.26l-0.17,1.12l-12.98-1.73l-0.85-3.62L1626.19,532.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 1652.2188,
    y1: 460.4915,
    x2: 1753.6238,
    y2: 401.9453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008980082,
    style: {
      stopColor: "#F2F2F1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    style: {
      stopColor: "#C5C5C5",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0782,
    style: {
      stopColor: "#9D9D9C",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#7A7A79",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1592,
    style: {
      stopColor: "#5D5D5C",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2056,
    style: {
      stopColor: "#454544",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#323232",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3204,
    style: {
      stopColor: "#262625",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9317
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9458
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8144,
    style: {
      stopColor: "#323231",
      stopOpacity: 0.9564
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8523,
    style: {
      stopColor: "#444443",
      stopOpacity: 0.9653
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8855,
    style: {
      stopColor: "#5B5B5B",
      stopOpacity: 0.9731
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9155,
    style: {
      stopColor: "#787877",
      stopOpacity: 0.9801
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#9A9A9A",
      stopOpacity: 0.9866
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9686,
    style: {
      stopColor: "#C2C2C2",
      stopOpacity: 0.9926
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9918,
    style: {
      stopColor: "#EEEEEE",
      stopOpacity: 0.9981
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M1642.9,438.45c-1.1,1.19-4.13,3.57,1.45,3.92c5.58,0.35,36.89,0.18,36.89,0.18 s28.86,0,40.52-0.58c11.66-0.58,31.57-0.58,35.41-5.78c3.84-5.21,8.39-13.59,8.39-13.59s-0.18-0.34-0.58-0.89 c-1.75-2.42-7.71-8.94-21.03-8.94c-16.35,0-61.43,0-66.12,0c-4.57,0-12.07,0.83-21.06,10.41c-0.23,0.25-0.47,0.5-0.7,0.76 C1646.75,434.24,1644,437.26,1642.9,438.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 1658.2787,
    y1: 471.5412,
    x2: 1701.1261,
    y2: 471.5412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7009,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8971,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.1233
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9457,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0161
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M1699.94,465.71c-6.83-0.18-27.69-0.16-35.98-0.15c-1.04,0-1.88,0-2.48,0 c-0.57,0-1.06,0.41-1.19,0.98l-1.99,9.18c-0.17,0.78,0.4,1.52,1.18,1.53l1.71,0.01l36.84,0.26c0.58,0,1.09-0.42,1.2-1l1.85-9.31 C1701.25,466.45,1700.7,465.73,1699.94,465.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 1811.2042,
    y1: 548.3428,
    x2: 1865.1589,
    y2: 548.3428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M1815.94,551.58c-0.59-7.4-3.21-15.3-4.73-20.64c0,0,10.15-25.79,31.96-22.18 c25.14,4.16,22.61,44.48,21.14,50.73c-1.86,7.91-6.76,27.17-24.69,28.72S1816.62,560.01,1815.94,551.58z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1840.16,428.58l0.29-6.57c-0.05,0.02-0.09,0.03-0.14,0.05C1840.19,422.98,1840.08,425.34,1840.16,428.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1862.12,418.66c-0.02,0.24-0.01,1.38-0.02,1.61c-0.13,2.31-0.27,3.87-0.3,5.63 c-0.16,8.3-0.72,13.81-1.54,17.21c-0.05,0.22-0.1,0.39-0.15,0.53l-0.04,0.48c0.51-0.28,0.82-0.4,1.41-0.49 c0.75-0.12,1.14-0.39,1.8-0.75l0.04,0.01c1.49-4.52,1.17-10.56,0.78-12.2c-0.55-2.32-0.9-5.55-1.11-8.26 c-0.23-0.15-0.35-0.27-0.35-0.27L1862.12,418.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1869.01,421.26c-0.79,0.49-2.25,1.37-2.77,1.52c-1.62,0.46-2.73-0.01-3.25-0.35 c0.21,2.71,0.55,5.94,1.11,8.26c0.39,1.64,0.71,7.69-0.78,12.2l-0.04-0.01c-0.66,0.36-1.05,0.63-1.8,0.75 c-0.59,0.09-0.91,0.21-1.41,0.49c-0.13,0.07-0.27,0.16-0.44,0.25c-0.81,0.48-1.59-0.18-1.32,0.78c0.14,0.5,0.88,0.6,1.63,0.55 c0.7-0.05,1.4-0.22,1.63-0.34c0.48-0.24,0.66-0.09,0.54,0.36c-0.12,0.45-0.69,1.26-1.2,2.06c-0.51,0.81-0.63,1.59-0.72,2.75 c-0.09,1.17-0.21,1.62,0.45,1.65c0.66,0.03,0.99-1.59,1.32-2.54c0.33-0.96,1.11-2.12,1.11-2.12s-0.09,0.33-0.24,0.81 c-0.15,0.48-0.48,1.56-0.3,2.21s0.39,1.26,0.96,1.38c0.57,0.12,0.78-0.99,0.78-0.99c0.12,0.51,0.51,0.99,1.08,0.96 s0.9-1.23,1.08-1.89c0.18-0.66,0.54-1.23,0.54-1.23c-0.09,0.27,0,0.87-0.12,1.26c-0.12,0.39-0.24,1.02,0.18,1.05 c0.42,0.03,0.42,0.03,1.14-0.66c0.72-0.69,0.3-1.02,0.36-2.12c0.05-0.87-0.9-2.55-1.06-3.47c0.85-5.56,1.64-5.09,2.29-10.81 C1870.19,430.22,1869.61,425.04,1869.01,421.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1847.74,444.27c0,0-1.21-0.07-1.83-0.26c-1.2-0.35-2.2-0.78-2.94-0.59c-1.19,0.3-1.33-0.81-1.44-1.46 c-0.83-5.04-1.15-9.8-1.23-13.46c-0.08-3.23,0.27-5.89,0.38-6.82c-1.5,0.47-4.19,0.93-6.18-1.32c-0.1,1.75-0.42,9.18,0.83,16.57 c0.72,4.27,2.25,9.49,2.25,9.49s0.3,0.64,0.54,1.65s0.78,1.65,1.14,2.54c0.36,0.89,1.08,1.8,1.78,1.35c0,0,0.69,1.4,1.42,1.22 c0.73-0.17,0.59-0.7,0.59-0.7s0.63,0.49,1.16,0.24s0.43-1.36,0.43-1.36s0.69,0.14,0.93-0.28c0.23-0.42,0.07-2.66,0.03-3.04 s-0.72-2.44-0.72-2.44s1.82,0.13,2.21,0.03c0.13-0.03,0.24-0.08,0.34-0.12C1848.18,445.13,1847.74,444.27,1847.74,444.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1846.47,409.39c-0.09-0.03-0.17-0.06-0.25-0.09C1846.34,409.36,1846.43,409.38,1846.47,409.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1868.12,413.35c-0.23-1.58-0.86-4.98-2.38-5.97c-1.48-0.96-4.24-0.88-6.67-0.57 c-1.41,0.18-2.82,0.39-3.7,0.56c-0.14,1.93-0.13,2.31-0.27,3.25c-0.52,3.56-1.6,4.82-3.91,4.82c-4.27,0-4.54-6-4.54-6.1 c0,0-0.12,0.04-0.14,0.03c-0.23-0.22-1.37-1.46-1.41-1.53c-0.14-0.21-0.44-0.61-0.76-1.17c-0.03,0-2.06-0.28-2.21-0.31 c-0.01-0.01-0.01-0.02-0.01-0.03c-2.7-0.44-6.36-0.73-7.05,1.53c-1.24,4.07-1.24,11.98-1.24,11.98 c0.17,0.24,0.35,0.46,0.52,0.66c2,2.25,4.46,1.99,5.95,1.52c0.05-0.02,0.1-0.03,0.14-0.05l-0.29,6.57 c0.08,3.66,0.41,8.43,1.23,13.46c0.11,0.65,0.23,1.85,1.42,1.55c0.74-0.18,1.75,0.23,2.94,0.58c0.62,0.18,1.87,0.29,1.87,0.29 s0.28,0.79-0.49,1.18l12.79,0.2l0.01-0.14c-0.75,0.05-1.49-0.05-1.63-0.55c-0.27-0.96,0.51-0.3,1.32-0.78 c0.17-0.1,0.31-0.18,0.44-0.25l0.04-0.48c0.05-0.13,0.1-0.3,0.15-0.53c0.82-3.4,1.38-8.91,1.54-17.21 c0.03-1.76,0.17-3.32,0.3-5.63c0.01-0.23,0-1.36,0.02-1.61l0.52,3.5c0,0,0.12,0.12,0.35,0.27c0.53,0.34,1.63,0.81,3.25,0.35 c0.52-0.15,1.97-1.03,2.77-1.52c0.32-0.2,0.53-0.33,0.53-0.33S1868.53,416.13,1868.12,413.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1856.35,404c0,0-0.01-0.35,0.05-0.96c0.05-0.02,0.07-0.03,0.12-0.05c1-0.32,1.71-1.82,1.98-2.6 c0.27-0.78,0.37-2.07-0.77-2.08c-0.35,0-4.89-6.96-4.89-6.96c-0.8,0.64-5.59,0.04-5.57-1.07c-0.17,1.11-4.85,1.61-4.35,0.54 c0,0-0.06,0.13-0.14,0.35c-0.17,0.47-0.56,1.36-0.5,2.35c-0.13,1.43-0.28,2.42-0.15,2.96c0,0.13,0.02,0.09,0.02,0.34 c-0.02,0.45-0.08,0.72-0.03,1.15c0.27,2.15-0.15,3.97,0.3,5.53c0.05,0.19,0.09,0.34,0.17,0.54c0.01,0.02,0.06,0.09,0.07,0.11 c0.34,0.88,0.92,1.79,1.37,2.58c0.32,0.56,0.58,1.03,0.72,1.24c0.05,0.08,0.14,0.18,0.2,0.27c0.54,0.68,0.94,1.08,1.25,1.15 c0.08,0.03,0.2-0.03,0.29-0.01c0.02,0.01,0.04,0.01,0.04,0.01c0,0,0,0,0,0c0.01,0.1,0.41,6.23,4.68,6.23 c2.31,0,3.52-1.45,4.04-5c0.14-0.94,0.11-1.27,0.25-3.19c0.04-0.54,0.3-1.14,0.38-1.98C1856.43,404.63,1856.35,404,1856.35,404z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1843.12,398.08c-0.35,0.19-0.38,0.51-0.38,0.51s0.11,0.01,0.41-0.01c0.04,0,0.09-0.01,0.15-0.01 C1843.28,398.57,1843.01,398.43,1843.12,398.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1846.26,403.5c-0.39-0.01-0.72,0.05-0.92,0.19c0.11-0.05,0.38-0.16,0.87-0.19 C1846.23,403.49,1846.25,403.5,1846.26,403.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1848.25,404.76c0.01-0.01,0.01-0.02,0.02-0.03C1848.26,404.74,1848.26,404.75,1848.25,404.76 C1848.25,404.76,1848.25,404.76,1848.25,404.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1845.81,405.62c0.3,0.29,0.71,0.41,1.22,0.23c-0.11,0.03-0.23,0.05-0.35,0.05 C1846.26,405.92,1845.99,405.78,1845.81,405.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1844.98,403.95l0.05-0.02c0,0,0.14,0.73,0.48,1.31c0,0-0.02-0.75,0.9-0.89 c0.92-0.14,1.52-0.13,1.91,0.08c0,0,0.09,0.08,0.01,0.21c0.16-0.24,0.27-0.45,0.33-0.56l-0.14-0.13 c-0.21-0.06-0.65-0.26-1.03-0.35c-1.12,0.45-1.88,0.09-1.99,0.05c0,0-0.22,0.09-0.22,0.09 C1845.19,403.84,1845.08,403.9,1844.98,403.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1847.44,400.67c-0.08-0.14-0.12-0.22-0.12-0.22C1847.34,400.51,1847.39,400.59,1847.44,400.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1847.57,403.7c-0.26-0.06-0.44-0.26-0.64-0.29c-0.2-0.03-0.48,0.01-0.67,0c-0.02,0-0.02,0-0.04,0 c-0.48,0.03-0.77,0.13-0.88,0.19c-0.01,0.01-0.03,0.12-0.04,0.13C1845.41,403.76,1846.45,404.14,1847.57,403.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1846.82,405.43c-0.79,0.02-1.31-0.19-1.31-0.19s0,0.27,0.22,0.45c0.18,0.15,0.5,0.34,0.92,0.34 c0.12,0,0.33-0.01,0.44-0.05c0.71-0.21,1.08-1.08,1.16-1.23c0,0,0,0,0,0C1848.01,405.08,1847.62,405.41,1846.82,405.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M1846.38,404.2c-0.92,0.14-0.87,1.04-0.87,1.04s0.44,0.32,1.24,0.3c0.8-0.02,1.26-0.46,1.5-0.78 c0.01-0.01,0.01-0.02,0.02-0.03c0.02-0.03,0.05-0.07,0.06-0.1c0.08-0.13,0.12-0.23,0.12-0.23 C1848.07,404.2,1847.3,404.06,1846.38,404.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1857.48,393.07L1857.48,393.07c0.01-0.02,0.02-0.06,0.03-0.1L1857.48,393.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1844.61,404.52c-0.01-0.05-0.03-0.11-0.04-0.17C1844.58,404.56,1844.67,404.75,1844.61,404.52z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1839.56,447.53c0,0,0.56,1.85,0.76,2.9c0.15,0.79,0.26,1.43,0.31,1.71c0.02,0.09,0.02,0.14,0.02,0.14 l0.26-0.14c0,0,0-0.03-0.01-0.07c-0.03-0.26-0.17-1.27-0.49-2.21C1840.05,448.79,1839.56,447.53,1839.56,447.53z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1841.84,449.11c0.09,0.6,0.82,3.33,0.97,3.86c0.02,0.06,0.02,0.09,0.02,0.09l0.1-0.38 c0,0-0.01-0.04-0.03-0.11c-0.17-0.71-1.13-4.71-1.49-5.7C1841.41,446.87,1841.74,448.44,1841.84,449.11z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1843.44,447c-0.16-0.58-0.27-0.98-0.25-1.15c0,0-0.11,0.07,0.02,0.75c0.13,0.69,0.53,2.03,0.62,2.59 c0.08,0.54,0.57,2.22,0.63,2.9c0,0.03,0,0.06,0.01,0.08l0.05-0.62c0,0-0.01-0.04-0.02-0.11c-0.07-0.33-0.27-1.35-0.57-2.62 C1843.75,448.12,1843.58,447.5,1843.44,447z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1845.66,398.79c0-0.07,0.01-0.14,0.01-0.21c0-0.11-0.01-0.23-0.02-0.35c-0.05-0.61-0.23-1.13-0.23-1.13 c0.01,0.02,0.02,0.04,0.03,0.06c-0.22-0.5-0.59-0.74-0.59-0.74c-1.21-0.75-1.96,0.09-1.96,0.09c0.04,0,0.08,0,0.12,0 C1845.13,396.47,1845.57,398.02,1845.66,398.79z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1845.02,445.33c-0.27-0.12-1.17-0.53-1.4-0.64c1,0.51,1.24,0.93,1.24,0.93l0.8,0.05 c0,0,0.07,0.02-0.06-0.06C1845.51,445.56,1845.35,445.47,1845.02,445.33z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1839.47,431.1c-0.09,2.25-1.29,2.67-1.59,2.73c0.34-0.06,1.92-0.19,2.11,2.11 c0.21,2.58,0.72,5.15,0.82,6.49c0.1,1.34,1.47,1.15,1.47,1.15s0,0,0,0c-0.01-0.06-0.58-1.18-0.85-2.62 c0.05-1.16,0.13-3.17,0.24-5.48c0.02-0.02,0.04-0.04,0.06-0.08c0.54-0.95,2.55,0.31,3.73,1.19c-2.19-2.05-5.69-6.94,0.73-3.18 c6.81,3.99,9.27,3.75,6.69,2.82c-2.58-0.94-6.69-2.82-8.33-5.87c-1.64-3.05-2.46-5.63-2.02-10.01c0,0-0.06,0.54-0.14,1.41 c0.05-0.71,0.1-1.21,0.14-1.41c0.32-1.6,1.04-2.47,0.32-1.75c-0.72,0.72-1.28,1.28-1.44-0.08s-0.59-4.94-0.59-4.94 s0.03,2.39-0.05,4.46c-0.06,1.46-0.33,3.58-0.49,4.01c-0.24,0.09-1.17,0.26-1.16,0.28 C1839.16,422.79,1839.57,428.63,1839.47,431.1z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1867.53,444.28c0.03-0.19,0.07-0.41,0.12-0.65c0.19-0.94,0.48-2.26,0.88-3.66 c0.46-1.63,0.69-2.45,1.01-4.32c0.17-1.03,0.35-1.95,0.38-2.62c0.12-2.84,0.19-6.15-0.89-11.77c0-0.02,0,0-0.01-0.05 c-2.38,1.82-4.16,1.77-4.16,1.77l-0.12,0.05c1.98,4.24,2.91,6.43,2.29,8.98c-0.39,1.62-0.44,2.99-0.09,4.76 c0.57,2.83-0.29,5.94-0.34,7.23c0,0,0,0.01,0,0.01c-0.28,2.44,0,2.7-0.56,4.95c-0.14,0.57-0.27,0.96-0.38,1.22 c-0.4,0.04-1.11,0.07-1.14-0.27c-0.03-0.48,0.58-2.48,0.27-2.01c-0.31,0.48-0.51,2.21-0.88,2.21c-0.35,0-0.89,0.01-1.43-0.05 c-0.04,0,0.04,0,0,0c-0.03,0.82,0.49,2.07,1.2,1.85c0.51-0.16,0.58-0.96,0.58-0.96c-0.02,0.17,0.19,0.49,0.33,0.64 c0.2,0.21,0.29,0.28,0.53,0.32c0.41,0.07,0.61-0.09,0.95-0.78c0,0,0.13-0.4,0.12-0.37c0.05-0.17,0.07-0.29,0.21-0.75 c0.07-0.23,0.33-0.84,0.51-1.12c-0.01,0.31-0.01,0.78-0.09,1.18c-0.03,0.12-0.07,0.26-0.09,0.38c-0.04,0.37,0.01,0.66,0.38,0.64 c0.52-0.02,0.39-0.1,0.57-0.24c0.11-0.08,0.21-0.17,0.29-0.25c0.52-0.44,0.69-0.78,0.55-1.6c-0.03-0.16-0.02-0.61-0.03-0.81 c-0.04-0.54-0.16-0.89-0.38-1.49c-0.08-0.24-0.16-0.32-0.22-0.51c-0.1-0.31-0.32-0.85-0.39-1.07c-0.14-0.46-0.01-0.44-0.02-0.53 c0-0.03,0.01-0.06,0.01-0.09C1867.51,444.42,1867.52,444.35,1867.53,444.28z M1867.21,448.71c0-0.02,0-0.04,0-0.05c0,0,0,0,0,0 C1867.21,448.67,1867.21,448.69,1867.21,448.71z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1863.01,446.98c0.04-0.37-0.33,0.29-0.84,1.21c-0.51,0.92-0.81,1.32-0.95,2.27 c-0.14,0.9-0.48,1.5-0.98,1.56c-0.03,0,0.03,0,0,0c0,0,0.36,0.34,0.68,0.12c0.35-0.23,0.62-1.05,0.76-1.6 c0.15-0.55,0.5-1.55,0.76-1.99s0.62-1.03,0.62-1.03S1862.97,447.34,1863.01,446.98z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1850.82,398.57c0.04,0,0.06,0,0.06,0l-0.12-0.06c-0.26-0.24-0.98-0.85-1.68-0.8 c-0.86,0.06-1.25,0.84-1.25,0.84s0.37-0.53,0.96-0.68c-0.05,0.02-0.1,0.04-0.16,0.07c0,0-0.13,0.33,0.09,0.59l0.83,0.01 c0,0,0.29-0.15,0.2-0.55c0.38,0.15,0.74,0.37,0.94,0.5c-0.11,0.01-0.49,0.04-1,0.04c-0.53,0,0.77,0.02,1.1,0.03 c0.03,0.02,0.05,0.04,0.05,0.04S1850.85,398.59,1850.82,398.57z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1844.14,398.01c0.49,0.14,0.86,0.46,0.86,0.46s-0.47-0.75-1.49-0.6c-0.71,0.11-0.92,0.77-0.92,0.77 s0.9-0.01,1.3-0.05c0.06-0.01,0.1-0.01,0.1-0.02c0,0,0,0-0.01-0.01l0.1,0C1844.24,398.38,1844.17,398.11,1844.14,398.01z  M1842.73,398.59c0,0,0.03-0.32,0.38-0.51c-0.11,0.35,0.17,0.49,0.18,0.49c-0.06,0-0.11,0-0.15,0.01 C1842.85,398.6,1842.73,398.59,1842.73,398.59z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1849.57,397.61c0.29,0.06,0.57,0.16,0.85,0.28c0.28,0.12,0.55,0.24,0.82,0.38 c-0.48-0.37-1.04-0.65-1.64-0.8c-0.3-0.07-0.63-0.09-0.94-0.01c-0.31,0.07-0.59,0.29-0.69,0.57c0.15-0.26,0.43-0.41,0.71-0.46 C1848.98,397.51,1849.28,397.53,1849.57,397.61z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1851.69,397.03c0,0-0.94-1.26-2.17-1.24c-1.23,0.02-1.85,0.83-1.85,0.83s0.8-0.23,1.86-0.25 C1850.59,396.35,1851.69,397.03,1851.69,397.03z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1844.61,401.77c0.08-0.18,0.15-0.3,0.2-0.39c0,0.08,0.03,0.16,0.1,0.26c0,0,0,0.01,0,0.01 c-0.02,0.07,0.03,0.1,0.11,0.11c0.02,0.01,0.03,0.03,0.04,0.04c-0.01-0.01-0.02-0.03-0.03-0.04c0.12,0.01,0.28-0.02,0.37-0.03 c0.11,0.1,0.26,0.15,0.47,0.07c0,0-0.63,0.05-0.58-0.7c0.03-0.39,0.31-1.19,0.39-1.88s0.1-1.48-0.25-2.12c0,0,0.36,1.08,0.2,1.96 c-0.15,0.88-0.39,1.97-0.42,2.15c-0.02,0.09,0.02,0.29,0.13,0.44c-0.17-0.09-0.32-0.16-0.39-0.07c-0.06-0.2-0.04-0.48,0.3-0.63 c0,0-0.19,0.06-0.32,0.18c0.03-0.1,0.05-0.21,0.05-0.39c0,0-0.39,0.78-0.59,1.54c-0.07,0.26-0.07,0.55-0.05,0.81 C1844.32,402.58,1844.47,402.1,1844.61,401.77z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1847.22,401.45c-0.04-0.22-0.8,0.25-0.8,0.25C1847.04,401.77,1847.26,401.67,1847.22,401.45z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1847.5,401.2c-0.06-0.4-0.46-0.41-0.46-0.41c0.14-0.02,0.33,0.17,0.39,0.44 c0.03,0.15-0.03,0.27-0.13,0.37C1847.42,401.5,1847.53,401.38,1847.5,401.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1847.29,401.59c-0.15,0.1-0.32,0.15-0.32,0.15"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1847.29,401.59c-0.09,0.08-0.2,0.14-0.32,0.15"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1842.78,397.77c0.2-0.14,0.45-0.2,0.7-0.21c0.26-0.02,0.51,0.02,0.76,0.08 c0.24,0.07,0.48,0.17,0.67,0.33c-0.3-0.39-0.9-0.56-1.43-0.54c-0.27,0.02-0.56,0.09-0.76,0.26c-0.21,0.16-0.33,0.38-0.37,0.61 C1842.43,398.09,1842.59,397.9,1842.78,397.77z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1844.56,404.35c-0.02-0.16,0-0.34,0.16-0.32c0.15,0.26,0.41,1.17,0.7,1.64 c0.29,0.46,0.56,0.89,1.56,0.73c0.99-0.16,1.01-0.83,1.33-1.29c0.25-0.36,0.35-0.82,0.38-1.01c0.19,0.03,0.26,0.61,0.26,0.59 c0-0.01-0.06-0.52-0.09-0.81c0-0.16-0.02-0.63-0.23-1.19c-0.04-0.12-0.11-0.25-0.18-0.39c-0.29-0.55-0.76-1.21-1.02-1.63 c0.21,0.38,0.66,1.18,0.93,1.78c0.25,0.54,0.39,1.02,0.45,1.28c-0.12,0.18-0.3,0.12-0.35,0.15l0.01,0.01 c-0.48-0.2-1.57-0.65-1.82-0.73c-0.32-0.1-0.44-0.02-0.68,0.06s-0.21-0.36-0.77,0c-0.39,0.25-0.47,0.54-0.48,0.69 c-0.05,0.1-0.16,0.04-0.26-0.23c-0.02-0.05-0.03-0.08-0.04-0.08c-0.03-0.15-0.07-0.32-0.09-0.5c0.01,0.18,0.03,0.36,0.08,0.55 C1844.43,403.77,1844.5,404.09,1844.56,404.35z M1845.3,403.72c0.01-0.01,0.03-0.02,0.04-0.03c0.19-0.15,0.53-0.2,0.92-0.19 c0.19,0,0.39,0.02,0.58,0.05c0.2,0.03,0.46,0.09,0.72,0.15c0.37,0.09,0.75,0.19,0.96,0.25l0.14,0.13 c-0.06,0.11-0.18,0.32-0.33,0.56c-0.02,0.03-0.04,0.06-0.06,0.1c-0.01,0.01-0.01,0.02-0.02,0.03c-0.08,0.15-0.51,0.89-1.22,1.1 c-0.51,0.17-0.92,0.06-1.22-0.23c-0.21-0.18-0.29-0.38-0.29-0.38c-0.34-0.59-0.48-1.31-0.48-1.31l-0.05,0.02 c0.1-0.05,0.21-0.11,0.31-0.22C1845.29,403.73,1845.3,403.73,1845.3,403.72z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1856.55,401.38c-0.24,0.33-0.16,0.56,0.03,0.38c0.19-0.19,0.59-0.67,0.53-0.84 c-0.05-0.16-0.28-0.11-0.34-0.44c0,0-0.09,0.03-0.07,0.24C1856.71,400.94,1856.79,401.05,1856.55,401.38z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1857.39,400.64c-0.02,0.24-0.04,0.44-0.04,0.44s0.2-0.2,0.22-0.46c0.02-0.26-0.01-0.41-0.13-0.78 c-0.12-0.37,0.14-0.71,0.37-0.72c0.32-0.02,0.37,0.8,0.37,0.8c0.02-0.36,0.08-0.88-0.2-1.05c-0.29-0.17-0.52,0.08-0.65,0.24 c-0.13,0.16-0.47,0.92-0.35,1.24C1857.11,400.68,1857.41,400.4,1857.39,400.64z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1856.61,402.43c0.78-0.2,1.29-1.79,1.29-1.79C1857.6,401.53,1856.61,402.43,1856.61,402.43z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1843.97,389.79c0,0,0.83-0.7,2.14-0.89c1.39-0.2,2.57-0.31,4.61,0.2c2.32,0.58,3.26,1.92,3.26,1.92 s1.45,1.4,2.18,3.05c0.45,1.02,1.19,2.98,1.47,4.32s-5.5-6.62-5.5-6.62l-7.32-0.16l-2.07-0.13l0.18-0.66L1843.97,389.79z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1842.09,406.99c-0.18,2.16,0.16,3.86,0.39,5.1c0.17,1.76,0.47,3.5,0.91,5.22 c-0.18-1.06-0.21-2.14-0.07-3.21c0.24,0.79,0.48,1.58,0.72,2.37c0.1,0.33,0.36,0.74,0.68,0.6c-0.61-0.84,0.13-0.68,0.38,0.46 c0.14-1.27,0.71-1.87,1.07-0.96c-0.07-1.15-0.03-2.31,0.12-3.46c0.02-0.01,0.03-0.01,0.05-0.02c0.12,1.12,0.32,2.24,0.6,3.33 c0.16-1.25-0.39-6.16-0.41-6.72c0-0.11-0.01-0.22-0.01-0.34c0,0,0,0,0,0c0,0-0.01,0-0.04-0.01c-0.04-0.01-0.13-0.03-0.25-0.09 c-0.26-0.13-0.73-0.39-1.23-1.11c-0.29-0.4-0.49-0.76-0.85-1.4c0.03,0.01-1.03-1.88-1.37-2.77c-0.01-0.02-0.01-0.03-0.02-0.05 c-0.08-0.2-0.15-0.4-0.2-0.59c-0.45-1.56,0-3.25-0.27-5.39c-0.05-0.44-0.06-0.68-0.05-1.13c0.16-0.15,0.43-0.31,0.87-0.38 c0.89-0.14,1.76-0.07,1.76-0.07s-0.76-0.56-1.72-0.47c-0.04,0-0.09,0.01-0.13,0.01c-0.37,0.05-0.61,0.21-0.76,0.4 c0.03-0.57,0.08-1.42,0.14-2.84c-0.09-1.47,0.51-2.7,0.51-2.7c-0.5,1.08-0.4,2.4-0.4,2.4l0.38,1.43 c0.02,0.03,0.03,0.06,0.05,0.08l0.97,0.07c0,0,0.51-0.15,0.51-0.02c0,0.04,0.11,0.07,0.27,0.1c-0.01-0.13,0.07-0.26,0.19-0.3 c0-0.12,0.01-0.24,0.01-0.36c0.08,0.12,0.12,0.26,0.14,0.41c0.01-0.2,0.01-0.41,0.02-0.61c0.12,0.32,0.23,0.63,0.35,0.95 c0.01,0,0.01,0,0.02,0c-0.16-0.69-0.14-0.97-0.19-1.73c-0.02-0.29-0.13-0.4-0.03-0.68c0.06,1.06,0.2,1.51,0.48,2.43 c0.03,0,0.06,0,0.08,0.01c0-0.21,0-0.42,0-0.63c0.07,0.13,0.11,0.27,0.14,0.41c-0.07-0.26-0.09-0.53-0.07-0.79 c0.08,0.24,0.16,0.49,0.24,0.73c0.01,0,0.02-0.01,0.03-0.01c-0.11-0.46-0.2-0.92-0.26-1.39c0.16,0.53,0.34,1.06,0.54,1.58 c0,0,0,0,0,0.01l0.01,0c-0.28-1.09-0.54-2.21-0.37-3.31c-0.02,1.11,0.23,2.23,0.73,3.22l0.06,0.07l1.13-0.07l0.71,0.14l2.88,0.09 c0,0-0.08-1.73,0.72-2.36c0,0,0,0.13,0.23,1.52c0.19,1.15,1.82,2.2,2.15,3.01c0.47,1.16,1.25,1.16,1.44,1.38 c0.04,0.35,0.09,0.7,0.18,1.04l0.49-0.97c0.23-0.17,0.52-0.3,0.87-0.29c1.14,0.02,1,1.16,0.73,1.94 c-0.27,0.78-0.99,2.26-1.99,2.58c-0.06,0.02-0.11,0.04-0.16,0.05c-0.06,0.61-0.09,0.99-0.09,0.99s0.09,0.61-0.48,1.43 c-0.07,0.84-0.12,1.51-0.16,2.05c0.88-0.17,2.18-0.42,3.59-0.6c0.49-1.36,0.79-2.61,0.61-3.31c-0.56-2.16-0.9-2.7-0.45-6.17 c0.41-3.13-0.47-5.28-1.76-7.76c-0.48-1.35-1.8-2.45-4.84-3.11c-3.91-0.85-6.66-0.55-8.53,0.98c-2.41,1.59-3.13,2.72-3.45,5.35 c-0.42,3.43,1.3,5.34,0.73,7.38c-0.1,0.35-0.16,0.68-0.2,0.98l-0.04,0c-0.01,0.16-0.01,0.31,0,0.46 c-0.03,1.17,0.36,1.98,0.73,2.98c0.04,0.1,0.07,0.19,0.09,0.29c0.09,0.43,0.14,0.91,0.14,1.44 C1842.11,406.55,1842.11,406.76,1842.09,406.99z M1857.48,393.04l0.03-0.1C1857.5,392.99,1857.49,393.02,1857.48,393.04 L1857.48,393.04z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1848.47,388.25c-1.42,1.48-0.97,4.35-0.88,6.44c0.06,0.01,0.19,0.07,0.35,0.16 c0.4,0.21,0.97,0.54,0.97,0.54s1.16,0,2.3,0.05c1.06,0.05,2.34,1.44,2.48,2.07c0.4,1.86-0.92,3-1.65,5 c-0.5,1.37-0.41,3.7-1.63,5.91c-0.5,0.57-1.27,0.86-1.69,0.96c-1.29,0.31-2.21,0.02-2.21,0.02c0,0.12,0,0.23,0.01,0.34 c0.01,0.22,0.02,0.52,0.05,0.9c-0.07-0.72-0.06-1.11-0.06-1.25c0-0.04,0-0.06,0-0.06s-0.92-0.19-1.69-1.46 c-0.54-0.89-1.25-2.17-1.62-2.86c-0.16-0.29-0.26-0.48-0.26-0.48c0.55,1.14,0.89,2.16,0.72,4.28c-0.17,2.12,0.13,2.8,0.47,3.94 c0.34,1.14,0.51,3.82,0.51,3.82s0.1,0.13,0.22,0.31c0,0,0,0.01,0.01,0.01c0.1,0.17,0.21,0.39,0.24,0.61 c0.01-0.03,0.02-0.09,0.03-0.15c0.01-0.05,0.02-0.11,0.04-0.18l-0.07,0.39c0,0,2.64-0.77,3.79-2.7c-0.36-0.28-0.67-0.62-0.93-1 c0.18-0.52,0.89-2.47,2.04-3.67c1.01-1.05,2.76-2.41,3.57-3.02c0.63-0.39,1.24-0.82,1.68-1.27c0,0,0.25-0.3,0.46-0.63 c0,0,0.02-0.03,0.05-0.07c-0.02,0.03-0.03,0.05-0.05,0.08l0,0.05l0-0.05c-0.02,0.03-0.04,0.06-0.06,0.09 c-0.07,0.84-0.12,1.51-0.16,2.05c0.04-0.01-0.01,0.16,0.03,0.16l-0.11,1.47c0.4-0.13,4.29-2.22,7.07-2.42 c0.08-0.01,0.17-0.01,0.25-0.01c-0.94-0.05-2.12-0.01-3.63,0.17c0.48-1.35,0.78-2.57,0.6-3.26c-0.56-2.16-0.9-2.7-0.45-6.17 c0.27-2.08-0.03-3.72-0.63-5.32c-0.26-1.16-0.72-2.26-1.47-3.16c-0.03-0.03-0.05-0.06-0.08-0.1 C1855.61,387.14,1850.08,386.57,1848.47,388.25z M1858.54,399.2c0.03,0.36-0.06,0.78-0.18,1.13c-0.1,0.3-0.27,0.7-0.5,1.09 C1858.22,400.67,1858.59,399.85,1858.54,399.2z M1858.52,399.09c0-0.01,0-0.02,0-0.03 C1858.52,399.08,1858.52,399.09,1858.52,399.09z M1845.84,416.19C1845.85,416.19,1845.85,416.19,1845.84,416.19 C1845.85,416.19,1845.85,416.19,1845.84,416.19z M1847.19,412.39c0.03,0.07,0.06,0.15,0.09,0.22 C1847.24,412.53,1847.21,412.46,1847.19,412.39z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1868.65,373.41l0.94-4.61c0,0,2.81-3.48,4.35-4.19c1.54-0.71,4.67-2.15,6.5-1.92 c1.84,0.23,5.05,0.12,7.6,1.86c2.56,1.74,3.32,1.69,3.86,3.81c0.54,2.12,0.71,2.56,0.6,3.97c-0.11,1.41-2.14,12.73-2.14,12.73 s-8.19,1.52-8.36,1.52c-0.08,0-2.3-1.39-3.75-3.54c-1.35-1.99-1.95-4.75-1.95-4.75l-1.02-2.32l-3.18,0.82L1868.65,373.41"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1908.76,592.26c0,0,1.52,2-2.62,4.76s-4.95,2.28-6.65,3.73c-1.7,1.45-14.09,3.75-34.73,6.5 c-21.3,2.84-25.25,1.47-35.45-3.11c-10.29-4.62-0.78-2.86,38.38-8.94"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1902.9,462.7l-0.01,0.05c1.25,0.01,2.52,0.08,3.77,0.26C1906.65,463.01,1905.45,462.67,1902.9,462.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1878.59,394.84c0.04-0.11,0.09-0.21,0.15-0.31c-0.06,0.03-0.11,0.05-0.17,0.08 C1878.58,394.68,1878.59,394.76,1878.59,394.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1907.55,425.12c-0.83,3.16-1.36,15.62-2.02,19.92c-0.18,1.18-0.35,1.66-0.14,2.02 c0.21,0.36,0.77,0.58,0.48,2.07c-0.2,1.02-0.33,1.76-0.14,2.34c1.6-2.62,5.23-11.73,5.22-13.65c-0.02-3.19,0.11-8.28,0.24-13.24 C1910.89,424.77,1909.76,425.37,1907.55,425.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1902.89,462.75c0,0-0.76-0.03-1.18-0.01C1901.7,462.75,1902.49,462.75,1902.89,462.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1866.63,430.85c-2.46-1.09-6.21-2.67-7.3-5.29c-0.82,2.61-2.18,6.95-3.44,12.07 c0,0-5.04,5.59-10.28,10.09c-5.14,4.41-9.19,7.12-10.63,8.03c-0.47,0.14-0.89,0.25-1.29,0.34c-1.5,0.28-3.2,0.61-3.6,0.79 c-0.75,0.33-2.25,2.2-2.58,2.76c0,0,0.15,0.14,0.45,0.62c-0.03,0.1-0.07,0.19-0.11,0.27c-0.33,0.67-0.79,4.87-0.43,6.36 c0.2,0.81,0.05,0.23,0.7,1.54c0.65,1.31,1.47-0.14,1.76-0.26c0,0,0.61,0.71,1.07,1.02c0.45,0.3,1.79,0.15,1.79,0.15 s0.96,0.58,1.52,0.3c0.55-0.28,1.22-0.79,1.22-0.79s0.26,0.17,1.16-0.08c0.66-0.18,1.18-1.38,1.24-1.52l-0.7-0.42 c-1.08,0-0.98-1.23-0.98-2.94s0.38-2.28,1.47-2.28l0.82-0.54c0.24,0,0.47,0.07,0.68,0.2c0.39-0.35,0.94-0.71,1.7-1.02 c3.14-1.27,10.06-5.32,14-7.73c0.36-0.22,0.69-0.29,1.01-0.5c7.87-5.19,9.93-9.11,12.1-13.3c1.61-3.12,2.9-6.01,3.9-8.47 C1870.41,431.78,1869.18,431.75,1866.63,430.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1899.12,585.61c0.66,1.07,2.54,3.79,4.34,3.34c2.24-0.56,4.57-1.81,4.57-1.81s0,0.31,0.07,0.78 c-0.12-1.28-0.02-2.48,0.04-3.03c-1.16,0.68-2.81,1.44-4.84,1.83C1901.58,587.04,1900.18,586.44,1899.12,585.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1898.75,585.3c0,0.22,0,0.44,0,0.65l0.08-0.57C1898.81,585.35,1898.78,585.33,1898.75,585.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1903.45,588.95c-1.8,0.45-3.68-2.27-4.34-3.34c-0.1-0.07-0.19-0.15-0.28-0.23l-0.08,0.57 c0.02,3.56,0.03,5.86,0.03,5.86c-0.31,0.11-0.61,0.21-0.92,0.31c0.01,0.06,0.01,0.12,0.02,0.17c0.3,0.14,2.37,1.06,4.17,1.72 c1.71,0.37,3.24,0.6,4.02,0.45c1.57-0.29,2.36-1.06,2.71-1.55c0.1-0.31,0.16-0.63,0.17-0.95c0.05-1.12-0.38-2.21-0.57-2.78 c-0.15-0.46-0.24-0.9-0.29-1.25c-0.07-0.47-0.07-0.78-0.07-0.78S1905.69,588.39,1903.45,588.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1906.07,596.4c1.43-0.12,2.14-0.74,2.47-1.42C1908.12,595.69,1907.38,596.29,1906.07,596.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1906.07,594.45c-0.78,0.15-2.31-0.08-4.02-0.45c-1.8-0.65-3.87-1.58-4.17-1.72 c-0.01-0.05-0.01-0.11-0.02-0.17c-4.93,1.52-9.2,0.66-12.41-0.75c0.36,1.13,1.2,2.68,3.19,3.25c2.3,0.67,4.44,0.53,6.08,0.13 c2.9-0.71,3.29-1.2,3.29-1.2l0.12,0.64c2.12,0.81,5.45,2.43,7.92,2.22c1.31-0.11,2.06-0.72,2.47-1.42 c0.68-1.14,0.5-2.53,0.5-2.53s-0.03,0.07-0.08,0.17c0.01-0.22,0.01-0.44-0.01-0.68c-0.01,0.32-0.06,0.64-0.17,0.95 C1908.42,593.39,1907.64,594.16,1906.07,594.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1894.08,600.44c-3.29-0.13-7.56-0.35-18.25-1.69c-10.69-1.33-11.51-4.67-11.51-4.67 c-0.1-0.34-0.15-0.65-0.17-0.93c-0.05-0.01-0.08-0.01-0.08-0.01s-0.54,2.26,1.6,3.99c3.29,2.67,8.02,2.68,13.28,3.62 s14.3,1.42,17.26,1.02c2.96-0.4,3.45-1.07,3.29-3.07C1899.17,600.04,1897.36,600.58,1894.08,600.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1898.02,593.55c0,0-0.38,0.49-3.29,1.2c-1.64,0.4-3.78,0.53-6.08-0.13c-1.99-0.58-2.84-2.13-3.19-3.25 c-1.28-0.56-2.4-1.21-3.31-1.84c-0.43,0.15-0.95,0.36-1.55,0.67c0,0-1.5,0.53-7.07,0.69c-3.81,0.11-9.53-1-9.37,2.28 c0.01,0.28,0.06,0.58,0.17,0.93c0,0,0.82,3.34,11.51,4.67c10.69,1.33,14.96,1.56,18.25,1.69c3.29,0.13,5.1-0.4,5.43-1.74 c0.33-1.33-0.99-2.62-0.99-2.62l-0.37-1.9L1898.02,593.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1902.91,463.15c1.26-0.01,2.2,0.06,2.82,0.14c0.57,0.07,1.11-0.31,1.24-0.87 c0.21-0.93,0.37-2.33-0.1-3.52c-0.79-1.98-0.79-3.37-0.2-4.56c0.39-0.78-0.33-1.31-0.7-2.41c-0.2-0.58-0.3-1.32-0.09-2.34 c0.59-2.97-0.76-1.74-0.34-4.09c0.69-3.88,1.2-14.62,1.84-18.89c0.08-0.56,0.57-0.97,1.14-0.97c1.59,0.01,2.43-0.44,2.68-0.6 c0.05-0.03,0.08-0.06,0.08-0.06s0.33-6.67,0.15-11.24c0-0.08,0-0.15,0.01-0.22c0.05-0.32,0.08-0.6,0.08-0.83 c0-2.38-3.96-15.47-7.47-16.4c-5.97-1.58-5.86-2.26-7.71-2.87c-0.61-0.2-1.22-0.41-1.83-0.61c-0.16-0.05-0.3-0.14-0.43-0.25 c-0.32-0.3-0.52-0.6-0.55-0.9c-0.07-0.9-1.44-1.85-2.74-1.82c-1.03,0.02-2.16-0.12-3.64,0.49c-3.15,1.3-7.27,1.61-8.57,3.92 c-0.06,0.1-0.15,0.88-0.19,0.99c-0.02,0.06-0.07,0.18-0.1,0.24c-0.21,0.62-0.15,0.73-0.28,1.22c-0.03,0.13-0.06,0.39-0.09,0.63 c-0.03,0.28-0.17,0.54-0.38,0.73c-0.21,0.19-0.43,0.38-0.64,0.56c-0.09,0.08-0.18,0.14-0.29,0.18 c-4.81,2.11-11.29,4.95-12.7,9.91c-2.31,8.09-3.67,10.74-4.91,14.51c-0.4,1.22-0.31,2.31,0.09,3.28 c1.08,2.6,4.45,4.32,6.91,5.42c0.04,0.02,0.07,0.03,0.11,0.04c2.52,0.86,4.3,0.27,5.77-1.22c0.13-0.14,0.27-0.28,0.39-0.43 c-0.41,3.32-1.9,15.72-1.9,19.83c0,4.37,0.13,10.68,0.18,16.53c0.01,0.77,0.76,1.3,1.49,1.06c11.62-3.74,29.65-4.65,29.65-4.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1901.7,462.74c0,0-19.63,0.86-31.13,5.02c0,0-0.01,0.09-0.02,0.26l0.02-0.26c0,0-0.93,0.63-0.82,6.07 s0,7.41,0,7.41l0.06,0.05c-0.21,3.86-0.43,8.14-0.63,12.23c-0.59,12.09,4.16,38.26,5.35,46.39c1.19,8.13,5.58,32.18,4.79,38.92 s-0.17,8.21-0.17,8.21s1.07,1.17,2.98,2.47c0.92,0.62,2.03,1.27,3.31,1.84c3.21,1.41,7.48,2.27,12.41,0.75 c0.3-0.09,0.61-0.19,0.92-0.31c0,0,0-2.3-0.03-5.86c0-0.21,0-0.43,0-0.65c0.03,0.03,0.06,0.05,0.09,0.08 c0.09,0.08,0.18,0.15,0.28,0.23c1.06,0.83,2.47,1.43,4.17,1.11c2.03-0.39,3.68-1.15,4.84-1.83c1.22-0.72,1.9-1.34,1.9-1.34 c-0.99-9.32-8.13-58.69-8.13-58.69s0.79-20.22,3.17-34.89c2.38-14.67,1.59-26.96,1.59-26.96c-1.25-0.17-2.52-0.25-3.77-0.26 C1902.49,462.75,1901.7,462.74,1901.7,462.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1875.15,379.09c0.27,1.49-0.38,3.49-0.38,3.49C1875.65,381.72,1875.15,379.09,1875.15,379.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1890.37,385.06c-3.05-1.78-7.88,0.65-7.88,0.65s-5.35-2.2-5.47-6.44c-0.11-4.21-2.93-4.52-3.88-3.09 c-0.79,1.19-0.45-0.48-1.13-0.92c-1.59-1.03-2.94-1.87-3.35-1.86c-0.17,1.66-0.04,3.37,0.44,5.05c0.1,0.33,0.12,0.66,0.13,0.98 c-0.01,0.4-0.02,0.96,0.02,1.22c0.04,0.31,0.13,0.6,0.33,0.87c0.65,0.82-0.21,2.24,0.75,4.49c0.51,1.2,0.74,2.33,0.88,3.2 c0.03-0.36,7.41,5.82,7.37,5.39c0.06-0.03,0.11-0.05,0.17-0.08c1.3-2.3,5.6-2.4,8.76-3.7c1.48-0.61,2.8-0.92,3.83-0.94 C1890.54,388.31,1890.3,386.68,1890.37,385.06z M1875.15,379.09c0,0,0.5,2.63-0.38,3.49 C1874.77,382.58,1875.41,380.58,1875.15,379.09z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1874.77,382.58c0.88-0.86,0.38-3.49,0.38-3.49C1875.41,380.58,1874.77,382.58,1874.77,382.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1836.72,464.19c0-1.71,0.88-3.09,1.96-3.09h-1.36c-1.08,0-1.96,1.38-1.96,3.09s0.88,3.09,1.96,3.09 h0.75h0.61C1837.6,467.28,1836.72,465.9,1836.72,464.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1838.5,461.1c-1.08,0-1.96,1.38-1.96,3.09s0.88,3.09,1.96,3.09s1.96-1.38,1.96-3.09 c0-1.33-0.53-2.46-1.28-2.89C1838.97,461.17,1838.74,461.1,1838.5,461.1z M1838.58,467.14c-1.43,0.49-1.19-3.1-1.19-3.1 l1.86,0.94C1839.24,464.98,1839.46,466.84,1838.58,467.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1837.38,464.04c0,0-0.24,3.59,1.19,3.1c0.89-0.3,0.67-2.16,0.67-2.16L1837.38,464.04z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1829.16,458.52c-0.63,0.13-1.44,1.33-1.47,1.36c0,0,0,0,0,0c0.11,0.17,0.11,0.17,0.27,0.39c0,0,0,0,0,0 C1827.96,460.28,1828.35,459.29,1829.16,458.52z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1903.45,588.95c-1.8,0.45-3.68-2.27-4.34-3.34c-0.1-0.07-0.19-0.15-0.28-0.23l-0.08,0.57 c0.02,3.56,0.03,5.86,0.03,5.86c-0.31,0.11-0.61,0.21-0.92,0.31c0.01,0.06,0.01,0.12,0.02,0.17c0.3,0.14,2.37,1.06,4.17,1.72 c1.71,0.37,3.24,0.6,4.02,0.45c1.57-0.29,2.36-1.06,2.71-1.55c0.1-0.31,0.16-0.63,0.17-0.95c0.05-1.12-0.38-2.21-0.57-2.78 c-0.15-0.46-0.24-0.9-0.29-1.25c-0.07-0.47-0.07-0.78-0.07-0.78S1905.69,588.39,1903.45,588.95z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1898.02,593.55c0,0-3.32,1.8-6.87,1.35c-2.31-0.3-4.03-2.04-4.95-3.22c-1.52-0.6-2.84-1.33-3.9-2.04 c-0.97,0.73-3.87,2.69-7.5,3.06c-4.38,0.44-10.37,0.09-10.64,0.08c-0.01,0-0.01,0-0.01,0s-0.07,0.21-0.11,0.56 c-0.11,1.1,0.13,3.55,4.03,5.2c0.54,0.23,1.08,0.43,1.63,0.6c3.99,1.3,8.12,1.38,11.66,2.05c4.02,0.76,11.57,1.01,13.54,0.78 c1.96-0.23,4.58,0,4.77-2.2s-0.3-2.76-0.98-3.79c-0.15-0.23-0.28-0.59-0.37-0.97C1898.12,594.3,1898.02,593.55,1898.02,593.55z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1875.11,437.59c4.93-4.99,10.01-10.98,7.1-9.46c-2.91,1.52-10.97,11.62-7.55,4.12s11.12-12.62,6.87-10.24 c-4.26,2.38-7.37,8.08-7.37,8.08s1.36-4.83,3.48-10.68c2.11-5.85,2.3-10.43-0.18-3.96c-1.58,4.11-2.92,6.96-3.69,8.49 c0.92-4.5,2.03-10.1,1.73-9.2c-0.49,1.48-1.97,5.85-1.85,3.94c0.12-1.91-0.62-9.47-0.62-7.63s-0.96,4.22-2.7,8.63 c-2.25,5.71-3.72,8.86-5.57,11.64c-0.45-0.21-1-0.53-1.46-0.78c-1.03,1.58-2.03,3.44-3.25,6.22 c-1.44,3.76-22.21,18.46-23.93,18.9c-1.72,0.44-1.68,0.88-5.63,2.58c-1.73,0.75-2.48,2.84-2.81,3.64c-0.12,0.29-0.2,0.62-0.27,1 c-0.12,0.7-0.15,1.59-0.15,2.54c0,0.94,0.01,1.7,0.73,2.82c0.23,0.36,0.27,0.69,0.75,0.77c0.33,0.05,1.12-0.82,1.12-0.82 c0.75,0.79,0.89,0.95,1.28,1.11c0.41,0.17,1.57,0.05,1.57,0.05s0.8,0.52,1.41,0.33c0.61-0.19,1.33-0.82,1.33-0.82 s0.68,0.25,1.46-0.24c0.49-0.3,0.95-1.37,0.95-1.37s-0.33,0.06-0.75,0.01c-0.72-0.08-1.62-0.96-1.75-2.59 c-0.2-2.64,1.26-3.56,1.71-3.57c0.58-0.02,1.19-0.02,1.44-0.02c0.07,0,0.14,0.01,0.21,0.04l0.42,0.16c0,0,0.59-0.49,1.08-0.74 c0.32-0.16,0.39-0.17,2.41-1.1c0.77-0.36,1.67-0.87,2.78-1.44c0.13-0.07,0.25-0.13,0.39-0.2c2.2-1.14,6.52-3.63,9.57-5.53 c0.2-0.12,0.39-0.24,0.57-0.36c0.66-0.41,1.2-0.77,1.65-1.09c0.68-0.47,1.18-0.85,1.59-1.19c0.52-0.43,0.9-0.77,1.39-1.12 c1.58-1.13,3.34-3.3,5.02-5.64c0.4-0.55,0.75-1.04,0.96-1.45c0.26-0.5,0.53-1.04,0.81-1.58c0.59-1.15,1.21-2.36,1.76-3.45 c0.39-0.79,0.75-1.52,1.03-2.14c0.28-0.62,0.61-1.38,0.93-2.14c0.24-0.58,0.25-0.57,0.45-1.07c0.01-0.01,0.42-0.4,0.42-0.41 c0.11-0.12,0.21-0.25,0.3-0.37c-0.29,2.56-0.78,5.39-1.06,8.68c-0.27,3.12-0.65,6.3-0.8,9.72c-0.07,1.59,0.01,3.36-0.02,4.96 c-0.07,3-0.06,5.99,0.06,8.86c0.03,0.66,0.05,1.25,0.08,1.75C1871.12,477.11,1870.37,442.39,1875.11,437.59z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1877.29,450.85C1876.15,451.65,1876,451.97,1877.29,450.85L1877.29,450.85z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1900.4,453.61c-5.55-1.19-15.46-3.17-21.61,1.78c0,0,13.68-3.57,20.22-0.2c6.16,3.17,7.16,2.11,7.27,1.95 c0.01-0.01,0,0,0,0s0.05-0.19,0.03-0.27c-0.04-0.14-0.04-0.41-0.06-0.74c-0.03-0.54,0.08-1.11,0.5-2.03 c0.05-0.11,0.04-0.65-0.12-0.78C1906.38,453.13,1904.68,454.53,1900.4,453.61z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1902.95,462.75l-0.06,0l-1.16,0c0,0-11.36,0.39-21.9,2.57c-3.16,0.65-6.57,1.41-9.24,2.45 c0,0,13.7,0.67,18.58,2.2c6.56,2.05,8.18,11.91,8.55,18.88c-0.13,0.74-0.27,1.55-0.42,2.47c-0.71,4.4-1.76,17.9-2.89,21.41 c-0.81,2.51-1.19,4.59-1.3,6.27c-0.38,1.51-1.82,7.07-3.26,11.52c-1.68,5.2,1.68-1.68,3.19-3.19c1.51-1.51,1.34,3.86,1.85,8.22 c0.5,4.36,2.52,6.55,2.52,6.55s-0.01-0.3-0.02-0.81c0,0,0,0.01,0,0.01c0.88,6.37,0.79,25.2,1.05,29.92 c0.26,4.72,0.48,14.11,0.48,14.11s0.13,0.25,0.43,0.56c0.83,0.85,2.81,1.75,7.39-0.11c1.03-0.42,2.07-1.33,3.31-2.22 c0,0-1.07-8.29-2.47-18.82c-2.04-15.35-4.73-35.16-5.64-39.74c-0.07-0.34,0.03-2.2,0.24-4.88c0.55-7.09,1.19-20.05,2.33-26.11 c1.7-9.1,2.81-24.36,2.16-31l-2.56-0.23l-0.45-0.02L1902.95,462.75z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1873.36,478.44c-2.65-6.5-2.8-9.71-2.78-10.61c0-0.02,0-0.05,0-0.07c0,0.02,0,0.05-0.01,0.07 C1869.9,477.82,1876.51,486.19,1873.36,478.44z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1911.55,412.69c0.01-0.24-0.01-0.25-0.01-0.25c0,0,0.02-0.24,0-0.19c-0.04-0.58-0.15-0.81-0.27-1.4 c-0.48-2.41-1.44-5.08-2.37-7.45c-0.61-1.55-1.11-2.57-1.26-2.84c-0.5-0.95-0.35,3.64-0.15,9.04 c0.55,14.99-12.74,18.99-8.34,34.29c0.19,0.66,0.15,1.14-0.05,1.49c-4.75-0.92-13.22-2.72-20.05,3.76 c-0.82,0.78-1.45,1.35-1.9,1.74c2.2-1.54,8.09-4.87,14.39-3.12c10.7,2.97,14.67,4.75,14.67,4.75s-0.11-0.11-0.22-0.58 c-0.03-0.11-0.16-0.45-0.18-0.61c0.07-0.14,0.3-0.47,0.71-1.38c0.28-0.62,0.71-1.49,1.07-2.31c1.4-3.26,3.31-8.12,3.34-9.81 c0.04-2.77,0.09-7.47,0.23-12.77c0-0.03,0.1-0.08,0.1-0.08c0.01-0.08,0.03-0.52,0.03-0.59c0.08-3.85,0.27-7.31,0.19-9.63 c-0.01-0.17-0.04-0.96-0.04-1.12C1911.52,413.15,1911.56,413.19,1911.55,412.69z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.3,
    points: "1911.51,412.24 1911.51,412.23 1911.51,412.23  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1874.7,379.29c-0.16-0.39-0.32-0.58-0.74-1.02s-0.33-1.12-0.05-1.3c0.4-0.26,1.06,0.87,1.06,0.87 c-0.23-0.53-0.53-1.32-1.03-1.35s-0.62,0.49-0.67,0.82c-0.05,0.33,0.05,1.66,0.45,2.03c0.41,0.38,0.59-0.23,0.75,0.12 c0.16,0.36,0.27,0.66,0.27,0.66S1874.87,379.68,1874.7,379.29z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1873.56,379.69C1873.56,379.69,1873.38,379.4,1873.56,379.69c0.17,0.29,0.43,0.79,0.36,1.44 c-0.07,0.65,0.2,0.93,0.31,0.52c0.11-0.4,0.28-1.39,0.09-1.59S1873.88,380.11,1873.56,379.69z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1869.42,380.88c0.46,0.24,0.81,0.54,0.66-0.1c-0.13-0.54-0.68-1.16-0.86-1.34 c-0.03-0.04-0.06-0.06-0.06-0.06c-0.16,0.42-0.07,0.97,0.08,1.28C1869.29,380.77,1869.36,380.85,1869.42,380.88z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1878.59,394.84c0-0.08-0.01-0.16-0.02-0.24c-0.04-0.25-0.12-0.48-0.24-0.66 c-1.32-1.98-2.58-6.5-3.58-8.16c-1-1.66-1.76-5.03-1.64-5.91s-0.78-2.5,0.02-3.7c0.96-1.43,3.77-1.13,3.88,3.09 c0.11,4.24,5.47,6.44,5.47,6.44s4.84-2.43,7.88-0.65c0,0,0,0,0,0c0,0,2.58-9.97,3.35-12.35c0.78-2.38,0.48-7.2,0.48-7.2 s-0.36,1.58-0.68,2.38s-0.64-4.3-0.64-4.3s-0.04,0.68-0.73,1.7c-0.69,1.02-0.5-0.15-4.35-2.36c-2.54-1.45-5.28-2.3-7.77-2.5 c-1.29-0.1-2.52-0.03-3.63,0.22c0,0,2.58,0.17,3.96,0.44c-0.44-0.08-4.8-0.67-10.49,5.01c0,0-2.09,2.88-3.25,6.45 c0,0,1.02-1.73,1.84-2.37c0,0-0.92,2.98-0.92,5.39c0,0,0.56-1.5,0.99-2.11c0.04-0.05,0.07-0.07,0.11-0.07 c0.41-0.01,0.92,2.8,2.51,3.83c1.73,1.12-0.49,4.68-0.58,6.04c-0.08,1.31,0.76,4.15,0.61,5.93c-0.01,0.07-0.01,0.14-0.02,0.21 c-0.25,1.76,0.57,2.28,1.19,3.97c0.62,1.69,0.58,5.49,3.38,4.76c1.1-0.29,1.83-0.84,2.27-1.47c0.13-0.49,0.3-1.04,0.5-1.66 C1878.55,394.96,1878.57,394.9,1878.59,394.84z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1874.71,364.64c0,0,3.44-0.28,6.59,0.16c0.03,0,0.05,0.01,0.08,0.01c-1.57-0.03-5.28,0.25-8.78,2.68 c0,0,4.52,2.41,4.46,5.96s7.25,9.46,8.34,11.1c0.03,0.05,0.06,0.09,0.09,0.14c1.01,1.58,1.28,2.87,1.28,2.87s0.18,1.68-0.98,3.85 c-0.84,1.57-2.37,3.39-5.18,5.02c-0.89,0.52,6.47-2.86,13.68-2.83c2.95,0.01,5.13,1.19,5.13,1.19c-1.22-0.49-2-1.11-3.51-1.52 c-1.95-0.54-2.09-0.9-2.47-1.9c0,0-0.19-1.03-1.82-1.48c-0.15-0.04-0.27-0.07-0.35-0.15c-0.04-0.04-0.07-0.08-0.09-0.15 c-0.01-0.05-0.03-0.1-0.04-0.15c-0.23-0.78-0.56-1.84-0.75-3.23c-0.05-0.36,0.02-0.75,0-1.16c0,0,0.06-0.04,0.07-0.14 c0.05-0.54,0.5-1.86,0.93-3.53c0.13-0.5,0.31-1.34,0.53-2.15c0.69-2.57,1.61-5.64,2.05-7.44c0.53-2.18,0.26-6.28,0.26-6.28 l-0.66,2.22c-0.07,0.33-0.2,0.24-0.22,0.07l-0.44-4.21c0,0,0.04,0.08,0.01,0.21c-0.09,0.36-0.21,0.86-0.75,1.5 c-0.26,0.31-0.2,0.79-1.13-0.09c-0.86-0.81-2.54-1.48-3.35-1.77c-0.26-0.09-0.51-0.21-0.76-0.34 C1885.86,362.56,1882.08,361.23,1874.71,364.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 1835.3361,
    y1: 464.2019,
    x2: 1838.6543,
    y2: 464.2019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M1836.69,464.2c0-1.71,0.88-3.09,1.96-3.09h-1.36c-1.08,0-1.96,1.38-1.96,3.09 c0,1.71,0.88,3.09,1.96,3.09h0.75h0.61C1837.57,467.29,1836.69,465.91,1836.69,464.2z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1770.74,614.15c0.01,0.04,0.05,0.12,0.14,0.22c-0.04-0.16-0.06-0.33-0.06-0.49 C1770.74,614.02,1770.73,614.11,1770.74,614.15z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1856.58,637.2c0.33-0.82-0.14-1.83-1.39-3.03c-6.68-6.39-22.22-8.64-38.9-10.55 c-4.98-0.57-10.3-1.05-15.43-1.52c-3.57-0.32-6.81-0.63-9.74-0.93c9.93,1.29,31.63,4.24,44.32,7.01 c8.92,1.95,21.71,6.87,19.81,10.5C1856.09,638.07,1856.44,637.56,1856.58,637.2z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1804.13,602.62c-12.37,2.43-26.4,5.17-32.46,10.29c-0.51,0.43-0.76,0.76-0.86,0.97 c0,0.17,0.02,0.33,0.06,0.49c0.39,0.45,1.82,1.41,7.01,2.41c-2.36-3.26,3.77-7.35,15.67-10.45 c14.33-3.74,40.02-8.98,47.16-10.23c9.56-1.68,3.63-3.27-2.22-2.12c-2.71,0.53-6.01,1.03-9.93,1.8 c-2.92,1.41-6.24,2.65-10.04,3.7C1814.53,600.59,1809.48,601.58,1804.13,602.62z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1733.23,671.26c-0.05,0.12-4.51-2.13-4.84-2.4c-0.32-0.27-0.7-0.54-1.1-0.8 c-0.8-0.52-1.69-0.99-2.61-1.43c-1.84-0.88-3.8-1.64-5.78-2.33c-3.97-1.37-8.09-2.49-12.2-3.3c-3.23-0.61-6.46-1.28-9.69-2.08 c8.32,3.1,23.93,9.26,27.01,13.06c0.26-0.06,1.92,3.91,1.39,4.05c-1.1,0.29-2.2,0.53-3.29,0.74c-4.37,0.83-8.72,1.3-13.06,1.67 c-4.34,0.36-8.68,0.61-13.01,0.79c-8.66,0.36-17.33,0.45-25.96,0.47l-25.88,0.1l-25.88,0.1l-3.24,0.01l-1.62,0.01 c-0.56,0-1.12,0-1.69-0.02c-2.26-0.06-4.59-0.23-6.98-0.81c-1.19-0.3-2.39-0.7-3.55-1.25c-1.13-0.54-2.22-1.23-3.2-2.06 c-10.54,1.31-15.53,5.04-4.02,6.72c15.91,2.31,90.08,3.28,127.21-0.69c10.99-1.17,14.19-3.82,14.47-6.62 C1735.94,673.14,1734.73,671.77,1733.23,671.26z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1729.29,669.89C1729.29,669.9,1729.29,669.9,1729.29,669.89L1729.29,669.89z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1685.04,650.47C1685.04,650.48,1685.04,650.48,1685.04,650.47L1685.04,650.47z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1859.24,637.86c0,0-0.05,0.03-0.15,0.1c-0.03,0.08-0.05,0.15-0.08,0.22c-0.83,2.07-3.36,3.76-7.74,5.17 c-3.4,1.1-7.96,2.03-13.53,2.78c-3.17,0.43-6.4,0.76-9.51,1.01c-1.36,0.12-2.73,0.23-4.09,0.32c-4.33,0.29-8.65,0.49-13.02,0.53 l-12.94,0.05l-51.76,0.2l-51.77,0.2c-2.06,0-4.11,0.18-6.05,0.58c-0.96,0.21-1.9,0.48-2.66,0.84c-0.29,0.13-0.54,0.29-0.71,0.42 c0.05,0.05,0.1,0.1,0.16,0.16c0.15,0.14,0.35,0.29,0.56,0.44c1.57-0.24,4.08-0.52,8.06-0.81c6.92-0.51,64.91,0.83,77.47,0.83 s49.85,2.49,79.5-3.8C1869.22,643.24,1859.24,637.86,1859.24,637.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1685.22,650.3c0.16-0.13,0.42-0.29,0.71-0.42c0.76-0.36,1.7-0.63,2.66-0.84 c1.94-0.41,3.99-0.58,6.05-0.58l51.77-0.2l51.76-0.2l12.94-0.05c4.36-0.03,8.69-0.23,13.02-0.53c1.36-0.09,2.73-0.2,4.09-0.32 c3.11-0.26,6.35-0.59,9.51-1.01c5.57-0.75,10.12-1.69,13.53-2.78c4.38-1.41,6.92-3.1,7.74-5.17c0.03-0.07,0.06-0.15,0.08-0.22 c0.44-1.32,0.38-3.31-2.09-5.67c-7.27-6.95-23.27-9.29-40.41-11.26c-5.01-0.58-10.34-1.06-15.49-1.53 c-7.95-0.72-15.45-1.4-21.16-2.34c-0.74-0.12-1.42-0.24-2.04-0.36c-5.19-1.01-6.62-1.96-7.01-2.41 c-0.09-0.1-0.13-0.18-0.14-0.22c-0.01-0.04,0-0.13,0.08-0.27c0.11-0.21,0.35-0.53,0.86-0.97c6.06-5.11,20.08-7.86,32.46-10.29 c5.35-1.05,10.4-2.04,14.39-3.14c3.79-1.05,7.12-2.29,10.04-3.7c21.38-10.31,20.83-29.46,20.33-46.61 c-0.07-2.56-0.15-5.21-0.15-7.74c0-2.83-0.41-23.24-0.78-41.25c-0.28-13.83-0.52-25.78-0.52-27.04c0-3.86-1.03-6.72-3.08-8.5 c-2.57-2.23-5.73-1.82-5.87-1.8c-0.71,0.1-1.21,0.75-1.11,1.47c0.09,0.71,0.75,1.21,1.46,1.13c0.02,0,2.17-0.25,3.82,1.21 c1.43,1.26,2.15,3.45,2.15,6.5c0,1.28,0.24,13.24,0.52,27.09c0.36,18,0.78,38.4,0.78,41.2c0,2.57,0.08,5.24,0.15,7.82 c0.28,9.68,0.57,19.69-2.93,28.17c-3.91,9.48-12.26,15.88-25.53,19.55c-3.9,1.08-8.9,2.06-14.2,3.1 c-12.69,2.49-27.07,5.3-33.64,10.86c-1.58,1.33-2.17,2.69-1.75,4.02c1.03,3.27,7.95,4.7,22.88,6.23 c2.93,0.3,6.17,0.61,9.74,0.93c5.14,0.47,10.45,0.95,15.43,1.52c16.69,1.91,32.22,4.16,38.9,10.55 c1.25,1.19,1.71,2.21,1.39,3.03c-0.14,0.35-0.49,0.87-1.33,1.47c-1.98,1.43-6.7,3.36-17.86,4.86c-2.47,0.33-4.98,0.61-7.44,0.83 c-1.99,0.17-3.99,0.32-5.99,0.45c-4.28,0.26-8.58,0.42-12.85,0.42l-12.94-0.05l-51.76-0.2l-51.77-0.2 c-2.25-0.01-4.53,0.15-6.81,0.61c-1.15,0.24-2.3,0.54-3.5,1.09c-0.6,0.29-1.22,0.62-1.87,1.23c-0.32,0.31-0.65,0.71-0.89,1.27 c-0.24,0.55-0.33,1.27-0.2,1.87c0.12,0.61,0.37,1.09,0.62,1.46c0.26,0.38,0.53,0.66,0.8,0.92c0.54,0.5,1.08,0.87,1.61,1.2 c1.06,0.65,2.12,1.13,3.17,1.56c2.11,0.86,4.23,1.52,6.35,2.11c1.03,0.29,2.06,0.55,3.09,0.81c3.22,0.8,6.46,1.47,9.69,2.08 c4.11,0.81,8.23,1.93,12.2,3.3c1.98,0.69,3.94,1.45,5.78,2.33c0.92,0.44,1.81,0.91,2.61,1.43c0.4,0.26,0.78,0.53,1.1,0.8 c0.33,0.27,0.6,0.55,0.76,0.77c0.05,0.07,0.08,0.13,0.1,0.17c-0.02,0.02-0.04,0.04-0.06,0.07c-0.15,0.16-0.45,0.38-0.81,0.58 c-0.36,0.2-0.77,0.39-1.21,0.56c-0.98,0.38-2.05,0.69-3.15,0.96c-0.88,0.22-1.79,0.4-2.7,0.57c-4.11,0.75-8.36,1.18-12.61,1.51 c-4.26,0.32-8.54,0.53-12.83,0.67c-8.58,0.29-17.17,0.31-25.79,0.26l-25.88-0.1l-25.88-0.1l-3.24-0.01l-1.62-0.01 c-0.52,0-1.04-0.01-1.55-0.03c-2.04-0.06-4.04-0.25-5.85-0.71c-1.81-0.46-3.39-1.2-4.66-2.31c-1.27-1.1-2.27-2.59-3.03-4.31 c-0.76-1.72-1.31-3.64-1.72-5.63c-0.41-1.99-0.68-4.04-0.88-6.12c-0.4-4.16-0.5-8.4-0.49-12.66l0.1-25.88l0.2-51.77l0.1-25.88 l0.01-1.63c0-0.57-0.01-1.14-0.03-1.72c-0.04-1.15-0.11-2.33-0.27-3.53c-0.16-1.2-0.38-2.43-0.77-3.71 c-0.4-1.27-0.97-2.61-1.9-3.86c-0.92-1.26-2.24-2.35-3.61-3.01c-1.38-0.68-2.74-1.02-4.01-1.23c-1.27-0.21-2.46-0.29-3.62-0.34 c-1.15-0.05-2.26-0.06-3.36-0.06l-0.02,0c-1.81,0-3.27,1.47-3.26,3.28s1.47,3.27,3.28,3.26h0.01c2.12,0,4.21,0,5.94,0.26 c0.86,0.13,1.61,0.34,2.17,0.62c0.57,0.28,0.96,0.6,1.32,1.08c0.74,0.94,1.25,2.67,1.49,4.54c0.13,0.94,0.2,1.92,0.24,2.92 c0.02,0.5,0.03,1.01,0.03,1.52l0.01,1.61l0.1,25.88l0.2,51.77l0.1,25.89c0.03,4.37,0.17,8.76,0.62,13.19 c0.23,2.22,0.55,4.44,1.02,6.68c0.48,2.23,1.12,4.49,2.12,6.71c0.51,1.11,1.1,2.2,1.84,3.24c0.73,1.04,1.6,2.03,2.6,2.88 c0.03,0.02,0.06,0.04,0.08,0.07c0.97,0.83,2.07,1.52,3.19,2.06c1.16,0.56,2.36,0.96,3.55,1.25c2.38,0.58,4.71,0.76,6.98,0.81 c0.57,0.01,1.13,0.02,1.69,0.02l1.62-0.01l3.24-0.01l25.88-0.1l25.88-0.1c8.63-0.02,17.3-0.11,25.96-0.47 c4.33-0.18,8.67-0.42,13.01-0.79c4.34-0.38,8.69-0.84,13.06-1.67c1.09-0.21,2.19-0.45,3.29-0.74c1.1-0.29,2.21-0.62,3.34-1.08 c0.56-0.23,1.13-0.49,1.72-0.82c0.58-0.33,1.18-0.73,1.78-1.35c0.3-0.32,0.59-0.69,0.83-1.17c0.06-0.11,0.11-0.23,0.16-0.36 c0.15-0.4,0.25-0.85,0.26-1.3c0.02-0.59-0.11-1.15-0.29-1.61c-0.18-0.46-0.41-0.84-0.65-1.17c-0.48-0.65-0.99-1.12-1.49-1.54 c-0.51-0.42-1.01-0.76-1.52-1.09c-1.02-0.64-2.04-1.17-3.07-1.66c-2.06-0.97-4.14-1.75-6.23-2.46c-4.2-1.4-8.43-2.52-12.79-3.35 c-4.22-0.77-8.4-1.62-12.48-2.72c-2.03-0.55-4.05-1.17-5.94-1.92c-0.94-0.38-1.85-0.8-2.64-1.27c-0.15-0.09-0.3-0.18-0.43-0.28 c-0.21-0.15-0.41-0.3-0.56-0.44C1685.32,650.4,1685.27,650.35,1685.22,650.3z M1729.29,669.89 C1729.29,669.9,1729.29,669.9,1729.29,669.89L1729.29,669.89z M1685.04,650.47C1685.04,650.48,1685.04,650.48,1685.04,650.47 L1685.04,650.47z"
  }))), /*#__PURE__*/React.createElement("g", null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1555.22,385.85c2.7-0.71,21.88-6.37,21.88-6.37s-34.23-4.16-35.27-4.32c-1.04-0.16-3.28,0.13-3.04,1.81 c0.08,0.54,0.26,1.76,0.47,3.1l0.01,0l0.76,4.89c2.16,0.32,4.01,0.57,5.61,0.75C1549.36,386.08,1553.54,386.29,1555.22,385.85z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1502.43,383.17l3.38,3.36l4.68,4.65c0,0,3.83-1.22,5.98-1.86c2.15-0.64,3.44-0.97,3.44-2.55 c0-0.18-0.04-0.45-0.12-0.79L1502.43,383.17z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1516.43,375.82c-3.49,0.85-11,2.45-14.97,3.28c0,0,8.18,1.22,17.03,2.55 C1517.53,378.78,1516.43,375.82,1516.43,375.82z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1498.88,379.65L1498.88,379.65l0.01,0C1498.88,379.64,1498.88,379.65,1498.88,379.65z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1595.31,372.61c-4.62-0.74-64.72-9.91-72.6-10.22c-7.88-0.31-12.96,1.98-15.32,2.73 s-23.42,6.62-25.01,7.44c-2.37,1.22-3.25,3.86-3.43,4.97c0,0,0.01-0.01,0.01-0.01c0.02-0.23,0.26-0.45,0.68-0.67 c2.38-1.18,20.74-6.02,24.57-7.28s8.29-3.85,18.04-3.3c9.75,0.55,68.64,8.76,73.72,9.62c3.05,0.52,4.04,1.21,3.88,1.88 c0.01,0.01,0.01,0.01,0.02,0.02C1599.87,377.8,1600.64,373.46,1595.31,372.61z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1519.06,690.93l-2.38-0.23c-0.41-0.02-0.82-0.06-1.23-0.11l-13.42-1.29c-3.21-0.31-5.61-2.34-5.61-4.74 v-1.71c-28.54,3.98-57.31,7.99-58.8,8.16c-2.98,0.34-8.61,1.1-3.88,3.95c5.48,3.3,15.86,9.32,19.01,10.71 c3.15,1.4,5.14,1.6,8.26,1.06c20.21-3.48,97.14-16.3,112.09-19.2l-52.66,3.42C1519.99,690.98,1519.52,690.97,1519.06,690.93z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M1577.98,686.14c0.84-0.44,1.25-0.92,1.35-1.4C1579,685.26,1578.54,685.74,1577.98,686.14z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1595.97,375.9c-5.08-0.86-63.97-9.07-73.72-9.62c-9.75-0.55-14.2,2.04-18.04,3.3s-22.19,6.1-24.57,7.28 c-0.43,0.21-0.66,0.43-0.68,0.67c-0.11,1.03,3.9,2.3,13.51,3.95c2.54,2.64,15.39,18.8,19.01,23.36l4.82-0.48 c1.21-0.15,3.15-0.15,3.46-0.22l1.06,0.07c0.4,0,0.76,0.02,1.04,0.06l21.39,1.52l0.01,0.01l0.01,0.01l0-0.01l0-0.01l0.08,0.01 l-2.75-17.34c0,0,0.43,0.05,1.15,0.14c1.23,0.16,3.5,0.48,7.02,1.04c1.89,0.3,7.5,1.15,10.7,0.7c3.08-0.43,8.01-1.69,12.37-3.03 c4.35-1.34,24.26-7.31,26.44-8.26c0.87-0.38,1.49-0.82,1.6-1.27C1600.02,377.11,1599.02,376.42,1595.97,375.9z M1519.58,385.08 l-0.02,0l-17.89-2.66l-0.08-0.01l-2.71-2.76l0,0c0,0,0,0,0.01,0l2.57-0.54l0,0c3.97-0.84,11.48-2.43,14.97-3.28 c0,0,1.1,2.96,2.06,5.83c0.03,0.01,0.07,0.01,0.1,0.02L1519.58,385.08z M1516.47,389.32c-2.15,0.64-5.98,1.86-5.98,1.86 l-4.68-4.65l-3.38-3.36l17.35,2.8c0.08,0.34,0.12,0.62,0.12,0.79C1519.91,388.34,1518.62,388.68,1516.47,389.32z  M1580.62,381.53c-1.66,0.86-13.27,3.93-20.63,6.21s-9.54,1.57-13.27,1.1c-0.76-0.1-3.05-0.41-6.22-0.84l-0.47-3.04 c1.29,0.24,3.37,0.52,5.61,0.74c-1.6-0.18-3.45-0.42-5.61-0.75l-0.76-4.89l-0.01,0c-0.2-1.33-0.39-2.56-0.47-3.1 c-0.24-1.68,2-1.97,3.04-1.81c1.04,0.16,35.27,4.32,35.27,4.32C1580.2,380.03,1582.28,380.66,1580.62,381.53z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1520.82,404.2l-1.06-0.07c-0.31,0.07-2.25,0.07-3.46,0.22C1517.77,404.33,1519.54,404.2,1520.82,404.2z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1543.24,405.78l-21.39-1.52c-0.28-0.04-0.63-0.06-1.04-0.06l22.44,1.58L1543.24,405.78z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1543.26,405.79 1543.34,405.79 1543.34,405.79 1543.26,405.78  "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1543.26,405.79L1543.26,405.79L1543.26,405.79l-22.44-1.58c-1.27-0.01-3.04,0.13-4.52,0.14l-4.82,0.48 l-10.88,1.08l13.62-1.32c2.34-0.2,3.48-0.2,4.49,0.25c2.54,1.12,2.75,2.59,2.75,6.26c0,3.67-0.15,272.1-0.15,274.11 c0,4.9-2.23,5.6-4.65,5.48l2.38,0.23c0.46,0.04,0.92,0.05,1.38,0.02l52.66-3.42l0.97-0.06c1.52-0.1,2.88-0.59,3.9-1.33 c0.56-0.4,1.02-0.88,1.35-1.4c0.39-0.62,0.62-1.31,0.62-2.03v-270c0-2.29-2.19-4.26-5.22-4.69l-31.38-2.22L1543.26,405.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 1496.4297,
    y1: 547.5547,
    x2: 1579.9463,
    y2: 547.5547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1019,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2683,
    style: {
      stopColor: "#222221",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3384,
    style: {
      stopColor: "#161616",
      stopOpacity: 0.2038
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4571,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.1648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.1132
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M1543.26,405.79L1543.26,405.79L1543.26,405.79l-22.44-1.58c-1.43-0.14-2.98-0.03-4.52,0.14 l-4.82,0.48l-10.88,1.08l13.62-1.32c2.34-0.2,3.4-0.33,4.42,0.12c2.54,1.12,2.83,2.73,2.83,6.39c0,3.67-0.15,272.1-0.15,274.11 c0,4.9-2.23,5.6-4.65,5.48l2.38,0.23c0.46,0.04,0.92,0.05,1.38,0.02l52.66-3.42l0.97-0.06c1.52-0.1,2.88-0.59,3.9-1.33 c0.56-0.4,1.02-0.88,1.35-1.4c0.39-0.62,0.62-1.31,0.62-2.03v-270c0-2.29-2.19-4.26-5.22-4.69l-31.38-2.22L1543.26,405.79z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M1515.45,690.59c0.41,0.05,0.82,0.09,1.23,0.11l-14.65-1.4L1515.45,690.59z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1502.04,689.3l14.65,1.4c2.41,0.12,4.65-0.58,4.65-5.48c0-2.01,0.15-270.44,0.15-274.11 c0-3.67-0.21-5.14-2.75-6.26c-1.02-0.45-2.15-0.46-4.49-0.25l-13.62,1.32c-2.51,0.7-4.18,2.48-4.18,4.47v272.46v1.71 C1496.43,686.96,1498.83,688.99,1502.04,689.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 1496.4297,
    y1: 547.5911,
    x2: 1579.9463,
    y2: 547.5911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1019,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2683,
    style: {
      stopColor: "#222221",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2761,
    style: {
      stopColor: "#2C2C2B",
      stopOpacity: 0.2355
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3148,
    style: {
      stopColor: "#585857",
      stopOpacity: 0.2788
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3575,
    style: {
      stopColor: "#80807F",
      stopOpacity: 0.3266
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    style: {
      stopColor: "#A2A2A2",
      stopOpacity: 0.3778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4531,
    style: {
      stopColor: "#BFBFBF",
      stopOpacity: 0.4335
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#D7D7D7",
      stopOpacity: 0.4951
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5707,
    style: {
      stopColor: "#E9E9E9",
      stopOpacity: 0.565
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#F6F6F5",
      stopOpacity: 0.6484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7436,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.7585
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9595,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M1502.04,689.3l14.65,1.4c2.41,0.12,4.65-0.58,4.65-5.48c0-2.01,0.15-270.44,0.15-274.11 c0-3.67-0.21-5.14-2.75-6.26c-1.02-0.45-2.15-0.46-4.49-0.25l-13.62,1.32c-2.51,0.7-4.18,2.48-4.18,4.47v272.46v1.71 C1496.43,686.96,1498.83,688.99,1502.04,689.3z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1502.04,689.3l14.65,1.4c2.41,0.12,4.65-0.58,4.65-5.48c0-2.01,0.15-270.44,0.15-274.11 c0-3.67-0.09-5.27-2.64-6.39c-1.02-0.45-2.27-0.32-4.61-0.12l-13.62,1.32c-2.51,0.7-4.18,2.48-4.18,4.47v272.46v1.71 C1496.43,686.96,1498.83,688.99,1502.04,689.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.8805,
    y1: 382.8131,
    x2: 1581.2057,
    y2: 382.8131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M1557.05,385.4c1.76-0.39,20.05-5.92,20.05-5.92s-19.18,5.66-21.88,6.37 c-1.68,0.44-5.85,0.23-9.59-0.15C1554.52,386.7,1555.55,385.73,1557.05,385.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.8805,
    y1: 382.0919,
    x2: 1581.2057,
    y2: 382.0919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M1501.46,379.1c-1.48,0.31-2.47,0.52-2.57,0.54l-0.01,0l2.79,2.77l17.89,2.66 c-0.27-0.96-0.65-2.19-1.07-3.43C1509.65,380.32,1501.47,379.1,1501.46,379.1z"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1501.59,382.4 1501.67,382.42 1498.88,379.65  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.8805,
    y1: 381.0309,
    x2: 1581.2057,
    y2: 381.0309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_61_)",
    points: "1501.59,382.4 1501.67,382.42 1498.88,379.65  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1577.09,379.48c0,0-18.29,5.52-20.05,5.92c-1.49,0.33-2.53,1.3-11.41,0.3 c-2.24-0.23-4.32-0.51-5.61-0.74l0.47,3.04c3.17,0.44,5.46,0.75,6.22,0.84c3.73,0.47,5.91,1.18,13.27-1.1s18.97-5.35,20.63-6.21 S1580.2,380.03,1577.09,379.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.8805,
    y1: 384.4049,
    x2: 1581.2057,
    y2: 384.4049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M1577.09,379.48c0,0-18.29,5.52-20.05,5.92c-1.49,0.33-2.53,1.3-11.41,0.3 c-2.24-0.23-4.32-0.51-5.61-0.74l0.47,3.04c3.17,0.44,5.46,0.75,6.22,0.84c3.73,0.47,5.91,1.18,13.27-1.1s18.97-5.35,20.63-6.21 S1580.2,380.03,1577.09,379.48z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1519.56,385.08l0.02,0l-0.99-3.42c-0.03-0.01-0.07-0.01-0.1-0.02 C1518.91,382.89,1519.3,384.12,1519.56,385.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.8805,
    y1: 383.3658,
    x2: 1581.2057,
    y2: 383.3658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M1519.56,385.08l0.02,0l-0.99-3.42c-0.03-0.01-0.07-0.01-0.1-0.02 C1518.91,382.89,1519.3,384.12,1519.56,385.08z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1501.46,379.1l-2.57,0.54C1499,379.62,1499.99,379.42,1501.46,379.1L1501.46,379.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.8805,
    y1: 379.3736,
    x2: 1581.2057,
    y2: 379.3736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M1501.46,379.1l-2.57,0.54C1499,379.62,1499.99,379.42,1501.46,379.1L1501.46,379.1z"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-left"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 332.9995 181.5151)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "112px",
    letterSpacing: -2
  }, "gesagt"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 439.4312 289.3579)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "Wir wollen die"), /*#__PURE__*/React.createElement("tspan", {
    x: 141.14,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "22px"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 145.12,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "27px"
  }, "CO2-EMISSIONEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "in der europ\xE4ischen Neufahrzeugflotte "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "zwischen 1995 und 2020 "), /*#__PURE__*/React.createElement("tspan", {
    x: 239.79,
    y: 64,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "27px"
  }, "HALBIEREN.")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-right"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1411.3076 175.5581)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "112px",
    letterSpacing: -2
  }, "getan"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.84695353.svg";
export { ForwardRef as ReactComponent };